/* Nobile Wood – Golvdesigner v4
   Professional plan-based floor designer:
   - multiple rooms (rectangle + free polygon, ortho-snap)
   - real measurements (scale via reference wall, live edge labels)
   - procedural stav rendering with sortering character
   - correct mitered fris (staves parallel to each wall) + löpband
   - material list per room + total, stavmått selector (real variants), add-to-cart, PDF export
*/
(function(){
  'use strict';

  var SORT_LABEL = { select:'Select', natur:'Natur', rustic:'Rustic' };
  var PATTERN_LABEL = { fiskben:'Fiskben', hollandsk:'Holländskt förband', rak:'Rak läggning (engelskt förband)' };

  var PALETTES = {
    select: { h:41, s:26, l:83, v:2,  dark:0,    knot:0    },
    natur:  { h:35, s:38, l:73, v:5,  dark:0.04, knot:0.06 },
    rustic: { h:27, s:44, l:63, v:12, dark:0.22, knot:0.30 }
  };

  // real variants (id, label, price kr/paket, m² per paket) — synced from Shopify
  var VARIANTS = {
    select: [
      {id:56382023205250, t:'16×50×350', price:805,  m2:0.875},
      {id:56382023238018, t:'16×50×400', price:920,  m2:1.0},
      {id:56382023270786, t:'16×68×408', price:1012, m2:1.1},
      {id:56382023303554, t:'16×68×340', price:846,  m2:0.92},
      {id:56382023336322, t:'16×68×272', price:680,  m2:0.73},
      {id:56382023369090, t:'16×68×204', price:708,  m2:0.77}
    ],
    natur: [
      {id:56386557313410, t:'16×50×350', price:724, m2:0.875},
      {id:56386557346178, t:'16×50×400', price:828, m2:1.0},
      {id:56386557378946, t:'16×68×408', price:910, m2:1.1},
      {id:56386557411714, t:'16×68×340', price:761, m2:0.92},
      {id:56386557444482, t:'16×68×272', price:612, m2:0.73},
      {id:56386557477250, t:'16×68×204', price:637, m2:0.77}
    ],
    rustic: [
      {id:56386684649858, t:'16×50×350', price:503, m2:0.875},
      {id:56386684682626, t:'16×50×400', price:575, m2:1.0},
      {id:56386684715394, t:'16×68×408', price:632, m2:1.1},
      {id:56386684748162, t:'16×68×340', price:529, m2:0.92},
      {id:56386684780930, t:'16×68×272', price:425, m2:0.73},
      {id:56386684813698, t:'16×68×204', price:443, m2:0.77}
    ]
  };

  // stav geometry per index (same order as VARIANTS)
  var DIMS=[
    {t:'16×50×350',w:50,l:350},
    {t:'16×50×400',w:50,l:400},
    {t:'16×68×408',w:68,l:408},
    {t:'16×68×340',w:68,l:340},
    {t:'16×68×272',w:68,l:272},
    {t:'16×68×204',w:68,l:204}
  ];

  // Default-stil som ärvs av nya rum (måste finnas innan state byggs, eftersom newRoom körs i state-literalen)
  var STYLE_DEF = { sort:'natur', pattern:'fiskben', rotation:45, fris:false, lopband:false, dimFloor:0, dimFris:5, dimLb:0 };

  var state = {
    img:null,
    rooms:[ newRoom('Rum 1') ],
    active:0,
    tool:'rect',                // 'rect' | 'poly'
    rectStart:null,             // first corner while drawing rect
    cursor:null,                // live cursor pos for previews
    sort:'natur',
    pattern:'fiskben',          // 'fiskben' | 'rak'
    plankW:11,
    rotation:45,
    fris:false,
    lopband:false,
    dimFloor:0,                 // stavmått golv (mitten)
    dimFris:5,                  // stavmått fris (68×204 rekommenderas)
    dimLb:0,                    // stavmått löpband
    wallM:null,                 // longest wall of room 1 (m)
    spill:0.10,
    calMperPx:null,             // m per px från Kalibrera (åsidosätter längsta-vägg-skalan)
    calLine:null,               // {a,b} sparad kalibreringslinje
    calStart:null               // första punkt under kalibrering
  };
  var dragState=null; // {type:'room'|'vertex'|'opening'|'pan', ...}
  var selOpening=null; // {ri, op}
  var view={ z:1, ox:0, oy:0 };
  var curSort='natur'; // sortering för rummet som ritas just nu (sätts per rum i draw())
  var activeMoveHandle=null; // {x,y,r} i världskoordinater – flytta-handtaget på aktivt rum
  var pointers={}; var pinch=null;
  function toWorld(sp){ return [(sp[0]-view.ox)/view.z, (sp[1]-view.oy)/view.z]; }
  function hitR(px){ return px/view.z; }
  function zoomAt(sx, sy, f){
    var nz=Math.max(0.35, Math.min(6, view.z*f));
    var k=nz/view.z;
    view.ox=sx-(sx-view.ox)*k;
    view.oy=sy-(sy-view.oy)*k;
    view.z=nz;
    // Vid UTZOOMNING: så fort hela planritningen får plats på skärmen, centrera den
    // (men panorera fritt när man är inzoomad – då rörs inget automatiskt)
    if(f<1) centerImageIfFits();
    drawFast();
  }
  function centerImageIfFits(){
    if(!state.img || !state.imgRect) return;
    var r=state.imgRect;
    var it=stageInsetTop(), ib=stageInsetBot();
    var availH=Math.max(80, ch()-it-ib);
    if(r.w*view.z<=cw()*0.98 && r.h*view.z<=availH*0.98){
      view.ox=cw()/2-(r.x+r.w/2)*view.z;
      view.oy=(it+availH/2)-(r.y+r.h/2)*view.z;
    }
  }
  function fitView(){
    var pts=[];
    state.rooms.forEach(function(r){ if(r.closed) pts=pts.concat(r.points); });
    if(!pts.length){ view.z=1; view.ox=0; view.oy=0; draw(); return; }
    var minx=Infinity,miny=Infinity,maxx=-Infinity,maxy=-Infinity;
    pts.forEach(function(p){ minx=Math.min(minx,p[0]); miny=Math.min(miny,p[1]); maxx=Math.max(maxx,p[0]); maxy=Math.max(maxy,p[1]); });
    // Centrera i den FRIA ytan (mellan toppraden och botten-docken) så rummet aldrig hamnar bakom knapparna.
    var it=stageInsetTop(), ib=stageInsetBot();
    var availH=Math.max(80, ch()-it-ib);
    var pad=40, bw=maxx-minx+pad*2, bh=maxy-miny+pad*2;
    view.z=Math.max(0.35, Math.min(4, Math.min(cw()/bw, availH/bh)));
    view.ox=(cw()-(minx+maxx)*view.z)/2;
    view.oy=(it+availH/2)-((miny+maxy)/2)*view.z;
    draw();
  }
  function clampView(){
    // När en planritning är uppladdad: hindra super-utzoom och håll ritningen på skärmen.
    if(!state.img || !state.imgRect) return;
    var r=state.imgRect;
    var minZ=Math.min(cw()/r.w, ch()/r.h)*0.9;
    if(view.z<minZ) view.z=minZ;
    var cxS=view.ox+(r.x+r.w/2)*view.z, cyS=view.oy+(r.y+r.h/2)*view.z;
    var mx=cw()*0.30, my=ch()*0.30;
    if(cxS<mx) view.ox+=mx-cxS; else if(cxS>cw()-mx) view.ox-=cxS-(cw()-mx);
    if(cyS<my) view.oy+=my-cyS; else if(cyS>ch()-my) view.oy-=cyS-(ch()-my);
  }
  var sceneCache=null, cacheView=null, fastTimer=null, mainCtx=null;
  function snapCache(){
    if(!canvas || !canvas.width) return;
    if(!sceneCache) sceneCache=document.createElement('canvas');
    if(sceneCache.width!==canvas.width || sceneCache.height!==canvas.height){ sceneCache.width=canvas.width; sceneCache.height=canvas.height; }
    var c2=sceneCache.getContext('2d');
    c2.setTransform(1,0,0,1,0,0);
    c2.clearRect(0,0,sceneCache.width,sceneCache.height);
    c2.drawImage(canvas,0,0);
    cacheView={z:view.z, ox:view.ox, oy:view.oy};
  }
  function drawFast(){
    if(!sceneCache || !cacheView){ draw(); return; }
    var dpr=window.devicePixelRatio||1;
    ctx.setTransform(dpr,0,0,dpr,0,0);
    ctx.clearRect(0,0,cw(),ch());
    ctx.fillStyle='#f7f5f1';
    ctx.fillRect(0,0,cw(),ch());
    var f=view.z/cacheView.z;
    ctx.drawImage(sceneCache, 0,0,sceneCache.width,sceneCache.height, view.ox-f*cacheView.ox, view.oy-f*cacheView.oy, cw()*f, ch()*f);
    clearTimeout(fastTimer);
    fastTimer=setTimeout(function(){ draw(); }, 120);
  }

  var view3d=false;
  var texMode=false;
  var texCanvas=null, tex3d=null, renderer3d=null, scene3=null, camera3=null, controls3=null, anim3=null;
  var TEX_SRC = {
    select:'https://cdn.shopify.com/s/files/1/0903/6762/3554/files/3_d2fa7517-d5fa-4c22-a970-65575768e72c.png',
    natur:'https://cdn.shopify.com/s/files/1/0903/6762/3554/files/2_92c5d59f-8a75-4d7d-8a08-51e61796ad73.png',
    rustic:'https://cdn.shopify.com/s/files/1/0903/6762/3554/files/1_911b337a-e3c6-4a2d-9a14-c8067c033030.png'
  };
  var texStrips={};

  function newRoom(name){
    // ärv från det aktiva templatet (state) om det finns, annars grunddefaults
    var t=(typeof state!=='undefined' && state) ? state : STYLE_DEF;
    return {
      name:name, points:[], closed:false,
      sort:t.sort, pattern:t.pattern,
      rotation:(t.pattern==='fiskben'?45:(t.rotation||0)),
      fris:!!t.fris, lopband:!!t.lopband,
      dimFloor:t.dimFloor||0, dimFris:(t.dimFris==null?5:t.dimFris), dimLb:t.dimLb||0
    };
  }
  // Returnerar rummets stil och fyller i ev. saknade fält (bakåtkompatibelt med gamla sparade designer)
  function rstyle(rm){
    rm=rm||room();
    if(!rm) return state;
    if(rm.sort==null) rm.sort=state.sort;
    if(rm.pattern==null) rm.pattern=state.pattern;
    if(rm.rotation==null) rm.rotation=(rm.pattern==='fiskben'?45:0);
    if(rm.fris==null) rm.fris=state.fris;
    if(rm.lopband==null) rm.lopband=state.lopband;
    if(rm.dimFloor==null) rm.dimFloor=state.dimFloor;
    if(rm.dimFris==null) rm.dimFris=state.dimFris;
    if(rm.dimLb==null) rm.dimLb=state.dimLb;
    return rm;
  }
  // Vart panelens stilval skrivs: det aktiva (färdiga) rummet, annars state-templatet för nästa rum
  function styleTarget(){ var rm=room(); return (rm && rm.closed) ? rstyle(rm) : state; }
  // Skriv ett stilfält till aktivt rum OCH spegla till templatet så nästa nya rum ärver valet
  function setStyle(field, value){ var t=styleTarget(); t[field]=value; if(t!==state) state[field]=value; }

  var canvas, ctx, wrap, cbox;
  var exportSS=1;
  var logoImg=new Image();
  logoImg.crossOrigin='anonymous';
  logoImg.onload=function(){ try{ if(ctx) draw(); }catch(eL){} };
  logoImg.src='https://cdn.shopify.com/s/files/1/0903/6762/3554/files/nobilelogo.png?v=1745844351';
  var K = 5; // updated per valt stavmått in draw()

  function $(id){ return document.getElementById(id); }
  function rnd(a,b){ var t=Math.sin(a*127.1+b*311.7+13.37)*43758.5453; return t-Math.floor(t); }
  function fmt(n,d){ return n.toLocaleString('sv-SE',{minimumFractionDigits:d||0,maximumFractionDigits:d||0}); }
  function rotBase(){ return styleTarget().pattern==='fiskben' ? 45 : 0; }
  function rotRel(){ var t=styleTarget(); return ((t.rotation-(t.pattern==='fiskben'?45:0))%360+360)%360; }
  function updateRotVal(){ var e=document.getElementById('nwfd-rotval'); if(e) e.textContent=rotRel()+'°'; }
  function track(name, params){ try{ if(window.gtag) gtag('event', name, params||{}); else if(window.dataLayer) dataLayer.push(Object.assign({event:name}, params||{})); }catch(eT){} }

  /* ============ INIT ============ */
  function init(){
    canvas=$('nwfd-canvas'); if(!canvas) return;
    ctx=canvas.getContext('2d'); mainCtx=ctx; wrap=$('nwfd-stage');
    // Lägg canvasen (+3D-ytan) i en egen mitt-sektion så layouten kan bli en riktig
    // app-kolumn: topprad / rityta / dock. cbox är den ruta canvasen ska fylla.
    cbox=document.createElement('div'); cbox.className='nwfd-canvaswrap';
    canvas.parentNode.insertBefore(cbox, canvas);
    cbox.appendChild(canvas);
    var d3w=$('nwfd-3dwrap'); if(d3w) cbox.appendChild(d3w);
    // Flytande overlay-kontroller (riktning + kalibrera) ska sväva ÖVER ritytan, inte över docken.
    var rotEl=$('nwfd-stage-rot'); if(rotEl) cbox.appendChild(rotEl);
    var calEl=document.querySelector('.nwfd-stage-cal'); if(calEl) cbox.appendChild(calEl);
    sizeCanvas();
    window.addEventListener('resize', function(){ sizeCanvas(); placeRot(); placeUpload(); draw(); });
    placeUpload();
    if(window.ResizeObserver){
      var lastW=-1, lastH=-1;
      new ResizeObserver(function(){
        var w=cbox.clientWidth, h=cbox.clientHeight;
        if(w>0 && (Math.abs(w-lastW)>1 || Math.abs(h-lastH)>1)){
          lastW=w; lastH=h; sizeCanvas(); draw();
          if(isMobileOpen()){ if(state.img) centerImageIfFits(); else fitView(); }
        }
      }).observe(cbox);
    }

    $('nwfd-file').addEventListener('change', onUpload);
    canvas.addEventListener('pointerdown', onTap);
    var drawPend=false;
    function drawThrottled(){ if(drawPend) return; drawPend=true; requestAnimationFrame(function(){ drawPend=false; draw(); }); }
    canvas.addEventListener('pointermove', function(ev){
      var r=canvas.getBoundingClientRect();
      var sx=ev.clientX-r.left, sy=ev.clientY-r.top;
      if(pointers[ev.pointerId]) pointers[ev.pointerId]=[sx,sy];
      var pids=Object.keys(pointers);
      if(pinch && pids.length>=2){
        var p1=pointers[pids[0]], p2=pointers[pids[1]];
        var d=Math.hypot(p2[0]-p1[0], p2[1]-p1[1])||1;
        var c=[(p1[0]+p2[0])/2,(p1[1]+p2[1])/2];
        var nz=Math.max(0.35, Math.min(6, pinch.z0*(d/pinch.d0)));
        var k=nz/pinch.z0;
        var zoomingOut=nz<view.z;
        view.z=nz;
        view.ox=c[0]-(pinch.c0[0]-pinch.ox0)*k;
        view.oy=c[1]-(pinch.c0[1]-pinch.oy0)*k;
        if(zoomingOut) centerImageIfFits();
        drawFast();
        return;
      }
      var wp=toWorld([sx,sy]);
      var x=wp[0], y=wp[1];
      state.cursor=[x,y];
      if(dragState && dragState.type==='pan'){
        view.ox=dragState.ox0+(sx-dragState.s0[0]);
        view.oy=dragState.oy0+(sy-dragState.s0[1]);
        drawFast();
        return;
      }
      if(dragState){
        if((Math.abs(x-dragState.start[0])+Math.abs(y-dragState.start[1]))*view.z>3) dragState.moved=true;
        if(dragState.type==='cal'){ state.cursor=[x,y]; drawThrottled(); return; }
        if(dragState.type==='vertex'){
          var rmv=state.rooms[dragState.idx];
          var n0=rmv.points.length;
          var np=[x,y];
          var thr=hitR(4); // mjuk snäppning – bara när du är nästan exakt i linje
          [rmv.points[(dragState.vi+n0-1)%n0], rmv.points[(dragState.vi+1)%n0]].forEach(function(q){
            if(Math.abs(np[0]-q[0])<thr) np[0]=q[0];
            if(Math.abs(np[1]-q[1])<thr) np[1]=q[1];
          });
          rmv.points[dragState.vi]=np;
          drawThrottled();
          return;
        }
        if(dragState.type==='edge'){
          var rmd=state.rooms[dragState.idx];
          var ia=dragState.vi, ib=(dragState.vi+1)%rmd.points.length;
          var oa=dragState.orig[ia], ob=dragState.orig[ib];
          var ex=ob[0]-oa[0], ey=ob[1]-oa[1];
          var elen=Math.hypot(ex,ey)||1;
          var nx=-ey/elen, ny=ex/elen;            // väggens normal
          var ddx=x-dragState.start[0], ddy=y-dragState.start[1];
          var proj=ddx*nx+ddy*ny;                  // flytta bara vinkelrätt → väggen förblir parallell
          rmd.points[ia]=[oa[0]+nx*proj, oa[1]+ny*proj];
          rmd.points[ib]=[ob[0]+nx*proj, ob[1]+ny*proj];
          drawThrottled();
          return;
        }
        if(dragState.type==='opening'){
          var rmo=state.rooms[dragState.idx];
          var ei=dragState.op.edge, ej=(ei+1)%rmo.points.length;
          var ds=distSeg([x,y], rmo.points[ei], rmo.points[ej]);
          dragState.op.t=Math.max(0.05, Math.min(0.95, ds.t));
          drawThrottled();
          return;
        }
        if(dragState.type==='opensize'){
          var rms=state.rooms[dragState.idx];
          var eis=dragState.op.edge, ejs=(eis+1)%rms.points.length;
          var dss=distSeg([x,y], rms.points[eis], rms.points[ejs]);
          dragState.op.t=Math.max(0.05, Math.min(0.95, (dragState.tStart+dss.t)/2));
          var scS=scaleMperPx();
          var spanM=Math.abs(dss.t-dragState.tStart)*dragState.edgeLen*(scS||0.025);
          dragState.op.wM=Math.max(0.5, Math.min(3.5, spanM));
          drawThrottled();
          return;
        }
        var dx=x-dragState.start[0], dy=y-dragState.start[1];
        if((Math.abs(dx)+Math.abs(dy))*view.z<6 && !dragState.moved2) return;
        dragState.moved2=true;
        var rm2=state.rooms[dragState.idx];
        rm2.points=dragState.orig.map(function(pt){ return [pt[0]+dx, pt[1]+dy]; });
        drawThrottled();
        return;
      }
      if(state.rectStart || (state.tool==='cal' && state.calStart) || (!room().closed && room().points.length)) drawThrottled();
    });
    function endDrag(ev){
      if(ev && pointers[ev.pointerId]) delete pointers[ev.pointerId];
      if(Object.keys(pointers).length<2) pinch=null;
      if(ev && ev.clientX!==undefined && state.tool==='rect' && state.rectStart && !dragState && !view3d){
        var rRct=canvas.getBoundingClientRect();
        var pRct=toWorld([ev.clientX-rRct.left, ev.clientY-rRct.top]);
        if(Math.abs(pRct[0]-state.rectStart[0])>hitR(12) && Math.abs(pRct[1]-state.rectStart[1])>hitR(12)){
          if(completeRect(pRct)) return;
        }
      }
      if(dragState){
        var dsl=dragState; dragState=null;
        if(dsl.rbtn) lastRPan=!!dsl.moved;
        if(dsl.type==='cal'){
          var aPt=state.calStart?state.calStart.slice():null;
          var bPt=state.cursor?state.cursor.slice():null;
          if(!aPt||!bPt){ state.calStart=null; state.calLine=null; setTool('edit'); draw(); return; }
          var dCal=Math.hypot(bPt[0]-aPt[0], bPt[1]-aPt[1]);
          if(dCal<hitR(12)){ state.calStart=null; state.calLine=null; setTool('edit'); draw(); return; } // för kort linje – ignorera
          state.calLine={ a:aPt, b:bPt }; draw();
          openPromptModal({
            kicker:'Kalibrera', title:'Hur lång är väggen?',
            label:'Skriv in längden i meter på väggen du ritade linjen på – då räknas alla andra mått ut automatiskt.',
            placeholder:'t.ex. 4,2', ok:'Spara skala',
            cb:function(ans){
              var mCal=ans?parseFloat(String(ans).replace(',','.')):NaN;
              if(mCal>0){ state.calMperPx=mCal/dCal; state.calLine={ a:aPt, b:bPt }; save(); }
              else { state.calLine=null; }
              state.calStart=null; setTool('edit'); refresh();
            },
            onCancel:function(){ state.calStart=null; state.calLine=null; setTool('edit'); refresh(); }
          });
          return;
        }
        if(dsl.type==='opensize'){
          if(!dsl.moved) dsl.op.wM=0.9;
          showOpEdit();
          refresh();
          return;
        }
        if(dsl.moved && dsl.type!=='pan') refresh();
      }
    }
    canvas.addEventListener('pointerup', endDrag);
    canvas.addEventListener('pointercancel', endDrag);
    canvas.addEventListener('pointerleave', function(){ state.cursor=null; endDrag(); draw(); });

    bindChoice('.nwfd-tool[data-tool]','data-tool',function(v){ setTool(v); });
    canvas.addEventListener('contextmenu', function(e){
      e.preventDefault();
      if(lastRPan){ lastRPan=false; return; }
      var rmC=room();
      if(state.rectStart){ state.rectStart=null; }
      else if(!rmC.closed && rmC.points.length){ rmC.points=[]; }
      else { hideOpEdit(); }
      dragState=null;
      draw(); hint();
    });
    var dockAnim=null;
    function glideTo(targetY){
      if(dockAnim) cancelAnimationFrame(dockAnim);
      var startY=window.scrollY, dist=targetY-startY, dur=650, t0=null;
      if(Math.abs(dist)<2) return;
      function ease(t){ return t<0.5 ? 4*t*t*t : 1-Math.pow(-2*t+2,3)/2; }
      function step(ts){
        if(t0===null) t0=ts;
        var p=Math.min(1,(ts-t0)/dur);
        window.scrollTo(0, startY+dist*ease(p));
        if(p<1) dockAnim=requestAnimationFrame(step);
        else dockAnim=null;
      }
      dockAnim=requestAnimationFrame(step);
    }
    var dockT=0;
    function dockEditor(){
      if(!window.matchMedia('(min-width:1001px)').matches) return;
      var gE=document.querySelector('.nwfd-grid'); if(!gE) return;
      if(dockAnim) return;
      var now=Date.now(); if(now-dockT<1500) return; dockT=now;
      var gT=gE.getBoundingClientRect().top;
      if(Math.abs(gT)>40 && gT>-gE.offsetHeight*0.5){
        glideTo(gT+window.scrollY);
      }
    }
    canvas.addEventListener('wheel', function(e){
      e.preventDefault();
      var r=canvas.getBoundingClientRect();
      zoomAt(e.clientX-r.left, e.clientY-r.top, e.deltaY<0?1.06:0.943);
    }, {passive:false});
    var startB=$('nwfd-start');
    var wrapBox=document.querySelector('.nwfd-wrap');
    function lockApp(){ document.body.classList.add('nwfd-lock'); }
    function unlockApp(){ document.body.classList.remove('nwfd-lock'); }
    // Stäng av webbläsarens nyp-zoom (hela sidan) medan appen är öppen — annars zoomar
    // iOS Safari hela sidan när man nyper på ritytan. Återställs när appen stängs.
    function pageZoom(allow){
      var m=document.querySelector('meta[name=viewport]');
      if(!m){ m=document.createElement('meta'); m.setAttribute('name','viewport'); document.head.appendChild(m); }
      if(!allow){
        if(m.getAttribute('data-nwfd-orig')==null) m.setAttribute('data-nwfd-orig', m.getAttribute('content')||'');
        m.setAttribute('content','width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover');
      }else{
        var orig=m.getAttribute('data-nwfd-orig');
        m.setAttribute('content', orig!=null && orig!=='' ? orig : 'width=device-width, initial-scale=1, viewport-fit=cover');
        m.removeAttribute('data-nwfd-orig');
      }
    }
    if(startB && wrapBox){
      var hasSaved=false;
      try{
        var svH=JSON.parse(localStorage.getItem('nwfd_v4')||'{}');
        hasSaved = ((svH.rooms||[]).some(function(rS){return rS.closed;})) || !!localStorage.getItem('nwfd_img');
      }catch(eH){}
      if(!hasSaved){
        wrapBox.classList.add('is-hidden');
      }else{
        // Tidigare ritning finns sparad i DENNA webbläsare. Kasta INTE in besökaren i fullskärm
        // (det hoppar över säljsidan och känns som att man fastnar). Visa landningssidan som vanligt
        // men byt CTA till "Fortsätt din ritning" – designen laddas redan via restore() och ritas
        // när man öppnar appen. (Tidigare: body.add('nwfd-open') här = auto-fullskärm.)
        wrapBox.classList.add('is-hidden');
        startB.textContent='Fortsätt din ritning  ↓';
        var gBr=document.getElementById('nwfd-gateopen'); if(gBr) gBr.textContent='Fortsätt din ritning →';
      }
      startB.addEventListener('click', function(){
        if(wrapBox.classList.contains('is-hidden')){
          wrapBox.classList.remove('is-hidden');
          wrapBox.classList.add('is-reveal');
          sizeCanvas(); draw();
        }
        startB.style.display='none';
        // innehållet ovanför göms (CSS via body.nwfd-open) – skrolla upp så appen fyller skärmen, centrerad
        document.body.classList.add('nwfd-open');
        if(window.matchMedia('(max-width:1000px)').matches) pageZoom(false);
        requestAnimationFrame(function(){
          window.scrollTo({top:0, behavior:'smooth'});
          placeRot(); placeUpload(); sizeCanvas(); draw();
          setTimeout(function(){ placeRot(); placeUpload(); sizeCanvas(); if(state.img) centerImageIfFits(); else fitView(); draw(); }, 360);
          setTimeout(lockApp, 520);
        });
        // Första gången: visa kom-igång-guiden så man förstår appen innan man börjar.
        var seenG=false; try{ seenG=!!localStorage.getItem('nwfd_intro_seen'); }catch(eS){}
        if(!seenG) setTimeout(openIntroGuide, 650);
      });
    }
    var guideB=$('nwfd-guide');
    if(guideB) guideB.addEventListener('click', openIntroGuide);
    function exitApp(){
      unlockApp();
      pageZoom(true);
      document.body.classList.remove('nwfd-open');
      placeRot(); placeUpload();
      if(wrapBox){ wrapBox.classList.add('is-hidden'); wrapBox.classList.remove('is-reveal'); }
      // App closed — bring back the "Börja nu" button so it can be reopened.
      if(startB) startB.style.display='';
      var introE=document.querySelector('.nwfd-intro');
      if(introE) window.scrollTo({top:introE.getBoundingClientRect().top+window.scrollY-90});
    }
    var exitB=$('nwfd-exit');
    if(exitB) exitB.addEventListener('click', exitApp);
    document.addEventListener('keydown', function(eK){
      if(eK.key!=='Escape' || !document.body.classList.contains('nwfd-lock')) return;
      var rmE=room();
      if(state.rectStart || (rmE && !rmE.closed && rmE.points.length)) return;
      exitApp();
    });
    var gateB=$('nwfd-gateopen');
    if(gateB && wrapBox) gateB.addEventListener('click', function(){
      wrapBox.classList.add('is-gateopen');
      wrapBox.classList.remove('is-hidden');
      wrapBox.classList.add('is-reveal');
      // Mobil: gå in i fullskärm precis som "Börja nu" på dator.
      document.body.classList.add('nwfd-open');
      if(window.matchMedia('(max-width:1000px)').matches) pageZoom(false);
      requestAnimationFrame(function(){
        window.scrollTo({top:0});
        placeRot(); placeUpload(); sizeCanvas(); draw(); fitView();
        setTimeout(function(){ placeRot(); placeUpload(); sizeCanvas(); if(state.img) centerImageIfFits(); else fitView(); draw(); }, 360);
        setTimeout(lockApp, 400);
      });
      // Första gången: visa rundturen.
      var seenG=false; try{ seenG=!!localStorage.getItem('nwfd_intro_seen'); }catch(eS){}
      if(!seenG) setTimeout(openIntroGuide, 700);
    });
    var zi=$('nwfd-zin'), zo=$('nwfd-zout'), zf=$('nwfd-zfit');
    if(zi) zi.addEventListener('click', function(){ zoomAt(cw()/2, ch()/2, 1.3); });
    if(zo) zo.addEventListener('click', function(){ zoomAt(cw()/2, ch()/2, 0.77); });
    if(zf) zf.addEventListener('click', fitView);
    window.addEventListener('keydown', function(e){
      if(view3d) return;
      var tag=(document.activeElement&&document.activeElement.tagName)||'';
      if(tag==='INPUT'||tag==='TEXTAREA'||tag==='SELECT') return;
      if(e.key==='Escape'){
        var rmE=room();
        if(state.rectStart){ state.rectStart=null; }
        else if(!rmE.closed && rmE.points.length){ rmE.points=[]; }
        hideOpEdit();
        draw(); hint();
      }
      if(e.key==='ArrowUp'||e.key==='ArrowDown'||e.key==='ArrowLeft'||e.key==='ArrowRight'){
        var rmA=room();
        if(state.tool==='edit' && rmA.closed){
          var st=(e.shiftKey?2:10)/view.z;
          var ddx=(e.key==='ArrowLeft'?-st:e.key==='ArrowRight'?st:0);
          var ddy=(e.key==='ArrowUp'?-st:e.key==='ArrowDown'?st:0);
          rmA.points=rmA.points.map(function(pt){ return [pt[0]+ddx, pt[1]+ddy]; });
          refresh();
          e.preventDefault();
          return;
        }
      }
      if(e.key==='Delete' || e.key==='Backspace'){
        if(selOpening){
          var roD=state.rooms[selOpening.ri];
          var ixD=(roD.openings||[]).indexOf(selOpening.op);
          if(ixD>=0) roD.openings.splice(ixD,1);
          hideOpEdit(); refresh();
        } else if(room().closed){
          deleteRoom(state.active);
        }
        e.preventDefault();
      }
    });
    var opw=$('nwfd-opw');
    if(opw) opw.addEventListener('input', function(e){
      if(!selOpening) return;
      var v=parseFloat((e.target.value||'').replace(',','.'));
      if(v>=0.4 && v<=3.5){ selOpening.op.wM=v; draw(); save(); calc(); }
    });
    document.querySelectorAll('.nwfd-opmode').forEach(function(b){
      b.addEventListener('click', function(){
        if(!selOpening) return;
        selOpening.op.mode=b.getAttribute('data-mode');
        showOpEdit(); refresh();
      });
    });
    var opd=$('nwfd-opdel');
    if(opd) opd.addEventListener('click', function(){
      if(!selOpening) return;
      var ro=state.rooms[selOpening.ri];
      var ix=(ro.openings||[]).indexOf(selOpening.op);
      if(ix>=0) ro.openings.splice(ix,1);
      hideOpEdit(); refresh();
    });
    var urb=$('nwfd-updroom');
    if(urb) urb.addEventListener('click', updateActiveRoom);
    $('nwfd-undo').addEventListener('click', function(){
      var rmU=room();
      if(state.rectStart || (rmU && !rmU.closed && rmU.points.length)) undo();
      else histUndo();
    });
    var rdB=$('nwfd-redo'); if(rdB) rdB.addEventListener('click', histRedo);
    $('nwfd-close').addEventListener('click', closeRoom);
    var nrBind=$('nwfd-newroom'); if(nrBind) nrBind.addEventListener('click', addRoom);
    $('nwfd-clear').addEventListener('click', function(){
      openConfirm({
        kicker:'Rensa allt', title:'Ta bort hela designen?',
        body:'Alla rum, mått och inställningar nollställs. Detta går inte att ångra.',
        ok:'Ja, rensa allt', cancel:'Avbryt',
        cb:function(){
          state.rooms=[newRoom('Rum 1')]; state.active=0; state.rectStart=null;
          state.rotation=rotBase(); $('nwfd-rot').value=0; updateRotVal();
          state.img=null; state.imgRect=null;
          state.calMperPx=null; state.calLine=null; state.calStart=null; state.wallM=null;
          var wEl0=$('nwfd-wall'); if(wEl0) wEl0.value='';
          try{ localStorage.removeItem('nwfd_img'); }catch(e4){}
          hideOpEdit();
          buildDims(); refresh(); syncScopeUI();
        }
      });
    });

    bindChoice('.nwfd-sort','data-sort',function(v){ setStyle('sort',v); buildDims(); refresh(); });
    bindChoice('.nwfd-pattern','data-pattern',function(v){
      setStyle('pattern', v);
      setStyle('rotation', v==='fiskben'?45:0);
      $('nwfd-rot').value=0; updateRotVal();
      refresh();
    });

    $('nwfd-rot').addEventListener('input', function(e){
      var base=(styleTarget().pattern==='fiskben')?45:0;
      setStyle('rotation', (parseInt(e.target.value,10)+base)%360);
      updateRotVal();
      var ss=$('nwfd-stage-rotslider'); if(ss) ss.value=rotRel(); var sv=$('nwfd-stage-rotval'); if(sv) sv.textContent=rotRel()+'°';
      draw(); save();
    });
    // Riktnings-reglage direkt på editorn – syns i Redigera-läget (per rum)
    (function(){
      var stage=document.getElementById('nwfd-stage'); if(!stage) return;
      var box=document.createElement('div'); box.className='nwfd-stage-rot'; box.id='nwfd-stage-rot'; box.style.display='none';
      box.innerHTML='<label>Riktning <strong id="nwfd-stage-rotval">0°</strong></label><input type="range" id="nwfd-stage-rotslider" min="0" max="360" step="5" value="0">';
      (cbox||stage).appendChild(box);
      placeRot();
      box.addEventListener('pointerdown', function(e){ e.stopPropagation(); });
      $('nwfd-stage-rotslider').addEventListener('input', function(e){
        var base=(styleTarget().pattern==='fiskben')?45:0;
        var rel=parseInt(e.target.value,10)||0;
        setStyle('rotation', (rel+base)%360);
        var sv=$('nwfd-stage-rotval'); if(sv) sv.textContent=rel+'°';
        var lr=$('nwfd-rot'); if(lr) lr.value=rel; var lv=$('nwfd-rotval'); if(lv) lv.textContent=rel+'°';
        draw(); save();
      });
      // tydlig kalibrera-uppmaning direkt på ritytan tills skalan är satt
      var cb=document.createElement('button'); cb.type='button'; cb.className='nwfd-stage-cal'; cb.id='nwfd-stage-cal'; cb.style.display='none';
      cb.innerHTML='<span class="nwfd-stage-cal-ic">⊾</span> Kalibrera för att få mått <span class="nwfd-stage-cal-arr">→</span>';
      (cbox||stage).appendChild(cb);
      cb.addEventListener('pointerdown', function(e){ e.stopPropagation(); });
      cb.addEventListener('click', function(){ setTool('cal'); hint(); });
    })();
    $('nwfd-fris').addEventListener('change', function(e){
      setStyle('fris', e.target.checked);
      if(!e.target.checked) setStyle('lopband', false);
      refresh();
    });
    $('nwfd-lopband').addEventListener('change', function(e){ setStyle('lopband', e.target.checked); refresh(); });

    var wm=$('nwfd-wall');
    wm.addEventListener('input', function(e){
      state.wallM=parseFloat((e.target.value||'').replace(',','.'))||null;
      refresh();
    });
    wm.addEventListener('change', function(){ if(state.wallM && stepPanels[0] && stepPanels[0].classList.contains('is-open')) openStep(1,false); });

    // stavmått pickers bind their own click handlers in buildDims()
    $('nwfd-cart').addEventListener('click', addToCart);
    var fcB=$('nwfd-fp-cart'); if(fcB) fcB.addEventListener('click', addToCart);
    var am=$('nwfd-addmeasured'); if(am) am.addEventListener('click', addMeasuredRoom);
    var pdf=$('nwfd-pdf'); if(pdf) pdf.addEventListener('click', exportPDF);
    var shB=$('nwfd-share'); if(shB) shB.addEventListener('click', shareDesign);
    setupSteps();
    histSnap();
    var drBind=$('nwfd-delroom'); if(drBind) drBind.addEventListener('click', function(){ var rmX=room(); if(rmX && rmX.closed) deleteRoom(state.active); });
    bindChoice('.nwfd-spill','data-spill',function(v){ state.spill=parseFloat(v); refresh(); });
    var dbB=$('nwfd-demo'); if(dbB) dbB.addEventListener('click', loadDemo);
    var calBtnEl=$('nwfd-calbtn'); if(calBtnEl) calBtnEl.addEventListener('click', function(){ setTool('cal'); hint(); });
    // toppknapp: Ladda upp ritning
    var upTop=$('nwfd-upload-top'); if(upTop) upTop.addEventListener('click', function(){ var f=$('nwfd-file'); if(f) f.click(); });
    // rums-panelen: "+ Nytt rum"
    var arAdd=$('nwfd-approom-add'); if(arAdd) arAdd.addEventListener('click', function(){ setTool('rect'); hint(); });
    // pris i prskortet: visa/dölj beräkning (göm verktygskolumnen så prskortet får plats)
    function setBreakdown(open){
      var rows=$('nwfd-fp-rows'), tog=$('nwfd-fp-toggle'); if(!rows) return;
      if(open){ rows.removeAttribute('hidden'); if(tog) tog.textContent='Visa beräkning ▾'; document.body.classList.add('nwfd-calc-open'); }
      else { rows.setAttribute('hidden',''); document.body.classList.remove('nwfd-calc-open'); }
    }
    var fpPdf=$('nwfd-fp-pdf'); if(fpPdf) fpPdf.addEventListener('click', function(){ exportPDF(); });
    var fpTog=$('nwfd-fp-toggle'); if(fpTog) fpTog.addEventListener('click', function(){ setBreakdown($('nwfd-fp-rows').hasAttribute('hidden')); });
    var fpX=$('nwfd-fp-x'); if(fpX) fpX.addEventListener('click', function(){ setBreakdown(false); });
    // dubbelklick på ett rum öppnar redigera-guiden direkt
    canvas.addEventListener('dblclick', function(ev){
      if(state.tool!=='edit') return;
      var rD=canvas.getBoundingClientRect();
      var pD=toWorld([ev.clientX-rD.left, ev.clientY-rD.top]);
      var hitD=state.rooms.findIndex(function(ro){ return ro.closed && pointInPoly(pD, ro.points); });
      if(hitD>=0){ state.active=hitD; openRoomModal(state.rooms[hitD], false); }
    });
    // scope tabs are built & bound in syncScopeUI()
    var mg=$('nwfd-mbar-go'); if(mg) mg.addEventListener('click', function(){ openStep(3,false); if(stepPanels[3]) stepPanels[3].scrollIntoView({behavior:'smooth', block:'start'}); });
    if(window.matchMedia('(hover: hover)').matches){
      var tipEl=document.createElement('div');
      tipEl.className='nwfd-tipbox';
      document.body.appendChild(tipEl);
      var tipTarget=null;
      function hideTip(){ tipTarget=null; tipEl.classList.remove('is-on'); }
      document.addEventListener('mouseover', function(eT){
        var t=eT.target && eT.target.closest ? eT.target.closest('[data-tip]') : null;
        if(t===tipTarget) return;
        if(!t){ hideTip(); return; }
        tipTarget=t;
        tipEl.textContent=t.getAttribute('data-tip');
        tipEl.classList.add('is-on');
        var rT=t.getBoundingClientRect();
        tipEl.style.left='0px'; tipEl.style.top='0px';
        var twT=tipEl.offsetWidth, thT=tipEl.offsetHeight;
        var xT=Math.min(Math.max(8, rT.left+rT.width/2-twT/2), window.innerWidth-twT-8);
        var yT=rT.top-thT-10;
        if(yT<8) yT=rT.bottom+10;
        tipEl.style.left=xT+'px'; tipEl.style.top=yT+'px';
      });
      window.addEventListener('scroll', hideTip, true);
      document.addEventListener('click', hideTip, true);
    }
    // editor docking handled on first canvas interaction (see dockEditor in wheel handler)
    var hb=$('nwfd-helpbtn'), hx=$('nwfd-helpbox');
    if(hb && hx){
      hb.addEventListener('click', function(e){ e.stopPropagation(); hx.hidden=!hx.hidden; hb.parentElement.classList.toggle('is-open', !hx.hidden); });
      document.addEventListener('click', function(e){ if(!hx.hidden && !hx.contains(e.target) && e.target!==hb){ hx.hidden=true; hb.parentElement.classList.remove('is-open'); } });
    }
    var b3=$('nwfd-3d');
    if(b3) b3.addEventListener('click', function(){
      var card=document.querySelector('.nwfd-stage-card');
      if(!view3d){
        if(!state.rooms.some(function(r){return r.closed;})){ $('nwfd-hint').textContent='Rita eller lägg till minst ett rum först – sedan kan du se det i 3D.'; return; }
        b3.textContent='Laddar 3D…'; b3.disabled=true;
        ensureThree(function(ok){
          b3.disabled=false;
          if(!ok){ b3.textContent='3D-vy'; alert('Kunde inte ladda 3D-vyn just nu.'); return; }
          view3d=true;
          card.classList.add('is-3d');
          b3.classList.add('is-active');
          b3.textContent='2D-plan';
          build3D();
          $('nwfd-hint').textContent='3D-vy: dra för att rotera, scrolla/nyp för att zooma. Tryck ”2D-plan” för att redigera.';
        });
      } else {
        view3d=false;
        card.classList.remove('is-3d');
        b3.classList.remove('is-active');
        b3.textContent='3D-vy';
        destroy3D();
        draw(); hint();
      }
    });
    var form=$('nwfd-form'); if(form) form.addEventListener('submit', onSend);

    buildDims();
    restore();
    refresh();
    syncScopeUI();
  }

  function buildStrips(key, cb){
    if(texStrips[key]!==undefined) { cb&&cb(); return; }
    texStrips[key]=null;
    var img=new Image();
    img.crossOrigin='anonymous';
    img.onload=function(){
      try{
        var size=Math.floor(Math.max(img.width,img.height)*1.42);
        var rot=document.createElement('canvas');
        rot.width=size; rot.height=size;
        var rc=rot.getContext('2d');
        rc.translate(size/2,size/2);
        rc.rotate(-Math.PI/4);
        rc.drawImage(img,-img.width/2,-img.height/2);
        var strips=[];
        var SH=64;
        var inner=Math.floor(size*0.5);
        var off=Math.floor((size-inner)/2);
        for(var i=0;i<8;i++){
          var sc=document.createElement('canvas');
          sc.width=inner; sc.height=SH;
          var sy=off+Math.floor(rnd(i,key.length*7)*(inner-SH));
          sc.getContext('2d').drawImage(rot, off, sy, inner, SH, 0,0,inner,SH);
          strips.push(sc);
        }
        // taint check — throws if CORS failed
        strips[0].getContext('2d').getImageData(0,0,1,1);
        texStrips[key]=strips;
      }catch(e){ texStrips[key]=null; }
      cb&&cb();
    };
    img.onerror=function(){ texStrips[key]=null; cb&&cb(); };
    img.src=TEX_SRC[key];
  }

  function bindChoice(sel, attr, cb){
    document.querySelectorAll(sel).forEach(function(btn){
      btn.addEventListener('click', function(){
        document.querySelectorAll(sel).forEach(function(b){ b.classList.toggle('is-active', b===btn); });
        cb(btn.getAttribute(attr));
      });
    });
  }

  function setTool(v){
    state.tool=v;
    if(v!=='cal') state.calStart=null;
    state.rectStart=null;
    var aR=room();
    if(aR && !aR.closed && aR.points.length){ aR.points=[]; }
    pruneKeep(aR);
    roomsUI();
    document.querySelectorAll('.nwfd-tool[data-tool]').forEach(function(b){ b.classList.toggle('is-active', b.getAttribute('data-tool')===v); });
    if(canvas) canvas.style.cursor = v==='edit' ? 'grab' : (v==='door' ? 'copy' : 'crosshair');
    draw(); hint();
  }

  function refresh(){ draw(); roomsUI(); hint(); calc(); save(); }
  function room(){ return state.rooms[state.active]; }

  // Mobil-fullskärm: ritytan fyller hela skärmen, men toppraden + botten-docken ligger ovanpå.
  // Dessa mäter hur många px som är skymda upptill/nedtill så att rummet kan centreras i den FRIA ytan.
  function isMobileOpen(){ return document.body.classList.contains('nwfd-open') && window.matchMedia('(max-width:1000px)').matches; }
  // I app-läget är ritytan en egen sektion (topprad + dock ligger UTANFÖR canvasen), så hela
  // canvasen är synlig → inga dolda kanter att kompensera för.
  function stageInsetTop(){ return 0; }
  function stageInsetBot(){ return 0; }
  // Riktnings-reglaget: i verktygsraden (footern) på mobil, svävande över ritytan på dator.
  function placeRot(){
    var box=document.getElementById('nwfd-stage-rot'); if(!box) return;
    var toolrow=document.querySelector('.nwfd-toolrow');
    var zoomc=document.querySelector('.nwfd-zoomctrl');
    if(isMobileOpen()){
      if(toolrow && box.parentNode!==toolrow){ if(zoomc && zoomc.parentNode===toolrow) toolrow.insertBefore(box, zoomc); else toolrow.appendChild(box); }
      box.classList.add('nwfd-stage-rot--dock');
    }else{
      if(cbox && box.parentNode!==cbox) cbox.appendChild(box);
      box.classList.remove('nwfd-stage-rot--dock');
    }
  }
  // "Ladda upp ritning": i toppraden (app-bar) på mobil → frigör en rad i footern; i footern på dator.
  function placeUpload(){
    var up=document.getElementById('nwfd-upload-top'); if(!up) return;
    var topb=document.querySelector('.nwfd-topbtns');
    var toolrow=document.querySelector('.nwfd-toolrow');
    if(isMobileOpen()){
      if(topb && up.parentNode!==topb) topb.insertBefore(up, topb.firstChild);
      up.classList.add('nwfd-upload--top');
    }else{
      if(toolrow && up.parentNode!==toolrow) toolrow.insertBefore(up, toolrow.firstChild);
      up.classList.remove('nwfd-upload--top');
    }
  }
  function sizeCanvas(){
    var dpr=window.devicePixelRatio||1;
    if(isMobileOpen()){
      // Mobil-app-läge: canvasen ligger absolut i sin flex-sektion (cbox) mellan topprad och dock.
      var wM=cbox.clientWidth||wrap.clientWidth;
      var hM=cbox.clientHeight;
      if(!(hM>40)) hM=Math.round((window.innerHeight||600)*0.5);
      canvas.style.height='';
      canvas.width=Math.round(wM*dpr); canvas.height=Math.round(hM*dpr);
      ctx.setTransform(dpr,0,0,dpr,0,0);
      return;
    }
    var w=cbox?cbox.clientWidth:wrap.clientWidth; if(!(w>0)) w=wrap.clientWidth;
    var h;
    // Fullskärm på dator → canvas fyller hela ytan.
    if(window.matchMedia('(min-width:1001px)').matches && wrap.clientHeight>200){
      h=wrap.clientHeight;
    } else {
      h=Math.round(w*0.75);
      if(h>window.innerHeight*0.62) h=Math.round(window.innerHeight*0.62);
    }
    canvas.width=Math.round(w*dpr); canvas.height=Math.round(h*dpr);
    canvas.style.height=h+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }
  function cw(){ return canvas.width/(window.devicePixelRatio||1); }
  function ch(){ return canvas.height/(window.devicePixelRatio||1); }

  /* ============ INPUT ============ */
  function onUpload(e){
    var f=e.target.files&&e.target.files[0]; if(!f) return;
    var url=URL.createObjectURL(f);
    var img=new Image();
    img.onload=function(){
      var dprU=window.devicePixelRatio||1;
      var cwU=(cbox&&cbox.clientWidth)||wrap.clientWidth;
      if(cwU>0 && Math.abs(Math.round(cwU*dprU)-canvas.width)>2) sizeCanvas();
      state.img=img; state.imgRect=null; draw(); URL.revokeObjectURL(url);
      try{
        var c=document.createElement('canvas');
        var mx=2200, sc=Math.min(1, mx/Math.max(img.width,img.height));
        c.width=Math.round(img.width*sc); c.height=Math.round(img.height*sc);
        var cxU=c.getContext('2d'); cxU.imageSmoothingQuality='high';
        cxU.drawImage(img,0,0,c.width,c.height);
        localStorage.setItem('nwfd_img', c.toDataURL('image/jpeg',0.8));
      }catch(e2){}
    };
    img.src=url;
  }

  function snap(pt, ref){
    // ortho-snap against reference point
    if(!ref) return pt;
    var x=pt[0], y=pt[1];
    var st=hitR(10);
    if(Math.abs(x-ref[0])<st) x=ref[0];
    if(Math.abs(y-ref[1])<st) y=ref[1];
    return [x,y];
  }

  var lastRPan=false;
  function onTap(ev){
    if(view3d) return;
    if(ev.button===2){
      var rR=canvas.getBoundingClientRect();
      var spR=[ev.clientX-rR.left, ev.clientY-rR.top];
      dragState={ type:'pan', s0:spR, ox0:view.ox, oy0:view.oy, moved:false, start:toWorld(spR), rbtn:true };
      try{ canvas.setPointerCapture(ev.pointerId); }catch(eR){}
      return;
    }
    if(ev.button!==undefined && ev.button!==0) return;
    var r=canvas.getBoundingClientRect();
    var sp=[ev.clientX-r.left, ev.clientY-r.top];
    pointers[ev.pointerId]=sp;
    var pids=Object.keys(pointers);
    if(pids.length===2){
      var p1=pointers[pids[0]], p2=pointers[pids[1]];
      pinch={ d0:Math.hypot(p2[0]-p1[0],p2[1]-p1[1])||1, z0:view.z, c0:[(p1[0]+p2[0])/2,(p1[1]+p2[1])/2], ox0:view.ox, oy0:view.oy };
      dragState=null;
      return;
    }
    var p=toWorld(sp);
    var rm=room();
    if(state.tool==='edit'){
      // FLYTTA-HANDTAGET: greppa det runda handtaget i mitten och dra för att flytta hela rummet
      if(activeMoveHandle && Math.hypot(p[0]-activeMoveHandle.x, p[1]-activeMoveHandle.y) < activeMoveHandle.r){
        var rmMove=state.rooms[state.active];
        if(rmMove && rmMove.closed){
          dragState={ type:'room', idx:state.active, start:p, orig:rmMove.points.map(function(pt){return pt.slice();}), moved:false };
          try{ canvas.setPointerCapture(ev.pointerId); }catch(eMv){}
          return;
        }
      }
      for(var ri2=0; ri2<state.rooms.length; ri2++){
        var ro2=state.rooms[ri2];
        if(!ro2.closed) continue;
        for(var vj=0; vj<ro2.points.length; vj++){
          if(Math.hypot(p[0]-ro2.points[vj][0], p[1]-ro2.points[vj][1])<hitR(14)){
            pruneKeep(ro2);
            state.active=state.rooms.indexOf(ro2);
            roomsUI(); hint(); draw();
            dragState={type:'vertex', idx:state.active, vi:vj, moved:false, start:p};
            try{ canvas.setPointerCapture(ev.pointerId); }catch(e0){}
            return;
          }
        }
      }
      var fo=findOpeningAt(p);
      if(fo){
        state.active=fo.ri;
        selOpening=fo;
        showOpEdit();
        dragState={type:'opening', idx:fo.ri, op:fo.op, moved:false, start:p};
        try{ canvas.setPointerCapture(ev.pointerId); }catch(e1){}
        roomsUI(); hint(); draw();
        return;
      }
      // dra en HEL vägg (linjen mellan två hörn) – flyttar väggen vinkelrätt, grannväggarna sträcks med.
      // Körs EFTER öppnings-kontrollen så dörröppningar fortfarande går att dra.
      for(var rE=0; rE<state.rooms.length; rE++){
        var roE=state.rooms[rE];
        if(!roE.closed || roE.points.length<2) continue;
        for(var eE=0; eE<roE.points.length; eE++){
          var aE=roE.points[eE], bE=roE.points[(eE+1)%roE.points.length];
          if(Math.hypot(p[0]-aE[0],p[1]-aE[1])<hitR(16) || Math.hypot(p[0]-bE[0],p[1]-bE[1])<hitR(16)) continue; // nära hörn – låt hörn-drag ta det
          var dE=distSeg(p, aE, bE);
          if(dE.d<hitR(9) && dE.t>0.06 && dE.t<0.94){
            pruneKeep(roE);
            state.active=state.rooms.indexOf(roE);
            roomsUI(); hint(); draw();
            dragState={type:'edge', idx:state.active, vi:eE, moved:false, start:p, orig:roE.points.map(function(pt){return pt.slice();})};
            try{ canvas.setPointerCapture(ev.pointerId); }catch(e0e){}
            return;
          }
        }
      }
      var hit=state.rooms.findIndex(function(ro){ return ro.closed && pointInPoly(p, ro.points); });
      if(hit>=0){
        var rrK=state.rooms[hit];
        pruneKeep(rrK);
        hit=state.rooms.indexOf(rrK);
        state.active=hit; roomsUI(); hint(); draw();
      }
      dragState={ type:'pan', s0:sp, ox0:view.ox, oy0:view.oy, moved:false, start:p };
      try{ canvas.setPointerCapture(ev.pointerId); }catch(e9){}
      return;
    }
    if(state.tool==='cal'){
      // klicka, dra och släpp – linjen ritas medan du drar, måttet frågas vid släpp (se endDrag)
      state.calStart=p; state.cursor=p; state.calLine=null;
      dragState={type:'cal', start:p};
      try{ canvas.setPointerCapture(ev.pointerId); }catch(eCal){}
      draw(); hint();
      return;
    }
    if(rm.closed){
      pruneKeep(rm);
      state.rooms.push(newRoom('Rum '+(state.rooms.length+1)));
      state.active=state.rooms.length-1;
      rm=room();
      roomsUI();
    }
    if(state.tool==='rect'){
      if(!state.rectStart){ state.rectStart=p; }
      else if(completeRect(p)){ return; }
      draw(); hint();
    } else {
      var ref=rm.points.length?rm.points[rm.points.length-1]:null;
      p=snap(p, ref);
      if(rm.points.length>=3){
        var p0=rm.points[0];
        if(Math.hypot(p[0]-p0[0],p[1]-p0[1])<hitR(14)){ rm.closed=true; refresh(); setTool('edit'); openRoomModal(rm, true); return; }
      }
      rm.points.push(p);
      draw(); hint();
    }
  }

  function undo(){
    var rm=room();
    if(state.rectStart){ state.rectStart=null; }
    else if(rm.closed){ rm.closed=false; rm.openings=[]; if(state.tool==='rect'){ rm.points=[]; } }
    else if(rm.points.length){ rm.points.pop(); }
    refresh();
  }

  function completeRect(b){
    var a=state.rectStart; if(!a) return false;
    if(Math.abs(a[0]-b[0])<=hitR(8) || Math.abs(a[1]-b[1])<=hitR(8)) return false;
    var rm=room();
    rm.points=[[a[0],a[1]],[b[0],a[1]],[b[0],b[1]],[a[0],b[1]]];
    rm.closed=true;
    state.rectStart=null;
    refresh();
    setTool('edit');
    openRoomModal(rm, true);
    return true;
  }

  function closeRoom(){
    var rm=room();
    if(!rm.closed && rm.points.length>=3){ rm.closed=true; refresh(); setTool('edit'); openRoomModal(rm, true); }
  }

  function addRoom(){
    pruneKeep(room());
    var rm=room();
    if(!rm.closed && rm.points.length===0 && state.rooms.length===1){ return; } // already empty single room
    if(!rm.closed){ return; } // finish current first
    state.rooms.push(newRoom('Rum '+(state.rooms.length+1)));
    state.active=state.rooms.length-1;
    state.rectStart=null;
    refresh();
  }

  function addMeasuredRoom(){
    var L=parseFloat(($('nwfd-rl').value||'').replace(',','.'));
    var B=parseFloat(($('nwfd-rb').value||'').replace(',','.'));
    var M2el=$('nwfd-rm2');
    var M2=M2el?parseFloat((M2el.value||'').replace(',','.')):0;
    if(M2 && M2>0){ L=Math.sqrt(M2); B=Math.sqrt(M2); }
    if(!L||!B||L<=0||B<=0){ $('nwfd-rl').focus(); return; }
    var scale=scaleMperPx();
    if(!scale){
      var anyClosed=state.rooms.some(function(r){return r.closed;});
      if(anyClosed){ openStep(0,true); alert('Ange längsta väggen (m) under steg 1 först, så vet vi skalan.'); $('nwfd-wall').focus(); return; }
      var ppm=Math.min(cw(),ch())*0.55/Math.max(L,B);
      scale=1/ppm;
      state.wallM=Math.max(L,B);
      $('nwfd-wall').value=String(state.wallM).replace('.',',');
    }
    var w=L/scale, h=B/scale;
    var nClosed=state.rooms.filter(function(r){return r.closed;}).length;
    var x0=24+nClosed*26, y0=24+nClosed*26;
    if(x0+w>cw()) x0=Math.max(4, cw()-w-4);
    if(y0+h>ch()) y0=Math.max(4, ch()-h-4);
    var rm=room();
    if(rm.closed || rm.points.length){ state.rooms.push(newRoom('Rum '+(state.rooms.length+1))); state.active=state.rooms.length-1; rm=room(); }
    rm.points=[[x0,y0],[x0+w,y0],[x0+w,y0+h],[x0,y0+h]];
    rm.closed=true;
    $('nwfd-rl').value=''; $('nwfd-rb').value='';
    if($('nwfd-rm2')) $('nwfd-rm2').value='';
    refresh();
    openRoomModal(rm, true);
  }

  function pruneKeep(keepRef){
    for(var i=state.rooms.length-1;i>=0;i--){
      var r=state.rooms[i];
      if(!r.closed && r!==keepRef && (r.points.length>0 || state.rooms.length>1)){
        state.rooms.splice(i,1);
      }
    }
    if(!state.rooms.length) state.rooms=[newRoom('Rum 1')];
    if(keepRef){ var ix=state.rooms.indexOf(keepRef); state.active = ix>=0?ix:0; }
    else if(state.active>=state.rooms.length) state.active=state.rooms.length-1;
    state.rooms.forEach(function(r2,idx){ if(/^Rum \d+$/.test(r2.name)) r2.name='Rum '+(idx+1); });
  }

  function deleteRoom(i){
    hideOpEdit();
    state.rooms.splice(i,1);
    if(!state.rooms.length) state.rooms=[newRoom('Rum 1')];
    state.rooms.forEach(function(r,idx){ if(/^Rum \d+$/.test(r.name)) r.name='Rum '+(idx+1); });
    if(state.active>=state.rooms.length) state.active=state.rooms.length-1;
    refresh();
  }

  /* ============ GEOMETRY ============ */
  function tracePoly(pts){
    ctx.beginPath();
    ctx.moveTo(pts[0][0],pts[0][1]);
    for(var i=1;i<pts.length;i++) ctx.lineTo(pts[i][0],pts[i][1]);
    ctx.closePath();
  }
  function signedArea(pts){
    var a=0;
    for(var i=0;i<pts.length;i++){ var j=(i+1)%pts.length; a+=pts[i][0]*pts[j][1]-pts[j][0]*pts[i][1]; }
    return a/2;
  }
  function polyAreaPx(pts){ return Math.abs(signedArea(pts)); }
  function centroid(pts){
    var x=0,y=0; pts.forEach(function(p){x+=p[0];y+=p[1];});
    return [x/pts.length, y/pts.length];
  }
  function pointInPoly(p, pts){
    var inside=false;
    for(var i=0,j=pts.length-1;i<pts.length;j=i++){
      if(((pts[i][1]>p[1])!==(pts[j][1]>p[1])) && (p[0] < (pts[j][0]-pts[i][0])*(p[1]-pts[i][1])/(pts[j][1]-pts[i][1])+pts[i][0])) inside=!inside;
    }
    return inside;
  }
  function insetPoly(pts, d){
    var n=pts.length;
    var dir=signedArea(pts)>0?1:-1;
    var lines=[];
    for(var i=0;i<n;i++){
      var p=pts[i], q=pts[(i+1)%n];
      var ex=q[0]-p[0], ey=q[1]-p[1], len=Math.hypot(ex,ey)||1;
      var nx=-ey/len*dir, ny=ex/len*dir;
      lines.push({px:p[0]+nx*d, py:p[1]+ny*d, ex:ex, ey:ey});
    }
    var out=[];
    for(var i2=0;i2<n;i2++){
      var A=lines[(i2-1+n)%n], B=lines[i2];
      var den=A.ex*B.ey-A.ey*B.ex;
      if(Math.abs(den)<1e-6){ out.push([B.px,B.py]); continue; }
      var t=((B.px-A.px)*B.ey-(B.py-A.py)*B.ex)/den;
      out.push([A.px+A.ex*t, A.py+A.ey*t]);
    }
    return out;
  }
  function longestEdgeAllRooms(){
    var m=0;
    state.rooms.forEach(function(r){
      if(!r.closed) return;
      for(var i=0;i<r.points.length;i++){
        var j=(i+1)%r.points.length;
        m=Math.max(m, Math.hypot(r.points[j][0]-r.points[i][0], r.points[j][1]-r.points[i][1]));
      }
    });
    return m;
  }
  function scaleMperPx(){
    if(state.calMperPx && state.calMperPx>0) return state.calMperPx;
    if(!state.wallM || state.wallM<=0) return null;
    var firstClosed=state.rooms.find(function(r){return r.closed;});
    if(!firstClosed) return null;
    var m=0;
    for(var i=0;i<firstClosed.points.length;i++){
      var j=(i+1)%firstClosed.points.length;
      m=Math.max(m, Math.hypot(firstClosed.points[j][0]-firstClosed.points[i][0], firstClosed.points[j][1]-firstClosed.points[i][1]));
    }
    if(m<10) return null;
    return state.wallM/m;
  }

  /* ============ ÖPPNINGAR (door openings) ============ */
  function lerp(a,b,t){ return [a[0]+(b[0]-a[0])*t, a[1]+(b[1]-a[1])*t]; }
  function distSeg(p,a,b){
    var vx=b[0]-a[0], vy=b[1]-a[1];
    var l2=vx*vx+vy*vy;
    if(l2<1) return {d:Math.hypot(p[0]-a[0],p[1]-a[1]), t:0};
    var t=((p[0]-a[0])*vx+(p[1]-a[1])*vy)/l2;
    t=Math.max(0,Math.min(1,t));
    return {d:Math.hypot(p[0]-(a[0]+vx*t), p[1]-(a[1]+vy*t)), t:t};
  }
  function edgeIntervals(rm, i, A, B, scale){
    var len=Math.hypot(B[0]-A[0],B[1]-A[1]);
    var res=[];
    (rm.openings||[]).forEach(function(op){
      if(op.edge!==i) return;
      var half=scale?(((op.wM||0.9)/scale)/2):30;
      var t0=Math.max(0.02, op.t-half/Math.max(1,len)), t1=Math.min(0.98, op.t+half/Math.max(1,len));
      if(t1>t0) res.push([t0,t1]);
    });
    return res.sort(function(a,b){return a[0]-b[0];});
  }
  function openingQuad(outer, inner, op, scale){
    var n=outer.length, i=op.edge;
    if(i==null || i>=n) return null;
    var j=(i+1)%n;
    var A=outer[i],B=outer[j],iA=inner[i],iB=inner[j];
    var len=Math.hypot(B[0]-A[0],B[1]-A[1]);
    if(len<4) return null;
    var half=scale?(((op.wM||0.9)/scale)/2):30;
    var t0=Math.max(0.02, op.t-half/len), t1=Math.min(0.98, op.t+half/len);
    if(t1<=t0) return null;
    return { quad:[lerp(A,B,t0),lerp(A,B,t1),lerp(iA,iB,t1),lerp(iA,iB,t0)], A:A,B:B,t0:t0,t1:t1 };
  }
  function strokeGaps(pts, rm, scale){
    var n=pts.length;
    for(var i=0;i<n;i++){
      var j=(i+1)%n;
      var A=pts[i],B=pts[j];
      var ivs=edgeIntervals(rm, i, A, B, scale);
      var segs=[], last=0;
      ivs.forEach(function(iv){ if(iv[0]>last) segs.push([last,iv[0]]); last=Math.max(last,iv[1]); });
      if(last<1) segs.push([last,1]);
      segs.forEach(function(sg){
        var P=lerp(A,B,sg[0]), Q=lerp(A,B,sg[1]);
        ctx.beginPath(); ctx.moveTo(P[0],P[1]); ctx.lineTo(Q[0],Q[1]); ctx.stroke();
      });
    }
  }
  function drawThreshold(seg, W, seed){
    var P=lerp(seg.A,seg.B,seg.t0), Q=lerp(seg.A,seg.B,seg.t1);
    var mx=(P[0]+Q[0])/2, my=(P[1]+Q[1])/2;
    var ang=Math.atan2(Q[1]-P[1],Q[0]-P[0]);
    var len=Math.hypot(Q[0]-P[0],Q[1]-P[1]);
    var im=[(seg.quad[2][0]+seg.quad[3][0])/2,(seg.quad[2][1]+seg.quad[3][1])/2];
    var ca=Math.cos(-ang), sa=Math.sin(-ang);
    var ly=(im[0]-mx)*sa+(im[1]-my)*ca;
    var dirY= ly>=0?1:-1;
    ctx.save();
    ctx.translate(mx,my); ctx.rotate(ang);
    var d=Math.max(4,W);
    paintPlank(-len/2+0.5, dirY>0?0:-d, len-1, d, seed+91, Math.round(len));
    ctx.restore();
  }

  function findOpeningAt(p){
    var found=null;
    state.rooms.forEach(function(ro,ri){
      if(!ro.closed) return;
      (ro.openings||[]).forEach(function(op){
        var i=op.edge, j=(i+1)%ro.points.length;
        var C=lerp(ro.points[i], ro.points[j], op.t);
        if(Math.hypot(p[0]-C[0], p[1]-C[1])<hitR(14)) found={ri:ri, op:op};
      });
    });
    return found;
  }
  function showOpEdit(){
    var el=$('nwfd-opedit'); if(!el||!selOpening) return;
    el.style.display='flex';
    var w=$('nwfd-opw'); if(w) w.value=String(selOpening.op.wM||0.9).replace('.',',');
    document.querySelectorAll('.nwfd-opmode').forEach(function(b){
      b.classList.toggle('is-active', b.getAttribute('data-mode')===selOpening.op.mode);
    });
  }
  function hideOpEdit(){
    var el=$('nwfd-opedit'); if(el) el.style.display='none';
    selOpening=null;
  }
  function updateActiveRoom(){
    var rm=room(); if(!rm.closed) return;
    var L=parseFloat(($('nwfd-rl').value||'').replace(',','.'));
    var B=parseFloat(($('nwfd-rb').value||'').replace(',','.'));
    var M2el=$('nwfd-rm2');
    var M2=M2el?parseFloat((M2el.value||'').replace(',','.')):0;
    if(M2 && M2>0){ L=Math.sqrt(M2); B=Math.sqrt(M2); }
    if(!L||!B||L<=0||B<=0){ $('nwfd-rl').focus(); return; }
    var firstClosed=state.rooms.find(function(r){return r.closed;});
    if(firstClosed===rm){
      state.wallM=Math.max(L,B);
      $('nwfd-wall').value=String(state.wallM).replace('.',',');
    }
    var scale=scaleMperPx();
    if(!scale){ openStep(0,true); alert('Ange längsta väggen (m) under steg 1 först.'); return; }
    var minx=Infinity, miny=Infinity;
    rm.points.forEach(function(pt){ minx=Math.min(minx,pt[0]); miny=Math.min(miny,pt[1]); });
    rm.points=[[minx,miny],[minx+L/scale,miny],[minx+L/scale,miny+B/scale],[minx,miny+B/scale]];
    rm.openings=[];
    $('nwfd-rl').value=''; $('nwfd-rb').value=''; if(M2el) M2el.value='';
    refresh();
  }

  /* ============ STAV RENDERING ============ */
  function paintPlank(X,Y,w,h,sa,sb){
    var strips=texStrips[curSort];
    if(strips && strips.length){
      var st=strips[Math.floor(rnd(sa,sb)*strips.length)];
      var horiz=w>=h;
      var sw=Math.max(60, Math.min(st.width-2, Math.floor(st.width*0.55)));
      var sx=Math.floor(rnd(sb+3,sa+9)*(st.width-sw));
      ctx.save();
      if(horiz){ ctx.drawImage(st, sx,0,sw,st.height, X,Y,w,h); }
      else { ctx.translate(X+w/2,Y+h/2); ctx.rotate(Math.PI/2); ctx.drawImage(st, sx,0,sw,st.height, -h/2,-w/2,h,w); }
      ctx.restore();
      var pal=PALETTES[curSort];
      var rr=rnd(sa+13,sb+29);
      if(rr<pal.dark){ ctx.fillStyle='rgba(70,46,22,0.22)'; ctx.fillRect(X,Y,w,h); }
      else if(rr>0.75){ ctx.fillStyle='rgba(255,246,232,'+(0.10*(rr-0.75)*4).toFixed(3)+')'; ctx.fillRect(X,Y,w,h); }
      else if(rr<0.35){ ctx.fillStyle='rgba(92,64,34,'+(0.10*(0.35-rr)*3).toFixed(3)+')'; ctx.fillRect(X,Y,w,h); }
      ctx.strokeStyle='rgba(60,42,25,0.32)';
      ctx.lineWidth=Math.max(0.5,state.plankW*0.045);
      ctx.strokeRect(X+0.25,Y+0.25,w-0.5,h-0.5);
      return;
    }
    var p=PALETTES[curSort];
    var r1=rnd(sa,sb), r2=rnd(sb+7,sa+3), r3=rnd(sa+31,sb+57);
    var l=p.l+(r1*2-1)*p.v;
    if(r2<p.dark) l-=8;
    var s=p.s+(r2*2-1)*4;
    ctx.fillStyle='hsl('+p.h+','+s+'%,'+l+'%)';
    ctx.fillRect(X,Y,w,h);

    var horiz=w>h;
    var gl=Math.max(1,Math.floor((horiz?h:w)/4));
    ctx.strokeStyle='hsla('+p.h+','+s+'%,'+(l-9)+'%,0.35)';
    ctx.lineWidth=0.6;
    for(var g=1;g<=gl;g++){
      var off=(horiz?h:w)*(g/(gl+1))+(rnd(sa+g,sb)*2-1)*1.2;
      ctx.beginPath();
      if(horiz){ ctx.moveTo(X+1,Y+off); ctx.lineTo(X+w-1,Y+off+(rnd(sb,g)*2-1)*1.5); }
      else     { ctx.moveTo(X+off,Y+1); ctx.lineTo(X+off+(rnd(sb,g)*2-1)*1.5,Y+h-1); }
      ctx.stroke();
    }
    if(r3<p.knot && Math.min(w,h)>6){
      var kx=X+w*(0.25+rnd(sa,sb+99)*0.5), ky=Y+h*(0.25+rnd(sa+5,sb)*0.5);
      var kr=Math.min(w,h)*0.16;
      ctx.beginPath(); ctx.ellipse(kx,ky,kr,kr*0.7,r3*3,0,Math.PI*2);
      ctx.fillStyle='hsla('+(p.h-6)+','+(s+6)+'%,'+(l-22)+'%,0.8)'; ctx.fill();
      ctx.beginPath(); ctx.ellipse(kx,ky,kr*0.45,kr*0.3,r3*3,0,Math.PI*2);
      ctx.fillStyle='hsla('+(p.h-8)+','+(s+6)+'%,'+(l-32)+'%,0.85)'; ctx.fill();
    }
    // bevel relief: lit top/left edge, shaded bottom/right - gives each stav height
    ctx.lineWidth=1;
    ctx.strokeStyle='rgba(255,255,255,0.32)';
    ctx.beginPath(); ctx.moveTo(X+0.8,Y+h-0.8); ctx.lineTo(X+0.8,Y+0.8); ctx.lineTo(X+w-0.8,Y+0.8); ctx.stroke();
    ctx.strokeStyle='rgba(55,32,12,0.30)';
    ctx.beginPath(); ctx.moveTo(X+w-0.8,Y+0.9); ctx.lineTo(X+w-0.8,Y+h-0.8); ctx.lineTo(X+0.9,Y+h-0.8); ctx.stroke();
    ctx.strokeStyle='rgba(60,42,25,0.32)';
    ctx.lineWidth=Math.max(0.5,state.plankW*0.045);
    ctx.strokeRect(X+0.25,Y+0.25,w-0.5,h-0.5);
  }

  function patBBox(pts, rotDeg){
    var cx=cw()/2, cy=ch()/2, a=-rotDeg*Math.PI/180;
    var ca=Math.cos(a), sa=Math.sin(a);
    var minx=Infinity,miny=Infinity,maxx=-Infinity,maxy=-Infinity;
    pts.forEach(function(p){
      var dx=p[0]-cx, dy=p[1]-cy;
      var x=dx*ca-dy*sa, y=dx*sa+dy*ca;
      if(x<minx)minx=x; if(x>maxx)maxx=x; if(y<miny)miny=y; if(y>maxy)maxy=y;
    });
    return {minx:minx,miny:miny,maxx:maxx,maxy:maxy};
  }

  function fillHerringbone(pts, rotDeg, W, seed){
    ctx.save();
    tracePoly(pts); ctx.clip();
    ctx.translate(cw()/2,ch()/2);
    ctx.rotate(rotDeg*Math.PI/180);
    var L=W*K;
    var bb=patBBox(pts, rotDeg);
    var nMin=Math.floor((bb.miny-W)/W)-1, nMax=Math.ceil((bb.maxy+K*W)/W)+1;
    for(var n=nMin;n<=nMax;n++){
      var mMin=Math.floor(((bb.minx-L)/W-n)/(2*K))-2, mMax=Math.ceil(((bb.maxx+L)/W-n)/(2*K))+2;
      for(var m=mMin;m<=mMax;m++){
        var X=(n+2*K*m)*W, Y=n*W;
        paintPlank(X,Y,L,W,n+seed,m);
        paintPlank(X+L,Y+(1-K)*W,W,L,n+311+seed,m+17);
      }
    }
    ctx.restore();
  }

  function fillStraight(pts, rotDeg, W, seed){
    ctx.save();
    tracePoly(pts); ctx.clip();
    ctx.translate(cw()/2,ch()/2);
    ctx.rotate(rotDeg*Math.PI/180);
    var L=W*K;
    var bb=patBBox(pts, rotDeg);
    var rMin=Math.floor(bb.miny/W)-1, rMax=Math.ceil(bb.maxy/W)+1;
    for(var r=rMin;r<=rMax;r++){
      var off=(r%2===0)?0:L/2; // engelskt förband – halv stavs förskjutning
      var x0s=Math.floor((bb.minx-L+off)/L)*L-off;
      for(var x=x0s;x<bb.maxx+L;x+=L){
        paintPlank(x, r*W-W/2, L-0.4, W, r+seed, Math.round(x/3));
      }
    }
    ctx.restore();
  }

  /* holländskt förband: block av stavar som växlar riktning */
  function fillBasket(pts, rotDeg, W, seed){
    ctx.save();
    tracePoly(pts); ctx.clip();
    ctx.translate(cw()/2,ch()/2);
    ctx.rotate(rotDeg*Math.PI/180);
    var L=W*K;
    var bb=patBBox(pts, rotDeg);
    var ciMin=Math.floor((bb.minx-L)/L)-1, ciMax=Math.ceil(bb.maxx/L)+1;
    var cjMin=Math.floor((bb.miny-L)/L)-1, cjMax=Math.ceil(bb.maxy/L)+1;
    for(var ci=ciMin;ci<=ciMax;ci++){
      for(var cj=cjMin;cj<=cjMax;cj++){
        var x0=ci*L, y0=cj*L;
        var horiz=((ci+cj)%2===0);
        for(var k=0;k<K;k++){
          if(horiz) paintPlank(x0, y0+k*W, L-0.3, W, ci*31+k+seed, cj*17);
          else      paintPlank(x0+k*W, y0, W, L-0.3, ci*13+k+seed, cj*29+7);
        }
      }
    }
    ctx.restore();
  }

  /* fris: staves PERPENDICULAR to each wall, split at öppningar */
  function fillFrisBand(rm, inner, W, seed, scale){
    var outer=rm.points;
    var n=outer.length;
    for(var i=0;i<n;i++){
      var j=(i+1)%n;
      var A=outer[i], B=outer[j], iA=inner[i], iB=inner[j];
      var ivs=edgeIntervals(rm, i, A, B, scale);
      var segs=[], last=0;
      ivs.forEach(function(iv){ if(iv[0]>last) segs.push([last,iv[0]]); last=Math.max(last,iv[1]); });
      if(last<1) segs.push([last,1]);
      segs.forEach(function(sg,si){
        var q=[lerp(A,B,sg[0]), lerp(A,B,sg[1]), lerp(iA,iB,sg[1]), lerp(iA,iB,sg[0])];
        ctx.save();
        tracePoly(q); ctx.clip();
        var omx=(q[0][0]+q[1][0])/2, omy=(q[0][1]+q[1][1])/2;
        var imx=(q[3][0]+q[2][0])/2, imy=(q[3][1]+q[2][1])/2;
        var ang=Math.atan2(B[1]-A[1], B[0]-A[0]);
        ctx.translate(omx,omy); ctx.rotate(ang);
        var ca=Math.cos(-ang), sa=Math.sin(-ang);
        var ly=(imx-omx)*sa + (imy-omy)*ca;
        var dirY = ly>=0 ? 1 : -1;
        var bandW=Math.hypot(imx-omx, imy-omy) + 0.5;
        var elen=Math.hypot(B[0]-A[0],B[1]-A[1])*(sg[1]-sg[0]) + W*4;
        var y0 = dirY>0 ? 0 : -bandW;
        var k=0;
        for(var x=-elen/2; x<elen/2; x+=W){
          paintPlank(x, y0, W-0.3, bandW, k+i*13+si*5+seed, Math.round(x/2)+i);
          k++;
        }
        ctx.restore();
      });
    }
  }

  function fillLopband(outer, inner){
    var n=outer.length;
    for(var i=0;i<n;i++){
      var j=(i+1)%n;
      var quad=[outer[i],outer[j],inner[j],inner[i]];
      ctx.save();
      // fyll själva quad-formen (täcker oavsett pan/zoom – fillRect(0,0,cw,ch) missade när rummet låg utanför världsrutan)
      ctx.fillStyle='hsl(26,45%,30%)';
      tracePoly(quad); ctx.fill();
      tracePoly(quad); ctx.clip();
      var elen=Math.hypot(outer[j][0]-outer[i][0], outer[j][1]-outer[i][1]);
      var steps=Math.max(2,Math.round(elen/(state.plankW*2.5)));
      ctx.strokeStyle='rgba(0,0,0,0.25)'; ctx.lineWidth=0.7;
      for(var t=1;t<steps;t++){
        var fx1=outer[i][0]+(outer[j][0]-outer[i][0])*t/steps;
        var fy1=outer[i][1]+(outer[j][1]-outer[i][1])*t/steps;
        var fx2=inner[i][0]+(inner[j][0]-inner[i][0])*t/steps;
        var fy2=inner[i][1]+(inner[j][1]-inner[i][1])*t/steps;
        ctx.beginPath(); ctx.moveTo(fx1,fy1); ctx.lineTo(fx2,fy2); ctx.stroke();
      }
      ctx.restore();
    }
  }

  /* ============ DRAW ============ */
  function drawGrid(){
    ctx.strokeStyle='rgba(0,0,0,0.05)';
    ctx.lineWidth=1/view.z;
    var g=24;
    var x0=Math.floor((-view.ox/view.z)/g)*g, y0=Math.floor((-view.oy/view.z)/g)*g;
    var x1=(-view.ox+cw())/view.z, y1=(-view.oy+ch())/view.z;
    for(var x=x0;x<x1;x+=g){ ctx.beginPath(); ctx.moveTo(x,y0); ctx.lineTo(x,y1); ctx.stroke(); }
    for(var y=y0;y<y1;y+=g){ ctx.beginPath(); ctx.moveTo(x0,y); ctx.lineTo(x1,y); ctx.stroke(); }
  }

  function edgeLabels(pts, scale){
    var inv=texMode?1:1/view.z; // konstant skärmstorlek på måtten oavsett zoom (även när man zoomat ut)
    var c=centroid(pts);
    ctx.save();
    ctx.font='600 '+(11*inv)+'px Inter, sans-serif';
    ctx.textAlign='center'; ctx.textBaseline='middle';
    for(var i=0;i<pts.length;i++){
      var j=(i+1)%pts.length;
      var ex=pts[j][0]-pts[i][0], ey=pts[j][1]-pts[i][1];
      var len=Math.hypot(ex, ey);
      if(len<28) continue;
      var mx0=(pts[i][0]+pts[j][0])/2, my0=(pts[i][1]+pts[j][1])/2;
      var txt=fmt(len*scale,1)+' m';
      var tw=ctx.measureText(txt).width+10*inv;
      // flytta måttsiffran UTÅT från rummet så hela etiketten klarar vägg-handtaget (pricken)
      var nx=-ey/len, ny=ex/len;
      if((mx0-c[0])*nx+(my0-c[1])*ny<0){ nx=-nx; ny=-ny; }
      var ext=Math.abs(nx)*(tw/2)+Math.abs(ny)*(9*inv); // etikettens utbredning längs normalen
      var off=ext+(5*inv)+(5*inv); // + prickens radie + liten lucka
      var mx=mx0+nx*off, my=my0+ny*off;
      ctx.fillStyle='rgba(29,29,31,0.9)';
      ctx.beginPath();
      if(ctx.roundRect) ctx.roundRect(mx-tw/2,my-9*inv,tw,18*inv,9*inv); else ctx.rect(mx-tw/2,my-9*inv,tw,18*inv);
      ctx.fill();
      ctx.strokeStyle='rgba(255,255,255,0.18)'; ctx.lineWidth=1; ctx.stroke();
      ctx.fillStyle='#fff';
      ctx.fillText(txt,mx,my);
    }
    ctx.restore();
  }

  function draw(){
    var trS=(window.devicePixelRatio||1)*(texMode&&texCanvas?(texCanvas._ss||1):exportSS);
    var trOx=(texMode&&texCanvas)?(texCanvas._ox||0):0, trOy=(texMode&&texCanvas)?(texCanvas._oy||0):0;
    ctx.setTransform(trS,0,0,trS,-trOx*trS,-trOy*trS);
    if(texMode&&texCanvas){ ctx.clearRect(trOx, trOy, texCanvas.width/trS, texCanvas.height/trS); }
    else { ctx.clearRect(0,0,cw(),ch()); }
    if(!texMode){
      ctx.fillStyle='#f7f5f1';
      ctx.fillRect(0,0,cw(),ch());
      ctx.translate(view.ox, view.oy);
      ctx.scale(view.z, view.z);
    }
    if(texMode){ /* transparent bg for 3D texture */ }
    else if(state.img){
      if(!state.imgRect){
        var sR=Math.min(cw()/state.img.width, ch()/state.img.height);
        state.imgRect={x:(cw()-state.img.width*sR)/2, y:(ch()-state.img.height*sR)/2, w:state.img.width*sR, h:state.img.height*sR};
        save();
      }
      ctx.imageSmoothingQuality=dragState?'low':'high';
      ctx.drawImage(state.img, state.imgRect.x, state.imgRect.y, state.imgRect.w, state.imgRect.h);
    } else {
      drawGrid();
    }
    if(!texMode){
      drawWatermark();
      var trB=(window.devicePixelRatio||1)*exportSS;
      ctx.setTransform(trB,0,0,trB,0,0);
      ctx.translate(view.ox, view.oy);
      ctx.scale(view.z, view.z);
    }

    var scale=scaleMperPx();
    if(!texMode) activeMoveHandle=null;

    state.rooms.forEach(function(rm, idx){
      if(rm.closed && rm.points.length>=3){
        var seed=idx*977;
        // --- per-rum stil & mått ---
        var st=rstyle(rm);
        curSort=st.sort||'natur';
        var fd=DIMS[st.dimFloor]||DIMS[0], fr=DIMS[st.dimFris]||DIMS[0], lb=DIMS[st.dimLb]||DIMS[0];
        K=Math.max(3, Math.round(fd.l/fd.w));
        var W = scale ? Math.max(4, (fd.w/1000)/scale) : Math.round(11*(fd.w/68));
        state.plankW=W; // computed, used for seams/bands
        var frisW = scale ? Math.max(10, (fr.l/1000)/scale) : Math.max(16, state.plankW*2.4);
        var bandW = scale ? Math.max(4, (lb.w/1000)/scale) : Math.max(4, state.plankW*0.55);
        var frisStavW = Math.max(3, Math.min(frisW/1.5, W*(fr.w/fd.w)));
        var rFris=!!st.fris, rLop=!!(st.fris&&st.lopband);

        var afterFris = rFris ? insetPoly(rm.points,frisW) : rm.points;
        var floorPts  = rLop ? insetPoly(rm.points,frisW+bandW) : afterFris;

        if(rFris){
          ctx.save();
          ctx.beginPath();
          rm.points.forEach(function(ptU,iU){ iU?ctx.lineTo(ptU[0],ptU[1]):ctx.moveTo(ptU[0],ptU[1]); });
          ctx.closePath();
          afterFris.forEach(function(ptU,iU){ iU?ctx.lineTo(ptU[0],ptU[1]):ctx.moveTo(ptU[0],ptU[1]); });
          ctx.closePath();
          ctx.fillStyle='#c8a878';
          ctx.fill('evenodd');
          ctx.restore();
          fillFrisBand(rm, afterFris, frisStavW, seed, scale);
        }
        if(rLop) fillLopband(afterFris, floorPts);

        var rPat=st.pattern||'fiskben';
        var rRot=(st.rotation!==null && st.rotation!==undefined)?st.rotation:(rPat==='fiskben'?45:0);
        if(rPat==='rak') fillStraight(floorPts, rRot, W, seed);
        else if(rPat==='hollandsk') fillBasket(floorPts, rRot, W, seed);
        else fillHerringbone(floorPts, rRot, W, seed);

        // öppningar: pattern flows through, or ends with tröskelstav
        var opInner = rFris ? afterFris : insetPoly(rm.points, Math.max(6,W));
        (rm.openings||[]).forEach(function(op){
          var seg=openingQuad(rm.points, opInner, op, scale);
          if(!seg) return;
          if(rFris && op.mode==='continue'){
            ctx.save(); tracePoly(seg.quad); ctx.clip();
            if(rPat==='rak') fillStraight(seg.quad, rRot, W, seed);
            else if(rPat==='hollandsk') fillBasket(seg.quad, rRot, W, seed);
            else fillHerringbone(seg.quad, rRot, W, seed);
            ctx.restore();
          }
          if(op.mode==='avslut') drawThreshold(seg, W, seed);

          // markera öppningen: karmstreck + mått
          var P0=lerp(seg.A,seg.B,seg.t0), Q0=lerp(seg.A,seg.B,seg.t1);
          var ang0=Math.atan2(seg.B[1]-seg.A[1], seg.B[0]-seg.A[0]);
          var px0=-Math.sin(ang0)*6, py0=Math.cos(ang0)*6;
          ctx.save();
          ctx.strokeStyle=(selOpening && selOpening.op===op)?'#1d1d1f':'rgba(20,12,4,.8)';
          ctx.lineWidth=(selOpening && selOpening.op===op)?3:2;
          ctx.beginPath(); ctx.moveTo(P0[0]-px0,P0[1]-py0); ctx.lineTo(P0[0]+px0,P0[1]+py0); ctx.stroke();
          ctx.beginPath(); ctx.moveTo(Q0[0]-px0,Q0[1]-py0); ctx.lineTo(Q0[0]+px0,Q0[1]+py0); ctx.stroke();
          ctx.restore();
          if(!texMode){
            var inv3=1/view.z;
            var omx0=(P0[0]+Q0[0])/2, omy0=(P0[1]+Q0[1])/2;
            ctx.save();
            ctx.font='600 '+(10*inv3)+'px Inter, sans-serif';
            ctx.textAlign='center'; ctx.textBaseline='middle';
            var txt0=fmt(op.wM||0.9,1)+' m'+(op.mode==='avslut'?' · avslut':'');
            var tw0=ctx.measureText(txt0).width+8*inv3;
            ctx.fillStyle='rgba(29,29,31,0.9)';
            ctx.beginPath();
            if(ctx.roundRect) ctx.roundRect(omx0-tw0/2,omy0-8*inv3,tw0,16*inv3,8*inv3); else ctx.rect(omx0-tw0/2,omy0-8*inv3,tw0,16*inv3);
            ctx.fill();
            ctx.strokeStyle='rgba(255,255,255,0.18)'; ctx.lineWidth=1; ctx.stroke();
            ctx.fillStyle='#fff';
            ctx.fillText(txt0,omx0,omy0);
            ctx.restore();
          }
        });

        ctx.save();
        ctx.strokeStyle = (!texMode && idx===state.active) ? '#1d1d1f' : 'rgba(40,25,10,.5)';
        ctx.lineWidth = (!texMode && idx===state.active) ? 2.4 : 1.4;
        strokeGaps(rm.points, rm, scale);
        if(rFris){ ctx.lineWidth=1; strokeGaps(afterFris, rm, scale); }
        if(rLop){ tracePoly(floorPts); ctx.stroke(); }
        ctx.restore();

        // room name + m² (also rendered into 3D texture)
        {
        var inv2=texMode?1:1/view.z;
        var c=centroid(rm.points);
        ctx.save();
        ctx.font='600 '+(12*inv2)+'px Inter, sans-serif';
        ctx.textAlign='center'; ctx.textBaseline='middle';
        var label=rm.name + (scale ? (' · '+fmt(polyAreaPx(rm.points)*scale*scale,1)+' m²') : '');
        var tw=ctx.measureText(label).width+14*inv2;
        ctx.fillStyle='rgba(29,29,31,0.82)';
        ctx.beginPath();
        if(ctx.roundRect) ctx.roundRect(c[0]-tw/2,c[1]-11*inv2,tw,22*inv2,11*inv2); else ctx.rect(c[0]-tw/2,c[1]-11*inv2,tw,22*inv2);
        ctx.fill();
        ctx.fillStyle='#fff';
        ctx.fillText(label,c[0],c[1]);
        ctx.restore();
        }

        if(scale && !texMode) edgeLabels(rm.points, scale);

        if(!texMode && idx===state.active){
          var hv=6/view.z;
          ctx.save();
          // litet runt handtag mitt på varje vägg → visar att hela väggen går att dra
          var mr=4.2/view.z;
          for(var em=0; em<rm.points.length; em++){
            var ma=rm.points[em], mb=rm.points[(em+1)%rm.points.length];
            var mcx=(ma[0]+mb[0])/2, mcy=(ma[1]+mb[1])/2;
            ctx.beginPath(); ctx.arc(mcx, mcy, mr, 0, Math.PI*2);
            ctx.fillStyle='#fff'; ctx.fill();
            ctx.lineWidth=1.4/view.z; ctx.strokeStyle='#1d1d1f'; ctx.stroke();
          }
          rm.points.forEach(function(pt){
            ctx.beginPath();
            ctx.rect(pt[0]-hv, pt[1]-hv, hv*2, hv*2);
            ctx.fillStyle='#fff'; ctx.fill();
            ctx.lineWidth=1.6/view.z; ctx.strokeStyle='#1d1d1f'; ctx.stroke();
          });
          // FLYTTA-HANDTAG: mörk rund knapp under rumsnamnet – greppa och dra för att flytta hela rummet
          var ctr=centroid(rm.points);
          var hr=14/view.z;
          var hx=ctr[0], hy=ctr[1]+28/view.z;
          ctx.beginPath(); ctx.arc(hx,hy,hr,0,Math.PI*2);
          ctx.fillStyle='#1d1d1f'; ctx.fill();
          ctx.lineWidth=1.5/view.z; ctx.strokeStyle='#fff'; ctx.stroke();
          // flytt-ikon (fyra pilar)
          var s=hr*0.52, a=s*0.45;
          ctx.strokeStyle='#fff'; ctx.lineWidth=1.6/view.z; ctx.lineCap='round'; ctx.lineJoin='round';
          ctx.beginPath();
          ctx.moveTo(hx,hy-s); ctx.lineTo(hx,hy+s);
          ctx.moveTo(hx-s,hy); ctx.lineTo(hx+s,hy);
          ctx.moveTo(hx-a,hy-s+a); ctx.lineTo(hx,hy-s); ctx.lineTo(hx+a,hy-s+a);
          ctx.moveTo(hx-a,hy+s-a); ctx.lineTo(hx,hy+s); ctx.lineTo(hx+a,hy+s-a);
          ctx.moveTo(hx-s+a,hy-a); ctx.lineTo(hx-s,hy); ctx.lineTo(hx-s+a,hy+a);
          ctx.moveTo(hx+s-a,hy-a); ctx.lineTo(hx+s,hy); ctx.lineTo(hx+s-a,hy+a);
          ctx.stroke();
          activeMoveHandle={ x:hx, y:hy, r:hr*1.25 };
          ctx.restore();
        }
      }
    });

    // in-progress drawing for active room
    var rm=room();
    if(!texMode && !rm.closed){
      ctx.save();
      ctx.strokeStyle='#1d1d1f'; ctx.lineWidth=2; ctx.setLineDash([6,4]);
      if(state.tool==='rect' && state.rectStart && state.cursor){
        var a=state.rectStart, b=state.cursor;
        ctx.strokeRect(Math.min(a[0],b[0]),Math.min(a[1],b[1]),Math.abs(b[0]-a[0]),Math.abs(b[1]-a[1]));
      }
      if(rm.points.length){
        ctx.beginPath();
        ctx.moveTo(rm.points[0][0],rm.points[0][1]);
        for(var i=1;i<rm.points.length;i++) ctx.lineTo(rm.points[i][0],rm.points[i][1]);
        if(state.cursor) ctx.lineTo(state.cursor[0],state.cursor[1]);
        ctx.stroke();
      }
      ctx.setLineDash([]);
      if(state.rectStart){
        ctx.beginPath(); ctx.arc(state.rectStart[0],state.rectStart[1],6,0,Math.PI*2);
        ctx.fillStyle='#1d1d1f'; ctx.fill();
      }
      rm.points.forEach(function(p,idx){
        ctx.beginPath(); ctx.arc(p[0],p[1], idx===0?7:5, 0, Math.PI*2);
        if(idx===0){ ctx.fillStyle='#fff'; ctx.fill(); ctx.lineWidth=2; ctx.strokeStyle='#1d1d1f'; ctx.stroke(); } else { ctx.fillStyle='#1d1d1f'; ctx.fill(); }
      });
      ctx.restore();
    }
    if(!texMode && (state.calLine || (state.tool==='cal' && state.calStart && state.cursor))){
      ctx.save();
      if(state.calLine){
        ctx.strokeStyle='rgba(29,29,31,.4)'; ctx.lineWidth=1.6; ctx.setLineDash([5,4]);
        ctx.beginPath(); ctx.moveTo(state.calLine.a[0],state.calLine.a[1]); ctx.lineTo(state.calLine.b[0],state.calLine.b[1]); ctx.stroke();
        ctx.setLineDash([]);
      }
      if(state.tool==='cal' && state.calStart && state.cursor){
        ctx.strokeStyle='#1d1d1f'; ctx.lineWidth=2.5; ctx.setLineDash([7,5]);
        ctx.beginPath(); ctx.moveTo(state.calStart[0],state.calStart[1]); ctx.lineTo(state.cursor[0],state.cursor[1]); ctx.stroke();
        ctx.setLineDash([]);
        [state.calStart,state.cursor].forEach(function(pt){ ctx.beginPath(); ctx.arc(pt[0],pt[1],5,0,Math.PI*2); ctx.fillStyle='#1d1d1f'; ctx.fill(); });
      }
      ctx.restore();
    }
    if(view3d && tex3d && !texMode){ renderTex(); tex3d.needsUpdate=true; }
    if(!texMode && ctx===mainCtx) snapCache();
  }

  function drawWatermark(){
    if(!(logoImg.complete && logoImg.naturalWidth)) return;
    var trW=(window.devicePixelRatio||1)*exportSS;
    ctx.setTransform(trW,0,0,trW,0,0);
    var lwm=110, gap=190;
    ctx.save();
    ctx.globalAlpha=0.09;
    var row=0;
    for(var wy=-lwm; wy<ch()+gap; wy+=gap, row++){
      var off=(row%2)?gap/2:0;
      for(var wx=-lwm+off; wx<cw()+gap; wx+=gap){
        ctx.drawImage(logoImg, wx, wy, lwm, lwm);
      }
    }
    ctx.restore();
  }

  var stepPanels=[];
  function openStep(i, scroll){
    if(i===3){
      stepPanels.forEach(function(p,j){ p.classList.toggle('is-open', j===3); });
    } else {
      if(stepPanels[3]) stepPanels[3].classList.remove('is-open');
      if(stepPanels[i]) stepPanels[i].classList.add('is-open');
    }
    if(scroll && stepPanels[i]){ try{ stepPanels[i].scrollIntoView({behavior:'smooth', block:'nearest'}); }catch(eS){} }
  }
  var STEP_DESC=[
    'Ladda upp din ritning och sätt skalan – valfritt',
    'Rita på ritytan eller skriv in mått',
    'Sortering, mönster, fris och stavmått',
    'Antal paket, pris och beställning'
  ];
  function loadDemo(){
    var W=cw(), H=ch();
    // sätt templatet INNAN rummen skapas så de ärver demo-stilen
    state.sort='select'; state.pattern='fiskben'; state.rotation=45; state.fris=true; state.lopband=true;
    function mk(nm,x0,y0,x1,y1){ var r=newRoom(nm); r.points=[[x0,y0],[x1,y0],[x1,y1],[x0,y1]]; r.closed=true; r.openings=[]; return r; }
    state.rooms=[ mk('Rum 1', W*0.08,H*0.10,W*0.46,H*0.46), mk('Rum 2', W*0.08,H*0.54,W*0.62,H*0.92) ];
    state.active=0;
    state.wallM=5; var wEl=$('nwfd-wall'); if(wEl) wEl.value='5';
    var rEl=$('nwfd-rot'); if(rEl) rEl.value=0;
    updateRotVal();
    buildDims();
    setTool('edit');
    fitView();
    refresh();
    syncScopeUI();
    openStep(1,false);
    track('golvdesigner_demo');
  }

  function styleScope(){ return 'room'; } // alla stilval är per-rum nu
  // Byt aktivt rum och uppdatera panel + ritning
  function selectRoom(rmRef){
    pruneKeep(rmRef);
    state.active=Math.max(0, state.rooms.indexOf(rmRef));
    state.rectStart=null;
    buildDims();
    draw(); roomsUI(); hint(); syncScopeUI(); calc(); save();
    // öppna "Golv & stil" för just det valda rummet
    var rmS=room(); if(rmS && rmS.closed) openStep(2,false);
  }
  function syncScopeUI(){
    var sc=$('nwfd-scope');
    var closedS=state.rooms.filter(function(r){return r.closed;});
    if(sc) sc.style.display = closedS.length ? '' : 'none';
    var tabs=$('nwfd-scopetabs');
    if(tabs){
      tabs.innerHTML='';
      state.rooms.forEach(function(r,i){
        if(!r.closed) return;
        var b=document.createElement('button');
        b.type='button';
        b.className='nwfd-scopetab'+(i===state.active?' is-active':'');
        b.textContent=r.name;
        b.setAttribute('data-tip', 'Redigera '+r.name+' – rummet markeras på ritningen. Varje rum har egna inställningar.');
        b.addEventListener('click', function(){ selectRoom(r); });
        tabs.appendChild(b);
      });
    }
    var gn=$('nwfd-globalnote'); if(gn) gn.style.display='none';
    // spegla aktivt rums stil i panelens kontroller
    var t=styleTarget();
    document.querySelectorAll('.nwfd-sort').forEach(function(b){ b.classList.toggle('is-active', b.getAttribute('data-sort')===t.sort); });
    document.querySelectorAll('.nwfd-pattern').forEach(function(b){ b.classList.toggle('is-active', b.getAttribute('data-pattern')===t.pattern); });
    var base=(t.pattern==='fiskben')?45:0, rel=((t.rotation-base)%360+360)%360;
    var rEl2=$('nwfd-rot'); if(rEl2) rEl2.value=rel;
    var rv=document.getElementById('nwfd-rotval'); if(rv) rv.textContent=rel+'°';
    var fb=$('nwfd-fris'); if(fb) fb.checked=!!t.fris;
    var lb2=$('nwfd-lopband'); if(lb2){ lb2.checked=!!(t.fris&&t.lopband); lb2.disabled=!t.fris; }
  }

  var histU=[], histR=[], histLast=null, histMuting=false;
  function updateHistBtns(){ var r=$('nwfd-redo'); if(r) r.disabled=!histR.length; var u=$('nwfd-undo'); if(u){ var rmH=room(); u.disabled = !histU.length && !state.rectStart && !(rmH && !rmH.closed && rmH.points.length); } }
  function histSnap(){
    if(histMuting) return;
    var snap=JSON.stringify(state.rooms);
    if(snap===histLast) return;
    if(histLast!==null){ histU.push(histLast); if(histU.length>60) histU.shift(); histR.length=0; }
    histLast=snap;
    updateHistBtns();
  }
  function histApply(snap){
    histMuting=true;
    try{
      state.rooms=JSON.parse(snap);
      if(state.active>=state.rooms.length) state.active=Math.max(0,state.rooms.length-1);
      histLast=snap;
      refresh();
    } finally { histMuting=false; }
    updateHistBtns();
  }
  function histUndo(){ if(!histU.length) return; histR.push(histLast); histApply(histU.pop()); }
  function histRedo(){ if(!histR.length) return; histU.push(histLast); histApply(histR.pop()); }

  var stepPrevClosed=null;
  function updateSteps(){
    if(!stepPanels.length) return;
    var sc=scaleMperPx();
    var closed=state.rooms.filter(function(r){return r.closed;});
    var m2=0; if(sc) closed.forEach(function(r){ m2+=polyAreaPx(r.points)*sc*sc; });
    var d=null; try{ d=calcData(); }catch(eU){}
    var sums=[
      (state.calMperPx ? ((state.img?'Ritning uppladdad · ':'')+'kalibrerad skala ✓') : (state.wallM ? ((state.img?'Ritning uppladdad · ':'')+'längsta vägg '+fmt(state.wallM,1)+' m') : '')),
      closed.length ? (closed.length+' rum'+(sc?(' · '+fmt(m2,1)+' m²'):'')) : '',
      '',
      d ? (fmt(d.need,1)+' m² · '+d.pktTotal+' paket · '+fmt(d.price)+' kr') : ''
    ];
    if(closed.length){
      var ts=styleTarget();
      function styleSig(r){ var s=rstyle(r); return [s.sort,s.pattern,s.rotation,s.fris,s.lopband,s.dimFloor,s.dimFris,s.dimLb].join(','); }
      var mixed = closed.length>1 && closed.some(function(r){ return styleSig(r)!==styleSig(closed[0]); });
      sums[2]=(SORT_LABEL[ts.sort]||'')+' · '+(PATTERN_LABEL[ts.pattern]||'Fiskben')+' · '+rotRel()+'°'+(ts.fris?(ts.lopband?' · fris + listband':' · fris'):'')+(mixed?' · blandat per rum':'');
    }
    var done=[(!!state.wallM || !!state.calMperPx), closed.length>0, closed.length>0, !!d];
    var dB=$('nwfd-demo'); if(dB) dB.style.display = closed.length? 'none':'';
    var calS=$('nwfd-calstatus'), calBt=$('nwfd-calbtn');
    if(calS){
      if(state.calMperPx){ calS.textContent='Skala kalibrerad ✓'; calS.classList.add('is-done'); if(calBt) calBt.textContent='⊾ Kalibrera om'; }
      else { calS.textContent='Steg 1: kalibrera för att få mått'; calS.classList.remove('is-done'); if(calBt) calBt.textContent='⊾ Kalibrera skalan'; }
    }
    var tStep=styleTarget();
    var fw=$('nwfd-dimwrap-fris'); if(fw) fw.style.display=tStep.fris?'':'none';
    var lw=$('nwfd-dimwrap-lb'); if(lw) lw.style.display=(tStep.fris&&tStep.lopband)?'':'none';
    syncScopeUI();
    var mb=$('nwfd-mbar');
    if(mb){
      if(d){ mb.hidden=false; $('nwfd-mbar-m2').textContent=fmt(d.need,1)+' m² · '+d.pktTotal+' paket'; $('nwfd-mbar-price').textContent='Ca '+fmt(d.price)+' kr'; }
      else mb.hidden=true;
    }
    stepPanels.forEach(function(p,i){
      var sm=p.querySelector('.nwfd-stepsum'); if(sm){ sm.textContent=sums[i]; sm.classList.toggle('has', !!sums[i]); }
      var ds=p.querySelector('.nwfd-stepdesc'); if(ds) ds.style.display=sums[i]?'none':'';
      var lb=p.querySelector('.nwfd-label'); if(lb) lb.classList.toggle('is-done', !!done[i]);
    });
    if(stepPrevClosed!==null && stepPrevClosed===0 && closed.length>0) openStep(2,false);
    stepPrevClosed=closed.length;
  }

  function setupSteps(){
    stepPanels=[].slice.call(document.querySelectorAll('.nwfd-grid .nwfd-panel'));
    if(stepPanels.length) stepPanels[0].parentElement.classList.add('nwfd-stepswrap');
    stepPanels.forEach(function(p,i){
      var head=p.querySelector('.nwfd-label');
      if(!head) return;
      var body=document.createElement('div');
      body.className='nwfd-body';
      var n=head.nextSibling;
      while(n){ var nx=n.nextSibling; body.appendChild(n); n=nx; }
      var mN=head.textContent.match(/^\s*(\d)\s*·\s*(.*)$/);
      if(mN){
        head.textContent=mN[2];
        var nbm=document.createElement('span'); nbm.className='nwfd-stepnum'; nbm.textContent=mN[1];
        head.insertBefore(nbm, head.firstChild);
      }
      var sum=document.createElement('p'); sum.className='nwfd-stepsum';
      var dsc=document.createElement('p'); dsc.className='nwfd-stepdesc'; dsc.textContent=STEP_DESC[i]||'';
      p.appendChild(sum); p.appendChild(dsc); p.appendChild(body);
      head.classList.add('nwfd-stephead');
      var chv=document.createElement('span'); chv.className='nwfd-chev'; head.appendChild(chv);
      head.addEventListener('click', function(){
        var willOpen=!p.classList.contains('is-open');
        if(willOpen && i===3){ stepPanels.forEach(function(pp,jj){ pp.classList.toggle('is-open', jj===3); }); return; }
        if(willOpen && i!==3 && stepPanels[3]) stepPanels[3].classList.remove('is-open');
        p.classList.toggle('is-open');
      });
    });
    openStep(0, false);
  }

  /* ============ UI ============ */
  function roomsUI(){
    var box=$('nwfd-rooms'); if(!box) return;
    box.innerHTML='';
    var scale=scaleMperPx();
    state.rooms.forEach(function(rm,i){
      var chip=document.createElement('button');
      chip.type='button';
      chip.className='nwfd-roomrow'+(i===state.active?' is-active':'');
      var m2txt = rm.closed ? (scale? fmt(polyAreaPx(rm.points)*scale*scale,1)+' m²' : '–') : 'ritar…';
      chip.innerHTML='<span class="nwfd-roomname">'+rm.name+'</span><span class="nwfd-roomm2">'+m2txt+'</span>';
      chip.addEventListener('click', function(){ selectRoom(state.rooms[i]); });
      if(rm.closed){
        var ren=document.createElement('span');
        ren.className='nwfd-roomren'; ren.textContent='✎'; ren.title='Byt namn på rummet';
        ren.addEventListener('click', function(ev){ ev.stopPropagation(); openRenameModal(state.rooms[i]); });
        chip.appendChild(ren);
      }
      var del=document.createElement('span');
      del.className='nwfd-roomdel'; del.textContent='×';
      del.addEventListener('click', function(ev){ ev.stopPropagation(); deleteRoom(i); });
      chip.appendChild(del);
      box.appendChild(chip);
    });
    renderAppRooms();
  }

  // In-app rums-panel på ritytan – klick öppnar Golv & stil-guiden för rummet
  function renderAppRooms(){
    var box=$('nwfd-approoms'); if(!box) return;
    box.innerHTML='';
    var scale=scaleMperPx();
    var closed=state.rooms.filter(function(r){return r.closed;});
    if(!closed.length){
      var e=document.createElement('p'); e.className='nwfd-roompanel-hint';
      e.textContent='Inga rum än – rita ditt första rum på ritytan.';
      box.appendChild(e); return;
    }
    state.rooms.forEach(function(rm,i){
      if(!rm.closed) return;
      var row=document.createElement('button'); row.type='button';
      row.className='nwfd-approom'+(i===state.active?' is-active':'');
      var m2 = scale ? fmt(polyAreaPx(rm.points)*scale*scale,1)+' m²' : '–';
      row.innerHTML='<span class="nwfd-approom-name">'+escapeHtml(rm.name)+'</span><span class="nwfd-approom-m2">'+m2+'</span>';
      row.addEventListener('click', function(){ state.active=i; draw(); openRoomModal(rm,false); });
      var del=document.createElement('span'); del.className='nwfd-approom-del'; del.textContent='×'; del.title='Ta bort rummet';
      del.addEventListener('click', function(ev){ ev.stopPropagation(); deleteRoom(i); });
      row.appendChild(del);
      box.appendChild(row);
    });
  }

  function hint(){
    var h=$('nwfd-hint'); var rm=room();
    var mc=$('nwfd-mode');
    if(mc){
      var mm={edit:['REDIGERA','nwfd-mode--edit'],rect:['RITA · REKTANGEL','nwfd-mode--draw'],poly:['RITA · FRIHAND','nwfd-mode--draw'],cal:['KALIBRERA · DRA LÄNGS EN VÄGG','nwfd-mode--draw']}[state.tool]||['',''];
      mc.textContent=mm[0];
      mc.className='nwfd-mode '+mm[1];
    }
    if(state.tool==='edit'){
      h.textContent='Dra i flytt-handtaget (✥) i mitten för att flytta hela rummet. Dra i ett hörn (vit fyrkant) eller mitt på en vägg (vit prick) för att ändra formen. Dra på tom yta för att panorera.';
    } else if(state.tool==='cal'){
      h.textContent='Klicka, dra längs en vägg du vet längden på och släpp. Sen skriver du in måttet i meter – då får alla rum rätt mått.';
    } else if(state.tool==='rect'){
      h.textContent = state.rectStart ? 'Släpp – eller tryck på motsatt hörn – för att slutföra rummet.' : 'Klicka och dra ut rummet, eller klicka i två motsatta hörn. Högerklicka och dra för att flytta vyn.';
    } else {
      h.textContent = rm.points.length<3 ? 'Tryck för varje hörn (raka linjer snäpper). Högerklicka och dra för att flytta vyn.' : 'Tryck på första punkten (den vita) eller “Stäng yta”.';
    }
    var drB=$('nwfd-delroom');
    if(drB){
      var rmD=room();
      var showD=(state.tool==='edit' && rmD && rmD.closed);
      drB.style.display=showD?'':'none';
      if(showD){ var spD=drB.querySelector('span'); if(spD) spD.textContent='Ta bort '+rmD.name; }
    }
    var cb2=$('nwfd-close');
    if(cb2){ cb2.style.display = state.tool==='poly' ? '' : 'none'; cb2.disabled = rm.closed || rm.points.length<3; }
    var nrB=$('nwfd-newroom'); if(nrB) nrB.disabled = !rm.closed;
    var tHint=styleTarget();
    var lbEl=$('nwfd-lopband'); if(lbEl) lbEl.disabled = !tHint.fris;
    // riktnings-reglaget på editorn: visa när man redigerar ett färdigt rum
    var srB=$('nwfd-stage-rot');
    if(srB){
      var showRot=(state.tool==='edit' && rm && rm.closed);
      srB.style.display=showRot?'':'none';
      if(showRot){ var rel=rotRel(); var ss2=$('nwfd-stage-rotslider'); if(ss2) ss2.value=rel; var sv2=$('nwfd-stage-rotval'); if(sv2) sv2.textContent=rel+'°'; }
    }
    // kalibrera-uppmaning på ritytan: visa tills skalan satts (dölj under själva kalibreringen)
    var scB=$('nwfd-stage-cal');
    if(scB) scB.style.display = (!scaleMperPx() && state.tool!=='cal') ? '' : 'none';
  }

  function buildDims(){
    var t=styleTarget(); var tsort=t.sort||'natur';
    var defs=[['nwfd-pick-floor','dimFloor'],['nwfd-pick-fris','dimFris'],['nwfd-pick-lb','dimLb']];
    var order=[5,4,3,2,-1,0,1]; // 68 mm stigande · avdelare · 50 mm
    defs.forEach(function(d){
      var box=$(d[0]); if(!box) return;
      box.innerHTML='';
      var row=document.createElement('div'); row.className='nwfd-planks';
      order.forEach(function(idx){
        if(idx<0){ var sep=document.createElement('span'); sep.className='nwfd-planksep'; row.appendChild(sep); return; }
        var v=VARIANTS[tsort][idx], g=DIMS[idx];
        var b=document.createElement('button');
        b.type='button';
        b.className='nwfd-plank'+(t[d[1]]===idx?' is-active':'');
        if(d[0]==='nwfd-pick-fris' && (idx===4||idx===5)) b.className+=' is-rec';
        b.style.height=Math.round(30+(g.l/408)*46)+'px';
        b.style.width=(g.w===68?30:24)+'px';
        b.innerHTML='<span>'+g.w+'×'+g.l+'</span>';
        b.setAttribute('data-tip', v.t+' mm · '+fmt(v.price)+' kr/paket · '+fmt(Math.round(v.price/v.m2))+' kr/m²');
        b.addEventListener('click', function(){
          setStyle(d[1], idx);
          buildDims(); draw(); calc(); save();
        });
        row.appendChild(b);
      });
      box.appendChild(row);
      var v2=VARIANTS[tsort][t[d[1]]]||VARIANTS[tsort][0];
      var info=document.createElement('div');
      info.className='nwfd-plankinfo';
      info.textContent=v2.t+' mm · '+fmt(v2.price)+' kr/paket · '+fmt(v2.m2,2)+' m²/paket · '+fmt(Math.round(v2.price/v2.m2))+' kr/m²';
      box.appendChild(info);
      if(d[0]==='nwfd-pick-fris'){ var tipF=document.createElement('div'); tipF.className='nwfd-rectip'; tipF.textContent='Rekommenderat för fris: 68×204 eller 68×272 – kortare stavar följer rummets form bäst.'; box.appendChild(tipF); }
      var sumEl=document.getElementById('nwfd-dimval-'+d[0].replace('nwfd-pick-',''));
      if(sumEl){ var gS=DIMS[t[d[1]]]||DIMS[0]; sumEl.textContent=gS.w+'×'+gS.l+' mm · '+fmt(v2.price)+' kr/paket'; }
    });
    Object.keys(VARIANTS).forEach(function(sk){
      var pEl=document.querySelector('.nwfd-sort[data-sort="'+sk+'"] .nwfd-sort-price');
      if(pEl){
        var minKm2=Infinity;
        VARIANTS[sk].forEach(function(vS){ var k=vS.price/vS.m2; if(k<minKm2) minKm2=k; });
        pEl.textContent='fr. '+fmt(Math.round(minKm2))+' kr/m²';
      }
    });
  }

  /* ============ CALC + CART + PDF ============ */
  function calcData(){
    var scale=scaleMperPx();
    if(!scale) return null;
    var sp=(typeof state.spill==='number')?state.spill:0.10;
    var rooms=[];
    var buckets={}; // nyckel: sort|dimIdx|label  → summerad yta (slås ihop över rum med samma material)
    function bucket(sort, dimIdx, label, area, spill){
      if(area<=0.01) return;
      var key=sort+'|'+dimIdx+'|'+label;
      if(!buckets[key]) buckets[key]={sort:sort, dimIdx:dimIdx, label:label, area:0, spill:spill};
      buckets[key].area += area;
    }
    state.rooms.forEach(function(rm){
      if(!rm.closed || rm.points.length<3) return;
      var st=rstyle(rm);
      var fr=DIMS[st.dimFris]||DIMS[0], lb=DIMS[st.dimLb]||DIMS[0];
      var frisW=Math.max(10,(fr.l/1000)/scale), bandW=Math.max(4,(lb.w/1000)/scale);
      var outerA=polyAreaPx(rm.points)*scale*scale;
      rooms.push({name:rm.name, m2:outerA, sort:st.sort});
      var floorA, frisA=0, lbA=0;
      if(st.fris){
        var a1=Math.max(0, polyAreaPx(insetPoly(rm.points, frisW))*scale*scale);
        frisA=Math.max(0, outerA-a1);
        if(st.lopband){
          var a2=Math.max(0, polyAreaPx(insetPoly(rm.points, frisW+bandW))*scale*scale);
          lbA=Math.max(0, a1-a2);
          floorA=a2;
        } else { floorA=a1; }
      } else { floorA=outerA; }
      bucket(st.sort, st.dimFloor, 'Golv', floorA, sp);
      if(st.fris) bucket(st.sort, st.dimFris, 'Fris', frisA, Math.max(sp,0.15));
      if(st.fris && st.lopband) bucket(st.sort, st.dimLb, 'Listband', lbA, Math.max(sp,0.15));
    });
    if(!rooms.length) return null;
    var parts=[];
    Object.keys(buckets).forEach(function(k){
      var bk=buckets[k];
      var v=VARIANTS[bk.sort][bk.dimIdx]||VARIANTS[bk.sort][0];
      var need=bk.area*(1+bk.spill);
      var pkt=Math.ceil(need/v.m2);
      parts.push({label:bk.label, sort:bk.sort, area:bk.area, spill:bk.spill, need:need, pkt:pkt, v:v, price:pkt*v.price});
    });
    if(!parts.length) return null;
    // sortera: Golv, Fris, Listband – och inom varje typ efter sortering
    var ord={'Golv':0,'Fris':1,'Listband':2};
    parts.sort(function(a,b){ return (ord[a.label]-ord[b.label]) || (a.sort<b.sort?-1:1); });
    var need=0, price=0, pktTotal=0, total=0;
    parts.forEach(function(pt){ need+=pt.need; price+=pt.price; pktTotal+=pt.pkt; });
    rooms.forEach(function(r){ total+=r.m2; });
    if(total<=0 || !isFinite(total)) return null;
    // sorts: unik lista av sorteringar som används (för rubriker)
    var sortSet={}; rooms.forEach(function(r){ sortSet[r.sort]=1; });
    var sorts=Object.keys(sortSet);
    var sortLabel = sorts.length===1 ? (SORT_LABEL[sorts[0]]||'') : 'blandat';
    return { rooms:rooms, total:total, parts:parts, need:need, price:price, pktTotal:pktTotal, sorts:sorts, sortLabel:sortLabel };
  }

  function calc(){
    updateSteps();
    var box=$('nwfd-result'); if(!box) return;
    var pf=$('nwfd-pick-fris'), pl=$('nwfd-pick-lb');
    var tCalc=styleTarget();
    if(pf) pf.classList.toggle('is-disabled', !tCalc.fris);
    if(pl) pl.classList.toggle('is-disabled', !(tCalc.fris&&tCalc.lopband));
    var d=calcData();
    var em=$('nwfd-empty');
    if(!d){ box.style.display='none'; if(em) em.style.display=''; $('nwfd-cart').disabled=true; var pb0=$('nwfd-pdf'); if(pb0) pb0.disabled=true; var fp0=$('nwfd-floatprice'); if(fp0) fp0.hidden=true; return; }
    box.style.display='block';
    if(em) em.style.display='none';
    var rows=$('nwfd-r-rooms');
    rows.innerHTML='';
    d.rooms.forEach(function(r){
      var div=document.createElement('div');
      div.className='nwfd-rrow';
      div.innerHTML='<span>'+r.name+'</span><strong>'+fmt(r.m2,1)+' m²</strong>';
      rows.appendChild(div);
    });
    d.parts.forEach(function(pt){
      var div=document.createElement('div');
      div.className='nwfd-rrow';
      div.innerHTML='<span>'+pt.label+(d.sorts.length>1?(' · '+SORT_LABEL[pt.sort]):'')+' · '+pt.v.t+'</span><strong>'+fmt(pt.need,1)+' m² · '+pt.pkt+' pkt</strong>';
      rows.appendChild(div);
    });
    $('nwfd-r-need').textContent=fmt(d.need,1)+' m² (inkl spill)';
    $('nwfd-r-pkt').textContent=d.pktTotal+' paket · '+d.sortLabel;
    $('nwfd-r-price').textContent=fmt(d.price)+' kr';
    var wEl=$('nwfd-r-weight'); if(wEl) wEl.textContent='ca '+fmt(d.need*13)+' kg';
    $('nwfd-cart').disabled=false;
    var pb=$('nwfd-pdf'); if(pb) pb.disabled=false;
    var fp=$('nwfd-floatprice');
    if(fp){
      fp.hidden=false;
      $('nwfd-fp-price').textContent=fmt(d.price)+' kr';
      $('nwfd-fp-sub').textContent=(d.rooms.length>1?(d.rooms.length+' rum · '):'')+fmt(d.need,1)+' m² (inkl spill) · '+d.pktTotal+' paket · '+d.sortLabel;
      var fc=$('nwfd-fp-cart'); if(fc) fc.disabled=false;
      var fpp=$('nwfd-fp-pdf'); if(fpp) fpp.disabled=false;
      // detaljerad beräkning (visas/döljs via "Visa beräkning")
      var fpRows=$('nwfd-fp-rows');
      if(fpRows){
        var rrH=d.rooms.map(function(r){ return '<div class="nwfd-fp-rrow"><span>'+escapeHtml(r.name)+(d.sorts.length>1?(' · '+(SORT_LABEL[r.sort]||'')):'')+'</span><strong>'+fmt(r.m2,1)+' m²</strong></div>'; }).join('');
        var prH=d.parts.map(function(pt){ return '<div class="nwfd-fp-rrow"><span>'+pt.label+(d.sorts.length>1?(' · '+SORT_LABEL[pt.sort]):'')+' · '+pt.v.t+'</span><strong>'+fmt(pt.need,1)+' m² · '+pt.pkt+' pkt</strong></div>'; }).join('');
        fpRows.innerHTML=rrH+'<div style="height:.4rem"></div>'+prH;
      }
      var fpSpills=$('nwfd-fp-spills');
      if(fpSpills){
        var spF=(typeof state.spill==='number')?state.spill:0.10;
        fpSpills.innerHTML=[0.05,0.10,0.15].map(function(v){ return '<button type="button" data-v="'+v+'"'+(Math.abs(spF-v)<0.001?' class="is-active"':'')+'>'+Math.round(v*100)+' %</button>'; }).join('');
        [].slice.call(fpSpills.querySelectorAll('button')).forEach(function(b){ b.addEventListener('click', function(){ state.spill=parseFloat(b.getAttribute('data-v')); refresh(); }); });
      }
    }
  }

  function addToCart(){
    var d=calcData(); if(!d) return;
    var byId={};
    d.parts.forEach(function(pt){ byId[pt.v.id]=(byId[pt.v.id]||0)+pt.pkt; });
    var items=Object.keys(byId).map(function(id){ return {id:parseInt(id,10), quantity:byId[id]}; });
    var btn=$('nwfd-cart');
    btn.disabled=true; btn.textContent='Lägger till…';
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:items, sections:'cart-drawer,cart-icon-bubble'})
    }).then(function(r){
      if(!r.ok) throw 0;
      return r.json();
    }).then(function(data){
      track('golvdesigner_add_to_cart', {value:d.price, currency:'SEK'});
      var drw=document.querySelector('cart-drawer');
      if(drw && data && data.sections && typeof drw.renderContents==='function'){
        drw.classList.remove('is-empty');
        drw.renderContents(data);
        requestAnimationFrame(function(){ drw.classList.remove('is-empty'); });
        btn.disabled=false; btn.textContent='Lägg i varukorgen';
        var fcA=$('nwfd-fp-cart'); if(fcA) fcA.disabled=false;
      } else {
        window.location.href='/cart';
      }
    }).catch(function(){
      btn.disabled=false; btn.textContent='Lägg i varukorgen';
      alert('Kunde inte lägga i varukorgen – prova igen eller ring 073-985 84 46.');
    });
  }

  function exportPDF(){
    var d=calcData(); if(!d) return;
    track('golvdesigner_pdf');
    var png='';
    try{
      var SSp=Math.max(1, Math.min(3, 4096/Math.max(canvas.width, canvas.height)));
      var keepV={z:view.z, ox:view.ox, oy:view.oy};
      var ptsF=[];
      state.rooms.forEach(function(r){ if(r.closed) ptsF=ptsF.concat(r.points); });
      if(state.img && state.imgRect){
        ptsF.push([state.imgRect.x, state.imgRect.y],[state.imgRect.x+state.imgRect.w, state.imgRect.y+state.imgRect.h]);
      }
      if(ptsF.length){
        var mnx=Infinity,mny=Infinity,mxx=-Infinity,mxy=-Infinity;
        ptsF.forEach(function(q){ mnx=Math.min(mnx,q[0]); mny=Math.min(mny,q[1]); mxx=Math.max(mxx,q[0]); mxy=Math.max(mxy,q[1]); });
        var padF=24, bwF=mxx-mnx+padF*2, bhF=mxy-mny+padF*2;
        view.z=Math.min(cw()/bwF, ch()/bhF);
        view.ox=(cw()-(mnx+mxx)*view.z)/2;
        view.oy=(ch()-(mny+mxy)*view.z)/2;
      }
      var pc=document.createElement('canvas');
      pc.width=Math.round(canvas.width*SSp); pc.height=Math.round(canvas.height*SSp);
      var pctx=pc.getContext('2d');
      var keepP=ctx; ctx=pctx; exportSS=SSp;
      try{ draw(); } finally { ctx=keepP; exportSS=1; view.z=keepV.z; view.ox=keepV.ox; view.oy=keepV.oy; }
      png=pc.toDataURL('image/png');
      draw();
    }catch(e){ try{ png=canvas.toDataURL('image/png'); }catch(e2){ png=''; } }
    var roomRows=d.rooms.map(function(r){ return '<div class="row"><span>'+r.name+(d.sorts.length>1?(' · '+(SORT_LABEL[r.sort]||'')):'')+'</span><strong>'+fmt(r.m2,1)+' m²</strong></div>'; }).join('');
    var partRows=d.parts.map(function(pt){ return '<div class="row"><span>'+pt.label+' · '+(SORT_LABEL[pt.sort]||'')+' '+pt.v.t+' mm</span><strong>'+fmt(pt.need,1)+' m² · '+pt.pkt+' paket</strong></div>'; }).join('');
    var patsP={}, anyFrisP=false, anyLbP=false;
    state.rooms.forEach(function(r){ if(r.closed){ var s=rstyle(r); patsP[s.pattern]=1; if(s.fris) anyFrisP=true; if(s.fris&&s.lopband) anyLbP=true; } });
    var patTxtP=Object.keys(patsP).map(function(p){return PATTERN_LABEL[p]||'Fiskben';}).join(' / ')||'Fiskben';
    var html='<!DOCTYPE html><html lang="sv"><head><meta charset="utf-8"><title>Nobile Wood – Golvplan</title>'+
      '<style>body{font-family:Inter,system-ui,sans-serif;color:#1d1d1f;max-width:720px;margin:24px auto;padding:0 16px}'+
      'h1{font-size:20px;letter-spacing:.12em;text-transform:uppercase;font-weight:600}'+
      '.k{font-size:10px;letter-spacing:.3em;text-transform:uppercase;color:#888;font-weight:700}'+
      '.plan{width:100%;border:1px solid #e5e7eb;border-radius:10px;margin:14px 0}'+
      '.logo{width:60px;height:60px;display:block;margin:0 0 10px}'+
      '.row{display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid #eee;font-size:14px}'+
      '.sum{font-size:16px;font-weight:700;border-bottom:none}'+
      '.note{color:#888;font-size:12px;margin-top:14px;line-height:1.5}'+
      '@media print{button{display:none}}</style></head><body>'+
      '<img class="logo" src="https://cdn.shopify.com/s/files/1/0903/6762/3554/files/nobilelogo.png?v=1745844351" alt="Nobile Wood">'+
      '<p class="k">Nobile Wood · Golvdesigner</p><h1>Din golvplan</h1>'+
      (png?('<img class="plan" src="'+png+'">'):'')+
      roomRows+
      partRows+
      '<div class="row"><span>Mönster</span><strong>'+patTxtP+(anyFrisP?' + fris':'')+(anyLbP?' + listband':'')+'</strong></div>'+
      '<div class="row"><span>Totalt behov inkl spill</span><strong>'+fmt(d.need,1)+' m²</strong></div>'+
      '<div class="row"><span>Antal paket</span><strong>'+d.pktTotal+'</strong></div>'+
      '<div class="row sum"><span>Ca pris</span><strong>'+fmt(d.price)+' kr</strong></div>'+
      '<p class="note">Uppskattning från ritningen – exakt åtgång bekräftas i offert. Nobile Wood · 073-985 84 46 · nobilewood.com</p>'+
      '<button onclick="window.print()" style="margin-top:14px;padding:10px 22px;border-radius:999px;border:1px solid #1d1d1f;background:#1d1d1f;color:#fff;font-weight:600;cursor:pointer">Skriv ut / spara som PDF</button>'+
      '</body></html>';
    var w=window.open('','_blank');
    if(w){ w.document.write(html); w.document.close(); }
  }

  /* ============ 3D VIEW ============ */
  function loadScript(src, cb){
    var sc=document.createElement('script');
    sc.src=src; sc.onload=function(){cb(true);}; sc.onerror=function(){cb(false);};
    document.head.appendChild(sc);
  }
  function ensureThree(cb){
    if(window.THREE && window.THREE.OrbitControls){ cb(true); return; }
    loadScript('https://unpkg.com/three@0.128.0/build/three.min.js', function(ok){
      if(!ok){ cb(false); return; }
      loadScript('https://unpkg.com/three@0.128.0/examples/js/controls/OrbitControls.js', function(ok2){ cb(!!ok2); });
    });
  }
  function renderTex(){
    if(!texCanvas) return;
    var octx=texCanvas.getContext('2d');
    var dpr=(window.devicePixelRatio||1)*(texCanvas._ss||1);
    octx.setTransform(dpr,0,0,dpr,0,0);
    var keep=ctx;
    ctx=octx; texMode=true;
    try{ draw(); } finally { texMode=false; ctx=keep; }
  }
  function build3D(){
    // is-3d har just gömt footern → ritytan (cbox) är nu högre. Mät om så 3D fyller hela ytan.
    sizeCanvas();
    var W=cw(), H=ch();
    var bMinX=Infinity,bMinY=Infinity,bMaxX=-Infinity,bMaxY=-Infinity;
    state.rooms.forEach(function(rB){ if(rB.closed) rB.points.forEach(function(pB){ bMinX=Math.min(bMinX,pB[0]); bMinY=Math.min(bMinY,pB[1]); bMaxX=Math.max(bMaxX,pB[0]); bMaxY=Math.max(bMaxY,pB[1]); }); });
    if(state.img && state.imgRect){
      bMinX=Math.min(bMinX,state.imgRect.x); bMinY=Math.min(bMinY,state.imgRect.y);
      bMaxX=Math.max(bMaxX,state.imgRect.x+state.imgRect.w); bMaxY=Math.max(bMaxY,state.imgRect.y+state.imgRect.h);
    }
    if(!isFinite(bMinX)){ bMinX=0; bMinY=0; bMaxX=W; bMaxY=H; }
    var padB=24;
    bMinX-=padB; bMinY-=padB; bMaxX+=padB; bMaxY+=padB;
    var BW=bMaxX-bMinX, BH=bMaxY-bMinY;
    var dprB=window.devicePixelRatio||1;
    texCanvas=document.createElement('canvas');
    var SS=Math.max(0.5, Math.min(2.5, 4096/(Math.max(BW,BH)*dprB)));
    texCanvas.width=Math.round(BW*dprB*SS); texCanvas.height=Math.round(BH*dprB*SS);
    texCanvas._ss=SS;
    texCanvas._ox=bMinX; texCanvas._oy=bMinY;
    renderTex();
    var wrapEl=$('nwfd-3dwrap');
    wrapEl.innerHTML='';
    renderer3d=new THREE.WebGLRenderer({antialias:true, alpha:true, preserveDrawingBuffer:true});
    renderer3d.setPixelRatio(window.devicePixelRatio||1);
    renderer3d.setSize(W,H);
    wrapEl.appendChild(renderer3d.domElement);
    scene3=new THREE.Scene();
    scene3.background=new THREE.Color(0xf2efe9);
    camera3=new THREE.PerspectiveCamera(45, W/H, 1, 9000);
    camera3.position.set(BW*0.5, BH*1.05, BH*1.25);
    controls3=new THREE.OrbitControls(camera3, renderer3d.domElement);
    controls3.target.set(BW/2, 0, BH/2);
    controls3.enableDamping=true;
    controls3.dampingFactor=0.08;
    controls3.maxPolarAngle=1.45;
    controls3.minDistance=140;
    controls3.maxDistance=2800;
    scene3.add(new THREE.HemisphereLight(0xffffff, 0x9a7c55, 0.8));
    var dl=new THREE.DirectionalLight(0xfff1de, 0.45);
    dl.position.set(BW*0.3, 700, BH*0.1);
    scene3.add(dl);
    var ground=new THREE.Mesh(new THREE.PlaneGeometry(BW*5, BH*5), new THREE.MeshStandardMaterial({color:0xe9e5dd, roughness:1}));
    ground.rotation.x=-Math.PI/2;
    ground.position.set(BW/2, -1.5, BH/2);
    scene3.add(ground);
    var gC=document.createElement('canvas');
    gC.width=Math.round(BW*dprB); gC.height=Math.round(BH*dprB);
    var gx=gC.getContext('2d');
    gx.setTransform(dprB,0,0,dprB,-bMinX*dprB,-bMinY*dprB);
    gx.fillStyle='#f7f5f1'; gx.fillRect(bMinX,bMinY,BW,BH);
    if(state.img && state.imgRect){
      gx.drawImage(state.img, state.imgRect.x, state.imgRect.y, state.imgRect.w, state.imgRect.h);
    }
    var gt=new THREE.CanvasTexture(gC);
    gt.anisotropy=renderer3d.capabilities.getMaxAnisotropy();
    var planMesh=new THREE.Mesh(new THREE.PlaneGeometry(BW,BH), new THREE.MeshBasicMaterial({map:gt}));
    planMesh.rotation.x=-Math.PI/2;
    planMesh.position.set(BW/2,-0.8,BH/2);
    scene3.add(planMesh);
    tex3d=new THREE.CanvasTexture(texCanvas);
    tex3d.anisotropy=renderer3d.capabilities.getMaxAnisotropy();
    var topMat=new THREE.MeshBasicMaterial({map:tex3d});
    var sideMat=new THREE.MeshStandardMaterial({color:0x7d5f3e, roughness:0.92});
    var depth=7;
    state.rooms.forEach(function(rm){
      if(!rm.closed || rm.points.length<3) return;
      var shape=new THREE.Shape(rm.points.map(function(pt){ return new THREE.Vector2(pt[0]-bMinX, BH-(pt[1]-bMinY)); }));
      var geo=new THREE.ExtrudeGeometry(shape, {depth:depth, bevelEnabled:false});
      var uv=geo.attributes.uv;
      for(var i=0;i<uv.count;i++){ uv.setXY(i, uv.getX(i)/BW, uv.getY(i)/BH); }
      var mesh=new THREE.Mesh(geo, [topMat, sideMat]);
      mesh.rotation.x=-Math.PI/2;
      mesh.position.z=BH;
      scene3.add(mesh);
    });
    (function loop(){
      anim3=requestAnimationFrame(loop);
      controls3.update();
      renderer3d.render(scene3, camera3);
    })();
  }
  function destroy3D(){
    if(anim3) cancelAnimationFrame(anim3);
    anim3=null;
    if(controls3){ controls3.dispose(); controls3=null; }
    if(renderer3d){ renderer3d.dispose(); renderer3d=null; }
    var wrapEl=$('nwfd-3dwrap'); if(wrapEl) wrapEl.innerHTML='';
    scene3=null; camera3=null; tex3d=null; texCanvas=null;
  }

  function shareDesign(){
    var o={rooms:state.rooms, sort:state.sort, pattern:state.pattern, rotation:state.rotation, fris:state.fris, lopband:state.lopband, dimFloor:state.dimFloor, dimFris:state.dimFris, dimLb:state.dimLb, wallM:state.wallM, imgRect:state.imgRect, spill:state.spill};
    var code=btoa(unescape(encodeURIComponent(JSON.stringify(o)))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
    var url=location.origin+location.pathname+'#d='+code;
    var b=$('nwfd-share');
    function done(ok){ if(b){ b.textContent= ok?'Länk kopierad ✓':'Kopiera delningslänk'; setTimeout(function(){ b.textContent='Kopiera delningslänk'; },2500);} var nS=$('nwfd-sharenote'); if(nS && state.img) nS.style.display='block'; }
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(url).then(function(){done(true);}, function(){ try{ prompt('Kopiera länken:', url); }catch(eP){} done(false); });
    } else { try{ prompt('Kopiera länken:', url); }catch(eP2){} }
    track('golvdesigner_share');
  }

  /* ============ MODAL (egna stilrena rutor – ersätter webbläsarens prompt/confirm) ============ */
  function escapeHtml(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  var modalRoot=null;
  function ensureModalCSS(){
    if(document.getElementById('nwfd-modal-css')) return;
    var css=''+
      '.nwfd-modal{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;padding:18px;'+
        'background:rgba(20,18,15,.55);backdrop-filter:blur(2px);opacity:0;transition:opacity .18s ease;}'+
      '.nwfd-modal.is-open{opacity:1;}'+
      '.nwfd-modal__card{background:#fff;color:#1d1d1f;width:100%;max-width:430px;max-height:92vh;overflow:auto;'+
        'border-radius:16px;padding:1.9rem 1.9rem 1.6rem;box-shadow:0 24px 70px rgba(0,0,0,.32);'+
        'font-family:var(--font-body-family,Inter,system-ui,sans-serif);transform:translateY(10px) scale(.985);transition:transform .18s ease;}'+
      '.nwfd-modal.is-open .nwfd-modal__card{transform:none;}'+
      '.nwfd-m-kicker{font-size:1rem;letter-spacing:.22em;text-transform:uppercase;color:#9a8f80;font-weight:700;margin:0 0 .4rem;}'+
      '.nwfd-m-title{font-size:1.55rem;font-weight:600;margin:0 0 1.1rem;line-height:1.2;}'+
      '.nwfd-m-body{font-size:1.2rem;color:#555;line-height:1.5;margin:0 0 1.2rem;}'+
      '.nwfd-m-lab{display:block;font-size:1.05rem;font-weight:600;letter-spacing:.02em;color:#1d1d1f;margin:1.1rem 0 .5rem;}'+
      '.nwfd-m-input{width:100%;border:1px solid #d8d8d8;border-radius:9px;padding:.9rem 1rem;font-size:1.25rem;'+
        'font-family:inherit;color:#1d1d1f;box-sizing:border-box;background:#fff;}'+
      '.nwfd-m-input:focus{outline:none;border-color:#1d1d1f;}'+
      'select.nwfd-m-input{appearance:none;-webkit-appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath d=%27M2 4l4 4 4-4%27 stroke=%27%231d1d1f%27 stroke-width=%271.5%27 fill=%27none%27/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 1rem center;padding-right:2.4rem;}'+
      '.nwfd-m-opts{display:grid;grid-template-columns:repeat(3,1fr);gap:.5rem;}'+
      '.nwfd-m-opt{border:2px solid #e5e7eb;background:#fff;border-radius:10px;padding:.7rem .4rem;font-size:1.1rem;'+
        'font-weight:600;letter-spacing:.03em;cursor:pointer;color:#1d1d1f;font-family:inherit;transition:border-color .12s,background .12s,color .12s;}'+
      '.nwfd-m-opt:hover{border-color:#b8b8bc;}'+
      '.nwfd-m-opt.is-active{border-color:#1d1d1f;background:#1d1d1f;color:#fff;}'+
      '.nwfd-m-checks{margin:1.2rem 0 .3rem;display:flex;flex-direction:column;gap:.7rem;}'+
      '.nwfd-m-check{display:flex;align-items:center;gap:.6rem;font-size:1.2rem;color:#1d1d1f;cursor:pointer;}'+
      '.nwfd-m-check input{width:18px;height:18px;accent-color:#1d1d1f;}'+
      '.nwfd-m-check input:disabled{opacity:.4;} .nwfd-m-check input:disabled + span{opacity:.4;}'+
      '.nwfd-m-actions{display:flex;gap:.7rem;margin-top:1.6rem;}'+
      '.nwfd-m-skip{flex:0 0 auto;border:1px solid #d4d4d8;background:#fff;color:#444;border-radius:999px;'+
        'padding:.85rem 1.4rem;font-size:1.15rem;font-weight:600;cursor:pointer;font-family:inherit;}'+
      '.nwfd-m-skip:hover{border-color:#9a9a9e;}'+
      '.nwfd-m-save{flex:1;background:#1d1d1f;color:#fff;border:0;border-radius:999px;padding:.85rem 1.4rem;'+
        'font-size:1.2rem;font-weight:600;cursor:pointer;font-family:inherit;}'+
      '.nwfd-m-save:hover{background:#000;}'+
      '.nwfd-m-save.nwfd-m-danger{background:#b3261e;} .nwfd-m-save.nwfd-m-danger:hover{background:#8f1d17;}'+
      // stegindikator
      '.nwfd-m-prog{display:flex;gap:.5rem;margin:0 0 1.3rem;}'+
      '.nwfd-m-dot{flex:1;height:4px;border-radius:3px;background:#e6e4df;transition:background .2s;}'+
      '.nwfd-m-dot.is-active{background:#1d1d1f;} .nwfd-m-dot.is-done{background:#9a8f80;}'+
      // återanvänder vänsterpanelens .nwfd-sorts/.nwfd-patterns/.nwfd-planks – små justeringar i modalen
      '.nwfd-modal__card .nwfd-sorts{display:grid;grid-template-columns:repeat(3,1fr);gap:.6rem;margin:0 0 .3rem;}'+
      '.nwfd-modal__card .nwfd-patterns{display:grid;grid-template-columns:repeat(3,1fr);gap:.6rem;margin:.2rem 0 1rem;}'+
      '.nwfd-modal__card .nwfd-sliderrow{display:flex;flex-direction:column;gap:.5rem;margin:.4rem 0 .2rem;font-size:1.15rem;color:#444;}'+
      '.nwfd-modal__card .nwfd-sliderrow input[type=range]{width:100%;accent-color:#1d1d1f;}'+
      '.nwfd-modal__card .nwfd-planks{display:flex;align-items:flex-end;justify-content:center;gap:.7rem;margin:.6rem 0 1rem;flex-wrap:wrap;}'+
      '.nwfd-modal__card .nwfd-plank span{font-size:1.05rem;}'+
      '.nwfd-modal__card .nwfd-plankinfo{font-size:1.08rem;color:#666;margin:.2rem 0 .4rem;text-align:center;}'+
      // hjälptext i varje steg
      '.nwfd-m-help{font-size:1.18rem;line-height:1.5;color:#6b6b6b;margin:0 0 1.2rem;}'+
      '.nwfd-m-help b{color:#1d1d1f;font-weight:600;}'+
      // swatch i förstasidans stil – hela fiskbensbilden med text-overlay, högre kort
      '.nwfd-sort-img{display:block;width:100%;aspect-ratio:3/4;background-size:cover;background-position:center;background-repeat:no-repeat;}'+
      // sorterings-beskrivning under varje kort
      '.nwfd-modal__card .nwfd-sort span{padding-bottom:.9rem;}'+
      '.nwfd-sort-desc{display:block;font-size:1.02rem;font-weight:400;letter-spacing:0;text-transform:none;color:#6b6b6b;line-height:1.35;margin-top:.35rem;padding:0 .3rem;}'+
      // varumärke: sorterings-titel svart (inte temats blå), pris grått
      '.nwfd-modal__card .nwfd-sort{color:#1d1d1f;}'+
      '.nwfd-modal__card .nwfd-sort-price{display:block;color:#8a8a8a;font-style:normal;font-weight:500;font-size:1rem;margin-top:.15rem;}'+
      // gemensamma popup-byggstenar (Ritning/Rum/Pris)
      '.nwfd-m-stack{display:flex;flex-direction:column;gap:.6rem;margin:.4rem 0;}'+
      '.nwfd-m-wide{width:100%;justify-content:center;text-align:center;}'+
      '.nwfd-m-ghost{background:#fff !important;color:#1d1d1f !important;border:1px solid #d4d4d8 !important;}'+
      '.nwfd-m-ghost:hover{background:#f5f4f0 !important;}'+
      // rumslista
      '.nwfd-mrooms{display:flex;flex-direction:column;gap:.5rem;margin:.4rem 0 .2rem;}'+
      '.nwfd-mroom{display:flex;align-items:center;gap:.8rem;width:100%;text-align:left;border:1px solid #e5e7eb;border-radius:10px;background:#fff;padding:.9rem 1.1rem;font-size:1.2rem;font-family:inherit;color:#1d1d1f;cursor:pointer;transition:border-color .12s;}'+
      '.nwfd-mroom:hover{border-color:#1d1d1f;}'+
      '.nwfd-mroom-name{font-weight:600;}'+
      '.nwfd-mroom-m2{margin-left:auto;color:#777;}'+
      '.nwfd-mroom-edit{color:#1d1d1f;font-weight:600;font-size:1.05rem;}'+
      // pris-popup
      '.nwfd-mp-total{text-align:center;background:#faf9f6;border:1px solid #eee;border-radius:12px;padding:1.2rem;margin:.2rem 0 1rem;display:flex;flex-direction:column;gap:.3rem;}'+
      '.nwfd-mp-price{font-size:2.4rem;font-weight:700;color:#1d1d1f;line-height:1.1;}'+
      '.nwfd-mp-sub{font-size:1.1rem;color:#666;}'+
      '.nwfd-mp-rows{margin:.2rem 0 .8rem;}'+
      '.nwfd-mp-row{display:flex;justify-content:space-between;gap:1rem;padding:.5rem 0;border-bottom:1px solid #f0eee9;font-size:1.12rem;}'+
      '.nwfd-mp-row strong{font-weight:700;white-space:nowrap;}'+
      '.nwfd-mp-sep{height:.6rem;}'+
      '.nwfd-mp-spillrow{display:flex;align-items:center;justify-content:space-between;gap:1rem;margin:.6rem 0;font-size:1.12rem;color:#444;}'+
      '.nwfd-mp-spills{display:flex;gap:.5rem;}'+
      '.nwfd-mp-spill{border:1px solid #d6d6d9;background:#fff;border-radius:8px;padding:.45rem .9rem;font-size:1.05rem;font-weight:600;cursor:pointer;font-family:inherit;color:#444;}'+
      '.nwfd-mp-spill.is-active{background:#1d1d1f;border-color:#1d1d1f;color:#fff;}';
    var st=document.createElement('style'); st.id='nwfd-modal-css'; st.textContent=css; document.head.appendChild(st);
  }
  function destroyModal(){ if(modalRoot && modalRoot.parentNode){ modalRoot.parentNode.removeChild(modalRoot); } modalRoot=null; }
  function closeModal(){
    if(!modalRoot) return;
    var m=modalRoot; modalRoot=null;
    m.classList.remove('is-open');
    setTimeout(function(){ if(m && m.parentNode) m.parentNode.removeChild(m); }, 190);
  }
  function buildModal(innerHTML){
    ensureModalCSS();
    destroyModal();
    var ov=document.createElement('div'); ov.className='nwfd-modal';
    ov.innerHTML='<div class="nwfd-modal__card" role="dialog" aria-modal="true">'+innerHTML+'</div>';
    document.body.appendChild(ov);
    modalRoot=ov;
    ov.addEventListener('click', function(e){ if(e.target===ov) closeModal(); });
    document.addEventListener('keydown', function esc(e){ if(e.key==='Escape'){ closeModal(); document.removeEventListener('keydown', esc); } });
    requestAnimationFrame(function(){ ov.classList.add('is-open'); });
    return ov;
  }

  /* ===== Interaktiv rundtur – pekar på de riktiga knapparna i appen ===== */
  function ensureTourCSS(){
    if(document.getElementById('nwfd-tour-css')) return;
    var css=''+
      '.nwfd-tour{position:fixed;inset:0;z-index:100000;pointer-events:auto;font-family:var(--font-body-family,Inter,system-ui,sans-serif);opacity:0;transition:opacity .2s ease;}'+
      '.nwfd-tour.is-in{opacity:1;}'+
      '.nwfd-tour__hole{display:block !important;position:fixed;border-radius:12px;box-shadow:0 0 0 9999px rgba(18,16,13,.62);transition:top .3s cubic-bezier(.4,0,.2,1),left .3s cubic-bezier(.4,0,.2,1),width .3s cubic-bezier(.4,0,.2,1),height .3s cubic-bezier(.4,0,.2,1);pointer-events:none;}'+
      '.nwfd-tour__ring{display:block !important;position:fixed;border:2.5px solid #fff;border-radius:13px;pointer-events:none;transition:top .3s cubic-bezier(.4,0,.2,1),left .3s cubic-bezier(.4,0,.2,1),width .3s cubic-bezier(.4,0,.2,1),height .3s cubic-bezier(.4,0,.2,1);animation:nwfd-tour-pulse 1.8s ease-in-out infinite;}'+
      '@keyframes nwfd-tour-pulse{0%,100%{box-shadow:0 0 0 0 rgba(255,255,255,.5)}50%{box-shadow:0 0 0 6px rgba(255,255,255,0)}}'+
      '.nwfd-tour__tip{position:fixed;width:316px;max-width:calc(100vw - 28px);background:#fff;color:#1d1d1f;border-radius:14px;padding:1.25rem 1.4rem 1.15rem;box-shadow:0 18px 50px rgba(0,0,0,.34);pointer-events:auto;transition:top .3s ease,left .3s ease;}'+
      '.nwfd-tour__arrow{position:absolute;width:15px;height:15px;background:#fff;transform:rotate(45deg);}'+
      '.nwfd-tour__kick{font-size:.95rem;letter-spacing:.16em;text-transform:uppercase;color:#9a8f80;font-weight:700;margin:0 0 .35rem;}'+
      '.nwfd-tour__title{font-size:1.42rem;font-weight:600;margin:0 0 .45rem;line-height:1.25;}'+
      '.nwfd-tour__body{font-size:1.18rem;color:#555;line-height:1.5;margin:0 0 1rem;}'+
      '.nwfd-tour__body b{color:#1d1d1f;font-weight:600;}'+
      // liten animerad demo överst i bubblan
      '.nwfd-tour__demo{height:128px;border-radius:10px;background:linear-gradient(180deg,#faf9f6,#eef0ea);overflow:hidden;margin:0 0 .95rem;}'+
      '.nwfd-tour__demo svg{width:100%;height:100%;display:block;}'+
      '.nwfd-td-cur{transform-box:fill-box;}'+
      '@keyframes nwfd-tdk-up{0%,8%{transform:translateY(40px);opacity:0}30%{transform:translateY(0);opacity:1}80%{opacity:1}92%,100%{opacity:0}}'+
      '.nwfd-td-up{transform-box:fill-box;animation:nwfd-tdk-up 3.4s ease-in-out infinite;}'+
      '@keyframes nwfd-tdk-arrow{0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)}}'+
      '.nwfd-td-arrow{transform-box:fill-box;animation:nwfd-tdk-arrow 1.3s ease-in-out infinite;}'+
      '@keyframes nwfd-tdk-grow{0%,5%{transform:scale(.001,.001);opacity:1}40%{transform:scale(1,1)}86%{transform:scale(1,1);opacity:1}94%{opacity:0}100%{transform:scale(.001,.001);opacity:0}}'+
      '.nwfd-td-room{transform-box:fill-box;transform-origin:0 0;animation:nwfd-tdk-grow 3.6s ease-in-out infinite;}'+
      '@keyframes nwfd-tdk-cur1{0%,5%{transform:translate(64px,30px)}40%{transform:translate(204px,96px)}100%{transform:translate(204px,96px)}}'+
      '.nwfd-td-cur1{animation:nwfd-tdk-cur1 3.6s ease-in-out infinite;}'+
      '@keyframes nwfd-tdk-draw{0%,14%{stroke-dashoffset:200}48%{stroke-dashoffset:0}90%{stroke-dashoffset:0}100%{stroke-dashoffset:200}}'+
      '.nwfd-td-mline{stroke-dasharray:200;stroke-dashoffset:200;animation:nwfd-tdk-draw 3.6s ease-in-out infinite;}'+
      '@keyframes nwfd-tdk-cur2{0%,14%{transform:translate(56px,82px)}48%{transform:translate(236px,82px)}100%{transform:translate(236px,82px)}}'+
      '.nwfd-td-cur2{animation:nwfd-tdk-cur2 3.6s ease-in-out infinite;}'+
      '@keyframes nwfd-tdk-pop{0%,52%{opacity:0;transform:scale(.5)}62%,90%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.5)}}'+
      '.nwfd-td-pop{transform-box:fill-box;transform-origin:center;animation:nwfd-tdk-pop 3.6s ease-in-out infinite;}'+
      '@keyframes nwfd-tdk-wipe{0%,12%{clip-path:inset(0 100% 0 0)}58%{clip-path:inset(0 0 0 0)}90%{clip-path:inset(0 0 0 0)}100%{clip-path:inset(0 100% 0 0)}}'+
      '.nwfd-td-fill{animation:nwfd-tdk-wipe 3.6s ease-in-out infinite;}'+
      '@keyframes nwfd-tdk-chipsel{0%,20%{stroke-opacity:0}30%,100%{stroke-opacity:1}}'+
      '.nwfd-td-chipsel{animation:nwfd-tdk-chipsel 3.6s ease-in-out infinite;}'+
      '@keyframes nwfd-tdk-rock{0%,100%{transform:rotate(-5deg)}50%{transform:rotate(5deg)}}'+
      '.nwfd-td-rock{transform-box:fill-box;transform-origin:150px 72px;animation:nwfd-tdk-rock 3.8s ease-in-out infinite;}'+
      '.nwfd-tour__dots{display:flex;gap:.34rem;margin:0 0 1rem;}'+
      '.nwfd-tour__dot{width:7px;height:7px;border-radius:50%;background:#e0ddd5;transition:background .2s;}'+
      '.nwfd-tour__dot.is-active{background:#1d1d1f;}'+
      '.nwfd-tour__row{display:flex;align-items:center;gap:.6rem;}'+
      '.nwfd-tour__skip{margin-right:auto;border:0;background:none;color:#9a9a9e;font-size:1.05rem;cursor:pointer;font-family:inherit;padding:.4rem 0;}'+
      '.nwfd-tour__skip:hover{color:#666;}'+
      '.nwfd-tour__back{border:1px solid #d4d4d8;background:#fff;color:#444;border-radius:999px;padding:.62rem 1.1rem;font-size:1.08rem;font-weight:600;cursor:pointer;font-family:inherit;}'+
      '.nwfd-tour__back:hover{border-color:#9a9a9e;}'+
      '.nwfd-tour__next{background:#1d1d1f;color:#fff;border:0;border-radius:999px;padding:.66rem 1.3rem;font-size:1.12rem;font-weight:600;cursor:pointer;font-family:inherit;}'+
      '.nwfd-tour__next:hover{background:#000;}'+
      // tvinga fram priskortet under rundturen så steget alltid har något att peka på
      'body.nwfd-tour-on #nwfd-floatprice{display:flex !important;opacity:1 !important;visibility:visible !important;}';
    var st=document.createElement('style'); st.id='nwfd-tour-css'; st.textContent=css; document.head.appendChild(st);
  }
  var TOUR_CUR='<path d="M0 0 L0 17 L4.2 13 L6.8 18.2 L9 17.2 L6.5 12.2 L11.6 12.2 Z" fill="#1d1d1f" stroke="#fff" stroke-width="1.1" stroke-linejoin="round"/>';
  // ren fiskbensyta (chevron) utan glipor – två halvor som möts i en mittfog
  function tourHerring(){
    var X0=44,X1=256,Y0=10,Y1=84,cx=150;
    var wcA='hsl(28,40%,66%)',wcB='hsl(26,33%,55%)',seam='hsl(24,42%,40%)';
    function half(clip,dir){
      var s='<g clip-path="url(#'+clip+')">', pw=12, idx=0;
      var kmin=(dir<0?X0+Y0:(X0-Y1))-60, kmax=(dir<0?cx+Y1:(X1-Y0))+60;
      for(var k=kmin;k<=kmax;k+=pw){ var col=(idx%2)?wcB:wcA; idx++;
        var x1=k-dir*Y0, x2=k-dir*Y1;
        s+='<line x1="'+x1+'" y1="'+Y0+'" x2="'+x2+'" y2="'+Y1+'" stroke="'+col+'" stroke-width="'+pw+'"/>';
        s+='<line x1="'+x1+'" y1="'+Y0+'" x2="'+x2+'" y2="'+Y1+'" stroke="'+seam+'" stroke-width="1" opacity=".5"/>';
      }
      return s+'</g>';
    }
    return '<rect x="'+X0+'" y="'+Y0+'" width="'+(X1-X0)+'" height="'+(Y1-Y0)+'" fill="'+wcA+'"/>'+
      half('nwfdHbL',-1)+half('nwfdHbR',1)+
      '<line x1="'+cx+'" y1="'+Y0+'" x2="'+cx+'" y2="'+Y1+'" stroke="'+seam+'" stroke-width="1.4" opacity=".6"/>';
  }
  var TOUR_STEPS=[
    { sel:'#nwfd-upload-top', title:'Ladda upp din planritning',
      body:'Börja här. Välj en bild på din planritning så får du en mall att rita ovanpå. Vill du rita utan bild? Hoppa bara vidare.',
      art:'<svg viewBox="0 0 300 132" xmlns="http://www.w3.org/2000/svg">'+
        '<rect x="100" y="14" width="100" height="86" rx="9" fill="#fff" stroke="#d8d3c8" stroke-width="2" stroke-dasharray="7 6"/>'+
        '<g class="nwfd-td-up"><rect x="114" y="30" width="72" height="54" rx="5" fill="#fff" stroke="#cfc9bd" stroke-width="2"/>'+
          '<rect x="122" y="38" width="26" height="18" fill="none" stroke="#b9b2a4" stroke-width="2"/>'+
          '<rect x="152" y="38" width="26" height="38" fill="none" stroke="#b9b2a4" stroke-width="2"/>'+
          '<rect x="122" y="60" width="26" height="16" fill="none" stroke="#b9b2a4" stroke-width="2"/></g>'+
        '<g class="nwfd-td-arrow"><circle cx="150" cy="110" r="14" fill="#1d1d1f"/>'+
          '<path d="M150 117 L150 104 M144 109 L150 103 L156 109" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></g></svg>' },
    { sel:'.nwfd-tool[data-tool="rect"]', title:'Rita rummet',
      body:'Klicka på <b>Rita rektangel</b> och dra sedan en ruta runt rummet på ritningen. Krokigt rum? Ta <b>Rita frihand</b> bredvid och klicka hörn för hörn.',
      art:'<svg viewBox="0 0 300 132" xmlns="http://www.w3.org/2000/svg">'+
        '<g opacity=".5"><rect x="30" y="14" width="240" height="104" rx="4" fill="none" stroke="#cdc7ba" stroke-width="2"/>'+
          '<path d="M150 14 L150 118 M30 66 L270 66" stroke="#ddd7ca" stroke-width="2"/></g>'+
        '<rect class="nwfd-td-room" x="64" y="30" width="140" height="66" rx="3" fill="rgba(160,120,80,.20)" stroke="#9a6b3f" stroke-width="2.5"/>'+
        '<g class="nwfd-td-cur nwfd-td-cur1">'+TOUR_CUR+'</g></svg>' },
    { sel:'.nwfd-tool[data-tool="cal"]', title:'Kalibrera måtten',
      body:'Det viktigaste steget. Klicka <b>Kalibrera skalan</b>, dra längs en vägg du vet längden på och skriv in måttet. Då blir alla mått och priser rätt.',
      art:'<svg viewBox="0 0 300 132" xmlns="http://www.w3.org/2000/svg">'+
        '<rect x="40" y="30" width="220" height="74" rx="4" fill="rgba(160,120,80,.10)" stroke="#cdc7ba" stroke-width="2"/>'+
        '<line class="nwfd-td-mline" x1="60" y1="86" x2="240" y2="86" stroke="#1d1d1f" stroke-width="3.5" stroke-linecap="round"/>'+
        '<circle cx="60" cy="86" r="4.5" fill="#1d1d1f"/>'+
        '<g class="nwfd-td-pop"><rect x="120" y="40" width="60" height="28" rx="7" fill="#1d1d1f"/>'+
          '<text x="150" y="59" text-anchor="middle" fill="#fff" font-size="16" font-weight="700" font-family="inherit">4 m</text></g>'+
        '<g class="nwfd-td-cur nwfd-td-cur2">'+TOUR_CUR+'</g></svg>' },
    { sel:'#nwfd-roompanel', title:'Välj stil för varje rum',
      body:'Dina rum listas här. Klicka på ett rum för att välja <b>mönster, storlek och sortering</b> – varje rum kan ha sin egen stil.',
      art:'<svg viewBox="0 0 300 132" xmlns="http://www.w3.org/2000/svg">'+
        '<defs><clipPath id="nwfdHbL"><rect x="44" y="10" width="106" height="74"/></clipPath>'+
        '<clipPath id="nwfdHbR"><rect x="150" y="10" width="106" height="74"/></clipPath>'+
        '<clipPath id="nwfdTdClip"><rect x="44" y="10" width="212" height="74" rx="6"/></clipPath></defs>'+
        '<g class="nwfd-td-fill" clip-path="url(#nwfdTdClip)">'+tourHerring()+'</g>'+
        '<rect x="44" y="10" width="212" height="74" rx="6" fill="none" stroke="#e0dbcf" stroke-width="1.5"/>'+
        '<g transform="translate(0,96)">'+
          '<rect x="36" y="0" width="64" height="26" rx="7" fill="#fff" stroke="#d8d3c8" stroke-width="2"/>'+
          '<rect class="nwfd-td-chipsel" x="36" y="0" width="64" height="26" rx="7" fill="none" stroke="#1d1d1f" stroke-width="2.5"/>'+
          '<text x="68" y="17" text-anchor="middle" font-size="12" font-weight="700" fill="#1d1d1f" font-family="inherit">SELECT</text>'+
          '<rect x="118" y="0" width="64" height="26" rx="7" fill="#fff" stroke="#d8d3c8" stroke-width="2"/>'+
          '<text x="150" y="17" text-anchor="middle" font-size="12" font-weight="700" fill="#8a8378" font-family="inherit">NATUR</text>'+
          '<rect x="200" y="0" width="64" height="26" rx="7" fill="#fff" stroke="#d8d3c8" stroke-width="2"/>'+
          '<text x="232" y="17" text-anchor="middle" font-size="12" font-weight="700" fill="#8a8378" font-family="inherit">RUSTIC</text></g></svg>' },
    { sel:'#nwfd-3d', title:'Se golvet i 3D',
      body:'Klicka <b>3D-vy</b> för att se ditt golv i 3D – dra med musen för att snurra runt rummet och känna hur mönstret ser ut på riktigt.',
      art:'<svg viewBox="0 0 300 132" xmlns="http://www.w3.org/2000/svg">'+
        '<ellipse cx="150" cy="74" rx="108" ry="50" fill="#000" opacity=".05"/>'+
        '<g class="nwfd-td-rock">'+
          '<polygon points="150,26 254,72 150,118 46,72" fill="hsl(27,34%,58%)" stroke="#7d5733" stroke-width="2.5" stroke-linejoin="round"/>'+
          '<g stroke="hsl(27,42%,45%)" stroke-width="2" opacity=".75">'+
            '<line x1="150" y1="26" x2="150" y2="118"/>'+
            '<line x1="98" y1="49" x2="202" y2="95"/><line x1="202" y1="49" x2="98" y2="95"/>'+
            '<line x1="124" y1="37" x2="176" y2="107"/><line x1="176" y1="37" x2="124" y2="107"/></g>'+
        '</g></svg>' },
    { sel:'#nwfd-floatprice', title:'Se priset & beställ',
      body:'Priset räknas ut automatiskt utifrån ytan. Klicka <b>Lägg i varukorgen</b> eller <b>Spara som PDF</b> när du är klar.',
      art:'<svg viewBox="0 0 300 132" xmlns="http://www.w3.org/2000/svg">'+
        '<g class="nwfd-td-up"><rect x="58" y="14" width="184" height="104" rx="12" fill="#fff" stroke="#e6e1d6" stroke-width="2"/>'+
          '<text x="150" y="40" text-anchor="middle" font-size="10" letter-spacing="1.4" font-weight="700" fill="#9a8f80" font-family="inherit">CA-PRIS FÖR DITT GOLV</text>'+
          '<text x="150" y="72" text-anchor="middle" font-size="25" font-weight="700" fill="#1d1d1f" font-family="inherit">122 784 kr</text>'+
          '<rect x="82" y="86" width="136" height="26" rx="13" fill="#1d1d1f"/>'+
          '<text x="150" y="103" text-anchor="middle" font-size="12" font-weight="600" fill="#fff" font-family="inherit">Lägg i varukorgen</text></g></svg>' },
    { sel:'#nwfd-guide', title:'Klart!',
      body:'Det var allt. Klicka <b>Guide</b> här uppe när du vill se rundturen igen. Lycka till med ditt golv!' }
  ];
  var tourRoot=null, tourIdx=0, tourRes=[], tourResize=null;
  function tourElVisible(el){
    if(!el) return false;
    var cs=window.getComputedStyle(el);
    if(cs.display==='none'||cs.visibility==='hidden'||parseFloat(cs.opacity||'1')===0) return false;
    var r=el.getBoundingClientRect();
    return r.width>4 && r.height>4 && r.left<window.innerWidth && r.top<window.innerHeight && r.right>0 && r.bottom>0;
  }
  function tourResolve(){
    tourRes=[];
    for(var i=0;i<TOUR_STEPS.length;i++){
      var el=document.querySelector(TOUR_STEPS[i].sel);
      if(tourElVisible(el)) tourRes.push({def:TOUR_STEPS[i], el:el});
    }
  }
  function closeTour(){
    if(!tourRoot) return;
    var t=tourRoot; tourRoot=null;
    if(tourResize){ window.removeEventListener('resize', tourResize); window.removeEventListener('scroll', tourResize, true); tourResize=null; }
    document.body.classList.remove('nwfd-tour-on');
    t.classList.remove('is-in');
    setTimeout(function(){ if(t&&t.parentNode) t.parentNode.removeChild(t); }, 200);
    try{ localStorage.setItem('nwfd_intro_seen','1'); }catch(e){}
  }
  function placeTour(){
    if(!tourRoot || !tourRes[tourIdx]) return;
    var el=tourRes[tourIdx].el, r=el.getBoundingClientRect(), pad=8;
    var hole=tourRoot.querySelector('.nwfd-tour__hole'), ring=tourRoot.querySelector('.nwfd-tour__ring'), tip=tourRoot.querySelector('.nwfd-tour__tip'), arrow=tourRoot.querySelector('.nwfd-tour__arrow');
    var hx=r.left-pad, hy=r.top-pad, hw=r.width+pad*2, hh=r.height+pad*2;
    hole.style.left=hx+'px'; hole.style.top=hy+'px'; hole.style.width=hw+'px'; hole.style.height=hh+'px';
    ring.style.left=hx+'px'; ring.style.top=hy+'px'; ring.style.width=hw+'px'; ring.style.height=hh+'px';
    var vw=window.innerWidth, vh=window.innerHeight, gap=16;
    var tw=tip.offsetWidth, th=tip.offsetHeight;
    var cx=r.left+r.width/2, cy=r.top+r.height/2;
    var place;
    if(r.left>=tw+gap+10) place='left';
    else if(vw-r.right>=tw+gap+10) place='right';
    else if(vh-r.bottom>=th+gap+10) place='bottom';
    else place='top';
    var top,left;
    if(place==='left'){ left=r.left-gap-tw; top=cy-th/2; }
    else if(place==='right'){ left=r.right+gap; top=cy-th/2; }
    else if(place==='top'){ top=r.top-gap-th; left=cx-tw/2; }
    else { top=r.bottom+gap; left=cx-tw/2; }
    left=Math.max(12, Math.min(left, vw-tw-12));
    top=Math.max(12, Math.min(top, vh-th-12));
    tip.style.left=left+'px'; tip.style.top=top+'px';
    arrow.style.cssText='position:absolute;width:15px;height:15px;background:#fff;transform:rotate(45deg);';
    if(place==='left'){ arrow.style.left=(tw-7)+'px'; arrow.style.top=Math.max(12,Math.min(cy-top-7,th-24))+'px'; }
    else if(place==='right'){ arrow.style.left='-7px'; arrow.style.top=Math.max(12,Math.min(cy-top-7,th-24))+'px'; }
    else if(place==='top'){ arrow.style.top=(th-7)+'px'; arrow.style.left=Math.max(12,Math.min(cx-left-7,tw-24))+'px'; }
    else { arrow.style.top='-7px'; arrow.style.left=Math.max(12,Math.min(cx-left-7,tw-24))+'px'; }
  }
  function renderTour(){
    if(!tourRoot) return;
    var n=tourRes.length, st=tourRes[tourIdx]; if(!st) return;
    var demo=tourRoot.querySelector('.nwfd-tour__demo');
    if(st.def.art){ demo.innerHTML=st.def.art; demo.style.display='block'; }
    else { demo.innerHTML=''; demo.style.display='none'; }
    tourRoot.querySelector('.nwfd-tour__kick').textContent='Steg '+(tourIdx+1)+' av '+n;
    tourRoot.querySelector('.nwfd-tour__title').textContent=st.def.title;
    tourRoot.querySelector('.nwfd-tour__body').innerHTML=st.def.body;
    var dotsWrap=tourRoot.querySelector('.nwfd-tour__dots'), dh='';
    for(var i=0;i<n;i++){ dh+='<span class="nwfd-tour__dot'+(i===tourIdx?' is-active':'')+'"></span>'; }
    dotsWrap.innerHTML=dh;
    var back=tourRoot.querySelector('.nwfd-tour__back'); back.style.display=(tourIdx===0?'none':'');
    tourRoot.querySelector('.nwfd-tour__next').textContent=(tourIdx===n-1?'Klar':'Nästa');
    // försök skrolla in målet (om appen någon gång inte är fullskärm)
    try{ tourRes[tourIdx].el.scrollIntoView({block:'nearest',inline:'nearest'}); }catch(e){}
    requestAnimationFrame(placeTour);
  }
  function openIntroGuide(){
    ensureTourCSS();
    if(tourRoot && tourRoot.parentNode){ closeTour(); }
    document.body.classList.add('nwfd-tour-on');
    tourResolve();
    if(!tourRes.length){ document.body.classList.remove('nwfd-tour-on'); return; }
    tourIdx=0;
    var ov=document.createElement('div'); ov.className='nwfd-tour';
    ov.innerHTML='<div class="nwfd-tour__hole"></div><div class="nwfd-tour__ring"></div>'+
      '<div class="nwfd-tour__tip" role="dialog" aria-modal="true" aria-label="Rundtur">'+
        '<span class="nwfd-tour__arrow"></span>'+
        '<div class="nwfd-tour__demo" style="display:none"></div>'+
        '<p class="nwfd-tour__kick"></p>'+
        '<h3 class="nwfd-tour__title"></h3>'+
        '<p class="nwfd-tour__body"></p>'+
        '<div class="nwfd-tour__dots"></div>'+
        '<div class="nwfd-tour__row">'+
          '<button type="button" class="nwfd-tour__skip">Hoppa över</button>'+
          '<button type="button" class="nwfd-tour__back">Tillbaka</button>'+
          '<button type="button" class="nwfd-tour__next">Nästa</button>'+
        '</div>'+
      '</div>';
    document.body.appendChild(ov); tourRoot=ov;
    ov.querySelector('.nwfd-tour__skip').addEventListener('click', closeTour);
    ov.querySelector('.nwfd-tour__back').addEventListener('click', function(){ if(tourIdx>0){ tourIdx--; renderTour(); } });
    ov.querySelector('.nwfd-tour__next').addEventListener('click', function(){ if(tourIdx<tourRes.length-1){ tourIdx++; renderTour(); } else { closeTour(); } });
    tourResize=function(){ placeTour(); };
    window.addEventListener('resize', tourResize);
    window.addEventListener('scroll', tourResize, true);
    document.addEventListener('keydown', function tesc(e){ if(!tourRoot){ document.removeEventListener('keydown',tesc); return; } if(e.key==='Escape'){ closeTour(); document.removeEventListener('keydown',tesc); } });
    renderTour();
    requestAnimationFrame(function(){ ov.classList.add('is-in'); });
  }

  // bild-/ikon-resurser (samma som vänsterpanelen) så popupen ser identisk ut
  var SORT_IMG={
    select:'https://cdn.shopify.com/s/files/1/0903/6762/3554/files/3_d2fa7517-d5fa-4c22-a970-65575768e72c.png',
    natur:'https://cdn.shopify.com/s/files/1/0903/6762/3554/files/2_92c5d59f-8a75-4d7d-8a08-51e61796ad73.png',
    rustic:'https://cdn.shopify.com/s/files/1/0903/6762/3554/files/1_911b337a-e3c6-4a2d-9a14-c8067c033030.png'
  };
  var PATTERN_SVG={
    fiskben:'<svg viewBox="0 0 48 28"><g fill="currentColor"><rect x="2" y="5.5" width="12" height="5" transform="rotate(45 8 8)"/><rect x="10" y="5.5" width="12" height="5" transform="rotate(-45 16 8)"/><rect x="18" y="5.5" width="12" height="5" transform="rotate(45 24 8)"/><rect x="26" y="5.5" width="12" height="5" transform="rotate(-45 32 8)"/><rect x="34" y="5.5" width="12" height="5" transform="rotate(45 40 8)"/><rect x="2" y="15.5" width="12" height="5" transform="rotate(45 8 18)"/><rect x="10" y="15.5" width="12" height="5" transform="rotate(-45 16 18)"/><rect x="18" y="15.5" width="12" height="5" transform="rotate(45 24 18)"/><rect x="26" y="15.5" width="12" height="5" transform="rotate(-45 32 18)"/><rect x="34" y="15.5" width="12" height="5" transform="rotate(45 40 18)"/></g></svg>',
    hollandsk:'<svg viewBox="0 0 48 28"><g fill="currentColor"><rect x="2" y="2" width="12" height="3"/><rect x="2" y="6.5" width="12" height="3"/><rect x="2" y="11" width="12" height="3"/><rect x="18" y="2" width="3" height="12"/><rect x="22.5" y="2" width="3" height="12"/><rect x="27" y="2" width="3" height="12"/><rect x="34" y="2" width="12" height="3"/><rect x="34" y="6.5" width="12" height="3"/><rect x="34" y="11" width="12" height="3"/><rect x="2" y="16" width="3" height="10"/><rect x="6.5" y="16" width="3" height="10"/><rect x="11" y="16" width="3" height="10"/><rect x="18" y="16" width="12" height="3"/><rect x="18" y="20.5" width="12" height="3"/><rect x="18" y="25" width="12" height="3"/><rect x="34" y="16" width="3" height="10"/><rect x="38.5" y="16" width="3" height="10"/><rect x="43" y="16" width="3" height="10"/></g></svg>',
    rak:'<svg viewBox="0 0 48 28"><g fill="currentColor"><rect x="0" y="2" width="21" height="5"/><rect x="23" y="2" width="21" height="5"/><rect x="46" y="2" width="2" height="5"/><rect x="0" y="9" width="10" height="5"/><rect x="12" y="9" width="21" height="5"/><rect x="35" y="9" width="13" height="5"/><rect x="0" y="16" width="21" height="5"/><rect x="23" y="16" width="21" height="5"/><rect x="46" y="16" width="2" height="5"/><rect x="0" y="23" width="10" height="5"/><rect x="12" y="23" width="21" height="5"/><rect x="35" y="23" width="13" height="5"/></g></svg>'
  };
  function sortMinKm2(sk){ var m=Infinity; VARIANTS[sk].forEach(function(v){ var k=v.price/v.m2; if(k<m) m=k; }); return Math.round(m); }
  // visuell stavmått-väljare (samma som buildDims) – bunden till en lokal arbetskopia
  function buildModalDimPicker(box, getSort, getIdx, onPick){
    var order=[5,4,3,2,-1,0,1];
    function render(){
      var sort=getSort(), sel=getIdx();
      box.innerHTML='';
      var row=document.createElement('div'); row.className='nwfd-planks';
      order.forEach(function(idx){
        if(idx<0){ var sep=document.createElement('span'); sep.className='nwfd-planksep'; row.appendChild(sep); return; }
        var v=VARIANTS[sort][idx], g=DIMS[idx];
        var b=document.createElement('button'); b.type='button'; b.className='nwfd-plank'+(sel===idx?' is-active':'');
        if((box.getAttribute('data-rec')==='1') && (idx===4||idx===5)) b.className+=' is-rec';
        b.style.height=Math.round(46+(g.l/408)*70)+'px'; b.style.width=(g.w===68?48:38)+'px';
        b.innerHTML='<span>'+g.w+'×'+g.l+'</span>';
        b.setAttribute('data-tip', v.t+' mm · '+fmt(v.price)+' kr/paket · '+fmt(Math.round(v.price/v.m2))+' kr/m²');
        b.addEventListener('click', function(){ onPick(idx); render(); });
        row.appendChild(b);
      });
      box.appendChild(row);
      var v2=VARIANTS[sort][sel]||VARIANTS[sort][0];
      var info=document.createElement('div'); info.className='nwfd-plankinfo';
      info.textContent=v2.t+' mm · '+fmt(v2.price)+' kr/paket · '+fmt(v2.m2,2)+' m²/paket · '+fmt(Math.round(v2.price/v2.m2))+' kr/m²';
      box.appendChild(info);
    }
    render();
    return render;
  }

  // Steg-för-steg-guide när ett rum sätts upp – samma bilder & kontroller som vänsterpanelen
  function openRoomModal(rm, isNew){
    if(!rm) return;
    var st=rstyle(rm);
    var w={ name:rm.name, sort:st.sort, pattern:st.pattern, rotation:st.rotation,
            dimFloor:st.dimFloor, dimFris:st.dimFris, dimLb:st.dimLb,
            fris:!!st.fris, lopband:!!(st.fris&&st.lopband) };
    var STEPS=['Namn & mönster','Storlek','Fris & listband','Sortering'];
    var cur=0;
    var html=
      '<p class="nwfd-m-kicker">'+(isNew?'Nytt rum':'Rummets golv')+'</p>'+
      '<h3 class="nwfd-m-title" id="nwfd-m-steptitle"></h3>'+
      '<div class="nwfd-m-prog" id="nwfd-m-prog"></div>'+
      '<div id="nwfd-m-stepbody"></div>'+
      '<div class="nwfd-m-actions">'+
        '<button type="button" class="nwfd-m-skip" id="nwfd-m-back" style="display:none">Tillbaka</button>'+
        '<button type="button" class="nwfd-m-skip" id="nwfd-m-skip">'+(isNew?'Hoppa över':'Avbryt')+'</button>'+
        '<button type="button" class="nwfd-m-save" id="nwfd-m-next">Nästa</button>'+
      '</div>';
    var ov=buildModal(html);
    var body=ov.querySelector('#nwfd-m-stepbody');
    var titleEl=ov.querySelector('#nwfd-m-steptitle');
    var progEl=ov.querySelector('#nwfd-m-prog');
    var backB=ov.querySelector('#nwfd-m-back');
    var nextB=ov.querySelector('#nwfd-m-next');
    ov.querySelector('#nwfd-m-skip').addEventListener('click', closeModal);
    backB.addEventListener('click', function(){ if(cur>0){ cur--; renderStep(); } });
    nextB.addEventListener('click', function(){
      if(cur<STEPS.length-1){ cur++; renderStep(); return; }
      if((w.name||'').trim()) rm.name=w.name.trim();
      rm.sort=w.sort; rm.pattern=w.pattern; rm.rotation=w.rotation;
      rm.dimFloor=w.dimFloor; rm.dimFris=w.dimFris; rm.dimLb=w.dimLb;
      rm.fris=w.fris; rm.lopband=w.fris && w.lopband;
      ['sort','pattern','rotation','dimFloor','dimFris','dimLb','fris','lopband'].forEach(function(k){ state[k]=rm[k]; });
      closeModal(); buildDims(); refresh(); syncScopeUI();
    });

    function renderProg(){
      progEl.innerHTML='';
      for(var i=0;i<STEPS.length;i++){ var d=document.createElement('span'); d.className='nwfd-m-dot'+(i===cur?' is-active':(i<cur?' is-done':'')); progEl.appendChild(d); }
    }
    function el(tag,cls,txt){ var e=document.createElement(tag); if(cls) e.className=cls; if(txt!=null) e.textContent=txt; return e; }

    function help(htmlStr){ var p=el('p','nwfd-m-help'); p.innerHTML=htmlStr; body.appendChild(p); }
    function stepNameMonster(){
      help('Ge rummet ett namn och välj <b>läggningsmönster</b>. Fiskben är det klassiska sicksack-mönstret, holländskt är block som växlar riktning, rak är raka rader med förskjutna skarvar.');
      body.appendChild(el('label','nwfd-m-lab','Rummets namn'));
      var inp=el('input','nwfd-m-input'); inp.value=w.name||''; inp.placeholder='t.ex. Vardagsrum';
      inp.addEventListener('input', function(){ w.name=inp.value; });
      body.appendChild(inp);
      body.appendChild(el('label','nwfd-m-lab','Mönster'));
      var grid=el('div','nwfd-patterns');
      [['fiskben','Fiskben'],['hollandsk','Holländsk'],['rak','Rak läggning']].forEach(function(pp){
        var b=el('button','nwfd-pattern'+(w.pattern===pp[0]?' is-active':'')); b.type='button'; b.setAttribute('data-pattern',pp[0]);
        b.innerHTML=PATTERN_SVG[pp[0]]+pp[1];
        b.addEventListener('click', function(){
          w.pattern=pp[0]; w.rotation=(pp[0]==='fiskben'?45:0);
          [].slice.call(grid.children).forEach(function(x){ x.classList.toggle('is-active', x===b); });
        });
        grid.appendChild(b);
      });
      body.appendChild(grid);
      help('Tips: riktningen på mönstret justerar du sen direkt på ritningen med reglaget när du är i läget <b>Redigera</b>.');
      setTimeout(function(){ inp.focus(); inp.select(); }, 60);
    }
    function stepSize(){
      help('Välj <b>stavmått</b> för golvet. Längre stavar ger färre skarvar och ett lugnare uttryck. Priset nedan visas för vald sortering – sorteringen väljer du i sista steget.');
      body.appendChild(el('label','nwfd-m-lab','Storlek – stavmått golv'));
      var box=el('div',null);
      body.appendChild(box);
      buildModalDimPicker(box, function(){return w.sort;}, function(){return w.dimFloor;}, function(idx){ w.dimFloor=idx; });
    }
    function stepFris(){
      help('En <b>fris</b> är en ram av stavar längs väggarna som ramar in golvet snyggt. Ett <b>listband</b> är en smal mörkare rand innanför frisen. Båda är valfria.');
      var c1=el('div','nwfd-m-checks');
      c1.innerHTML='<label class="nwfd-m-check"><input type="checkbox" id="nwfd-mw-fris"'+(w.fris?' checked':'')+'><span>Fris (ram runt golvet)</span></label>';
      body.appendChild(c1);
      var frisWrap=el('div',null); body.appendChild(frisWrap);
      var c2=el('div','nwfd-m-checks');
      c2.innerHTML='<label class="nwfd-m-check"><input type="checkbox" id="nwfd-mw-lop"'+((w.fris&&w.lopband)?' checked':'')+(w.fris?'':' disabled')+'><span>Listband (smal rand innanför frisen)</span></label>';
      body.appendChild(c2);
      var lopWrap=el('div',null); body.appendChild(lopWrap);
      var frisCb=c1.querySelector('#nwfd-mw-fris'), lopCb=c2.querySelector('#nwfd-mw-lop');
      function renderPicks(){
        frisWrap.innerHTML=''; lopWrap.innerHTML='';
        if(w.fris){
          frisWrap.appendChild(el('label','nwfd-m-lab','Stavmått · fris'));
          var p1=el('div',null); p1.setAttribute('data-rec','1'); frisWrap.appendChild(p1);
          buildModalDimPicker(p1, function(){return w.sort;}, function(){return w.dimFris;}, function(idx){ w.dimFris=idx; });
        }
        if(w.fris && w.lopband){
          lopWrap.appendChild(el('label','nwfd-m-lab','Stavmått · listband'));
          var p2=el('div',null); lopWrap.appendChild(p2);
          buildModalDimPicker(p2, function(){return w.sort;}, function(){return w.dimLb;}, function(idx){ w.dimLb=idx; });
        }
      }
      frisCb.addEventListener('change', function(){ w.fris=frisCb.checked; if(!w.fris){ w.lopband=false; lopCb.checked=false; } lopCb.disabled=!w.fris; renderPicks(); });
      lopCb.addEventListener('change', function(){ w.lopband=lopCb.checked; renderPicks(); });
      renderPicks();
    }
    function stepSort(){
      help('Sist väljer du träets <b>karaktär</b>. Valet styr både utseendet och priset – se skillnaden under varje alternativ.');
      body.appendChild(el('label','nwfd-m-lab','Sortering'));
      var SORT_DESC={ select:'Lugnast uttryck, minimal kvist – vår mest exklusiva.', natur:'Naturliga kvistar och varierat färgspel.', rustic:'Mest karaktär – tydliga kvistar och stora färgskillnader.' };
      var grid=el('div','nwfd-sorts');
      ['select','natur','rustic'].forEach(function(sk){
        var b=el('button','nwfd-sort'+(w.sort===sk?' is-active':'')); b.type='button'; b.setAttribute('data-sort',sk);
        b.innerHTML='<span class="nwfd-sort-img" style="background-image:url('+SORT_IMG[sk]+')"></span><span>'+SORT_LABEL[sk]+'<em class="nwfd-sort-price">fr. '+fmt(sortMinKm2(sk))+' kr/m²</em><small class="nwfd-sort-desc">'+SORT_DESC[sk]+'</small></span>';
        b.addEventListener('click', function(){ w.sort=sk; [].slice.call(grid.children).forEach(function(x){ x.classList.toggle('is-active', x===b); }); });
        grid.appendChild(b);
      });
      body.appendChild(grid);
    }

    function renderStep(){
      titleEl.textContent='Steg '+(cur+1)+' av '+STEPS.length+' · '+STEPS[cur];
      renderProg();
      backB.style.display=cur>0?'':'none';
      nextB.textContent=(cur===STEPS.length-1)?'Spara rummet':'Nästa';
      body.innerHTML='';
      [stepNameMonster, stepSize, stepFris, stepSort][cur]();
    }
    renderStep();
  }

  function openRenameModal(rm){
    if(!rm) return;
    var html='<p class="nwfd-m-kicker">Rum</p><h3 class="nwfd-m-title">Byt namn på rummet</h3>'+
      '<input type="text" class="nwfd-m-input" id="nwfd-m-rn" value="'+escapeHtml(rm.name)+'" placeholder="t.ex. Hall">'+
      '<div class="nwfd-m-actions"><button type="button" class="nwfd-m-skip" id="nwfd-m-skip">Avbryt</button><button type="button" class="nwfd-m-save" id="nwfd-m-save">Spara</button></div>';
    var ov=buildModal(html);
    ov.querySelector('#nwfd-m-skip').addEventListener('click', closeModal);
    function ok(){ var nm=(ov.querySelector('#nwfd-m-rn').value||'').trim(); if(nm){ rm.name=nm; refresh(); syncScopeUI(); } closeModal(); }
    ov.querySelector('#nwfd-m-save').addEventListener('click', ok);
    var inp=ov.querySelector('#nwfd-m-rn');
    inp.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); ok(); } });
    setTimeout(function(){ inp.focus(); inp.select(); }, 70);
  }

  function openPromptModal(opts){
    opts=opts||{};
    var html='<p class="nwfd-m-kicker">'+escapeHtml(opts.kicker||'')+'</p>'+
      '<h3 class="nwfd-m-title">'+escapeHtml(opts.title||'')+'</h3>'+
      (opts.label?'<p class="nwfd-m-body">'+escapeHtml(opts.label)+'</p>':'')+
      '<input type="text" inputmode="decimal" class="nwfd-m-input" id="nwfd-m-val" value="'+escapeHtml(opts.value||'')+'" placeholder="'+escapeHtml(opts.placeholder||'')+'">'+
      '<div class="nwfd-m-actions"><button type="button" class="nwfd-m-skip" id="nwfd-m-skip">Avbryt</button><button type="button" class="nwfd-m-save" id="nwfd-m-save">'+escapeHtml(opts.ok||'OK')+'</button></div>';
    var ov=buildModal(html);
    var done=false;
    function cancel(){ if(done) return; done=true; closeModal(); if(opts.onCancel) opts.onCancel(); }
    function ok(){ if(done) return; done=true; var v=ov.querySelector('#nwfd-m-val').value; closeModal(); if(opts.cb) opts.cb(v); }
    ov.querySelector('#nwfd-m-skip').addEventListener('click', cancel);
    ov.querySelector('#nwfd-m-save').addEventListener('click', ok);
    ov.addEventListener('click', function(e){ if(e.target===ov) cancel(); });
    var inp=ov.querySelector('#nwfd-m-val');
    inp.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); ok(); } });
    setTimeout(function(){ inp.focus(); inp.select(); }, 70);
  }

  function openConfirm(opts){
    opts=opts||{};
    var html='<p class="nwfd-m-kicker">'+escapeHtml(opts.kicker||'')+'</p>'+
      '<h3 class="nwfd-m-title">'+escapeHtml(opts.title||'')+'</h3>'+
      (opts.body?'<p class="nwfd-m-body">'+escapeHtml(opts.body)+'</p>':'')+
      '<div class="nwfd-m-actions"><button type="button" class="nwfd-m-skip" id="nwfd-m-skip">'+escapeHtml(opts.cancel||'Avbryt')+'</button>'+
      '<button type="button" class="nwfd-m-save'+(opts.danger===false?'':' nwfd-m-danger')+'" id="nwfd-m-save">'+escapeHtml(opts.ok||'Ja')+'</button></div>';
    var ov=buildModal(html);
    ov.querySelector('#nwfd-m-skip').addEventListener('click', closeModal);
    ov.querySelector('#nwfd-m-save').addEventListener('click', function(){ closeModal(); if(opts.cb) opts.cb(); });
  }

  /* ===== In-app-popups (knappraden Ritning · Rum · Golv & stil · Pris) ===== */
  function openRitningModal(){
    var calOn=!!state.calMperPx;
    var html=
      '<p class="nwfd-m-kicker">Planritning</p><h3 class="nwfd-m-title">Ritning & skala</h3>'+
      '<p class="nwfd-m-help">Ladda upp en bild på din planritning (den stannar i din webbläsare) eller rita direkt på rutnätet. Kalibrera skalan för att få mått och m².</p>'+
      '<div class="nwfd-m-stack">'+
        '<button type="button" class="nwfd-m-save nwfd-m-wide" id="nwfd-mr-upload">⬆ Ladda upp ritning</button>'+
        '<button type="button" class="nwfd-m-save nwfd-m-ghost nwfd-m-wide" id="nwfd-mr-demo">▶ Testa med ett exempel</button>'+
        '<button type="button" class="nwfd-m-save nwfd-m-wide" id="nwfd-mr-cal">⊾ '+(calOn?'Kalibrera om':'Kalibrera skalan')+'</button>'+
      '</div>'+
      '<p class="nwfd-m-help" style="margin-top:1rem">'+(calOn?'Skala kalibrerad ✓ – du kan kalibrera om när du vill.':'<b>Utan kalibrering visas inga mått.</b> Rita en linje längs en vägg du vet längden på.')+'</p>'+
      '<div class="nwfd-m-actions"><button type="button" class="nwfd-m-save nwfd-m-wide" id="nwfd-m-done">Klar</button></div>';
    var ov=buildModal(html);
    ov.querySelector('#nwfd-mr-upload').addEventListener('click', function(){ var f=$('nwfd-file'); if(f) f.click(); });
    ov.querySelector('#nwfd-mr-demo').addEventListener('click', function(){ closeModal(); loadDemo(); });
    ov.querySelector('#nwfd-mr-cal').addEventListener('click', function(){ closeModal(); setTool('cal'); hint(); });
    ov.querySelector('#nwfd-m-done').addEventListener('click', closeModal);
  }

  function openRoomsModal(){
    var sc=scaleMperPx();
    var rowsHtml=state.rooms.map(function(rm,i){
      var m2 = rm.closed ? (sc? fmt(polyAreaPx(rm.points)*sc*sc,1)+' m²' : '–') : 'ritar…';
      return '<button type="button" class="nwfd-mroom" data-i="'+i+'"><span class="nwfd-mroom-name">'+escapeHtml(rm.name)+'</span><span class="nwfd-mroom-m2">'+m2+'</span>'+(rm.closed?'<span class="nwfd-mroom-edit">Redigera ›</span>':'')+'</button>';
    }).join('');
    var anyClosed=state.rooms.some(function(r){return r.closed;});
    var html=
      '<p class="nwfd-m-kicker">Rum</p><h3 class="nwfd-m-title">Dina rum</h3>'+
      '<p class="nwfd-m-help">Klicka på ett rum för att redigera namn, mönster, storlek och sortering. Rita nya rum direkt på ritytan.</p>'+
      '<div class="nwfd-mrooms">'+(anyClosed?rowsHtml:'<p class="nwfd-m-help">Inga färdiga rum än – rita ditt första rum på ritytan.</p>')+'</div>'+
      '<div class="nwfd-m-actions"><button type="button" class="nwfd-m-skip" id="nwfd-m-done">Stäng</button><button type="button" class="nwfd-m-save" id="nwfd-mr-add">+ Rita nytt rum</button></div>';
    var ov=buildModal(html);
    [].slice.call(ov.querySelectorAll('.nwfd-mroom')).forEach(function(b){
      b.addEventListener('click', function(){
        var i=parseInt(b.getAttribute('data-i'),10); var rm=state.rooms[i]; if(!rm) return;
        state.active=i;
        if(rm.closed){ openRoomModal(rm,false); } else { closeModal(); draw(); roomsUI(); }
      });
    });
    ov.querySelector('#nwfd-m-done').addEventListener('click', closeModal);
    ov.querySelector('#nwfd-mr-add').addEventListener('click', function(){ closeModal(); setTool('rect'); hint(); });
  }

  function openStilFromBar(){
    var rm=room();
    if(rm && rm.closed){ openRoomModal(rm,false); return; }
    var closed=state.rooms.filter(function(r){return r.closed;});
    if(closed.length){ state.active=state.rooms.indexOf(closed[0]); openRoomModal(closed[0],false); return; }
    openConfirm({ kicker:'Golv & stil', title:'Rita ett rum först', body:'Rita minst ett rum på ritytan – sen kan du välja sortering, mönster, storlek och fris för det.', ok:'Okej', cancel:'Stäng', danger:false, cb:function(){ setTool('rect'); hint(); } });
  }

  function openPrisModal(){
    var d=null; try{ d=calcData(); }catch(eP){}
    var inner;
    if(!d){
      inner='<p class="nwfd-m-help">Inget pris än. Rita minst ett rum och <b>kalibrera skalan</b>, så räknar vi ut yta, antal paket och pris automatiskt.</p>';
    } else {
      var roomRows=d.rooms.map(function(r){ return '<div class="nwfd-mp-row"><span>'+escapeHtml(r.name)+(d.sorts.length>1?(' · '+(SORT_LABEL[r.sort]||'')):'')+'</span><strong>'+fmt(r.m2,1)+' m²</strong></div>'; }).join('');
      var partRows=d.parts.map(function(pt){ return '<div class="nwfd-mp-row"><span>'+pt.label+(d.sorts.length>1?(' · '+SORT_LABEL[pt.sort]):'')+' · '+pt.v.t+'</span><strong>'+fmt(pt.need,1)+' m² · '+pt.pkt+' pkt</strong></div>'; }).join('');
      var sp=(typeof state.spill==='number')?state.spill:0.10;
      var spillBtns=[0.05,0.10,0.15].map(function(v){ return '<button type="button" class="nwfd-mp-spill'+(Math.abs(sp-v)<0.001?' is-active':'')+'" data-v="'+v+'">'+Math.round(v*100)+' %</button>'; }).join('');
      inner=
        '<div class="nwfd-mp-total"><span class="nwfd-m-kicker">Ca-pris för hela golvet</span><strong class="nwfd-mp-price">'+fmt(d.price)+' kr</strong>'+
        '<span class="nwfd-mp-sub">'+(d.rooms.length>1?(d.rooms.length+' rum · '):'')+fmt(d.need,1)+' m² (inkl spill) · '+d.pktTotal+' paket · '+d.sortLabel+'</span></div>'+
        '<div class="nwfd-mp-rows">'+roomRows+'<div class="nwfd-mp-sep"></div>'+partRows+'</div>'+
        '<div class="nwfd-mp-spillrow"><span>Spillmarginal</span><div class="nwfd-mp-spills">'+spillBtns+'</div></div>'+
        '<div class="nwfd-m-stack" style="margin-top:.6rem">'+
          '<button type="button" class="nwfd-m-save nwfd-m-wide" id="nwfd-mp-cart">Lägg i varukorgen</button>'+
          '<button type="button" class="nwfd-m-save nwfd-m-ghost nwfd-m-wide" id="nwfd-mp-pdf">Spara golvplan som PDF</button>'+
        '</div>';
    }
    var html='<p class="nwfd-m-kicker">Pris & beställning</p><h3 class="nwfd-m-title">Pris & beställning</h3>'+inner+
      '<div class="nwfd-m-actions"><button type="button" class="nwfd-m-skip nwfd-m-wide" id="nwfd-m-done">Stäng</button></div>';
    var ov=buildModal(html);
    ov.querySelector('#nwfd-m-done').addEventListener('click', closeModal);
    var cartB=ov.querySelector('#nwfd-mp-cart'); if(cartB) cartB.addEventListener('click', function(){ addToCart(); });
    var pdfB=ov.querySelector('#nwfd-mp-pdf'); if(pdfB) pdfB.addEventListener('click', function(){ closeModal(); exportPDF(); });
    [].slice.call(ov.querySelectorAll('.nwfd-mp-spill')).forEach(function(b){ b.addEventListener('click', function(){ state.spill=parseFloat(b.getAttribute('data-v')); refresh(); openPrisModal(); }); });
  }

  /* ============ PERSISTENCE ============ */
  function save(){
    histSnap();
    try{
      localStorage.setItem('nwfd_v4', JSON.stringify({
        rooms:state.rooms, sort:state.sort, pattern:state.pattern, plankW:state.plankW,
        rotation:state.rotation, fris:state.fris, lopband:state.lopband, dimFloor:state.dimFloor, dimFris:state.dimFris, dimLb:state.dimLb, wallM:state.wallM, imgRect:state.imgRect, spill:state.spill, calMperPx:state.calMperPx, calLine:state.calLine
      }));
    }catch(e){}
  }
  function restore(){
    var d=null, fromShare=false;
    try{
      if(location.hash && location.hash.indexOf('#d=')===0){
        var code=location.hash.slice(3).replace(/-/g,'+').replace(/_/g,'/');
        while(code.length%4) code+='=';
        d=JSON.parse(decodeURIComponent(escape(atob(code))));
        track('golvdesigner_open_shared');
        fromShare=true;
      }
    }catch(eH){ d=null; }
    try{
      if(!d) d=JSON.parse(localStorage.getItem('nwfd_v4')||'null');
      if(!d) return;
      if(d.rooms&&d.rooms.length) { state.rooms=d.rooms; state.active=0; state.rooms.forEach(function(rr){ rr.openings=[]; }); }
      ['sort','pattern','plankW','rotation','fris','lopband','dimFloor','dimFris','dimLb','wallM','imgRect','spill','calMperPx','calLine'].forEach(function(k){ if(d[k]!==undefined&&d[k]!==null) state[k]=d[k]; });
      // backfilla per-rum stil för gamla designer som sparades globalt (rstyle fyller från state-templatet)
      state.rooms.forEach(function(rr){ rstyle(rr); });
      // sync controls (utgår från aktivt rum via syncScopeUI/buildDims)
      if(state.wallM) $('nwfd-wall').value=String(state.wallM).replace('.',',');
      document.querySelectorAll('.nwfd-spill').forEach(function(b){ b.classList.toggle('is-active', parseFloat(b.getAttribute('data-spill'))===state.spill); });
      buildDims();
      syncScopeUI();
    }catch(e){}
    try{
      var di=localStorage.getItem('nwfd_img');
      if(di){ var im=new Image(); im.onload=function(){ state.img=im; draw(); }; im.src=di; }
      else if(fromShare){ var shH=$('nwfd-sharedhint'); if(shH) shH.style.display='block'; }
    }catch(e3){}
  }

  /* ============ LEAD ============ */
  function onSend(e){
    e.preventDefault();
    var email=$('nwfd-email').value.trim();
    if(!email){ $('nwfd-email').focus(); return; }
    var name=$('nwfd-name').value.trim();
    var msg=$('nwfd-msg').value.trim();
    var d=calcData();
    var roomsTxt = d ? d.rooms.map(function(r){return r.name+': '+fmt(r.m2,1)+' m²'+(d.sorts.length>1?(' ('+(SORT_LABEL[r.sort]||'')+')'):'');}).join(' · ') : 'ej uppmätt';
    var partsTxt = d ? d.parts.map(function(pt){return pt.label+' '+(SORT_LABEL[pt.sort]||'')+' '+pt.v.t+': '+fmt(pt.need,1)+' m² ('+pt.pkt+' pkt)';}).join(' · ') : '';
    var patsS={}; state.rooms.forEach(function(r){ if(r.closed) patsS[rstyle(r).pattern]=1; });
    var patTxtS=Object.keys(patsS).map(function(p){return PATTERN_LABEL[p]||'Fiskben';}).join(' / ')||'Fiskben';
    var dlink='';
    try{
      var oS={rooms:state.rooms, sort:state.sort, pattern:state.pattern, rotation:state.rotation, fris:state.fris, lopband:state.lopband, dimFloor:state.dimFloor, dimFris:state.dimFris, dimLb:state.dimLb, wallM:state.wallM, imgRect:state.imgRect, spill:state.spill};
      dlink=location.origin+location.pathname+'#d='+btoa(unescape(encodeURIComponent(JSON.stringify(oS)))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
    }catch(eL){}
    var summary='GOLVDESIGNER-FÖRFRÅGAN\n'+
      'Sortering: '+(d?d.sortLabel:SORT_LABEL[state.sort])+'\n'+
      'Mönster: '+patTxtS+'\n'+
      'Rum: '+roomsTxt+'\n'+
      (partsTxt?('Material: '+partsTxt+'\n'):'')+
      (d?('Totalt: '+fmt(d.need,1)+' m² · '+d.pktTotal+' paket · ca '+fmt(d.price)+' kr (spill '+Math.round(((typeof state.spill==='number')?state.spill:0.10)*100)+'%)\n'):'')+
      'Planritning uppladdad: '+(state.img?'Ja (be kunden mejla den)':'Nej')+'\n'+
      (dlink?('Designlänk: '+dlink+'\n'):'')+
      (msg?('Meddelande: '+msg):'');
    var fd=new FormData();
    fd.append('form_type','contact');
    fd.append('utf8','✓');
    fd.append('contact[email]',email);
    fd.append('contact[Namn]',name);
    fd.append('contact[Ämne]','Golvdesigner – offertförfrågan');
    fd.append('contact[body]',summary);
    var btn=$('nwfd-send');
    btn.disabled=true; btn.textContent='Skickar…';
    fetch('/contact',{method:'POST',body:fd})
      .then(function(){ track('golvdesigner_offert'); $('nwfd-form').style.display='none'; $('nwfd-thanks').style.display='block'; })
      .catch(function(){ btn.disabled=false; btn.textContent='Skicka förfrågan'; alert('Något gick fel – ring oss på 073-985 84 46.'); });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
